<template>
    <div class="app has-header">
        <div class="header main">
            <div class="align-left">
                <dateselectionheader :label="monthDisplay" @PrevDate="PreviousDate" @NextDate="NextDate" @CalendarOpen="toggleDatePicker" @SetToday="SetDateToCurrentDay" />
            </div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
                <headerbuttonstack :state="sideButtons"/>
            </div>
        </div>


        <div class="tablecontainer scrollbar-container">
            <div style="margin-bottom: 70px;" v-if="!loading && !useSimpleView">
                <datatable :state="dataTableState" />
            </div>
            <div v-if="!loading && useSimpleView">
                <datatablesimple :state="dataTableSimpleState"
                                 :collapsedStateProp="dataTableCollapsedState"
                                 @collapsedStatesChanged="dataTableCollapsedState = $event"></datatablesimple>
            </div>
        </div>
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="loadingText && (loadingText + '').length > 0" class="loading-text">
                {{ loadingText }}
            </div>
        </div>


        <sidebar :tabs="sideMenuState" v-if="!loading && canEditBalances"></sidebar>
    </div>
</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import datatablesimple from '../uicomponents/datatablesimple.vue';
import VueEventBus from '../../vue-event-bus';
import {mapState, mapGetters} from 'vuex';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Papa from 'papaparse';
export default {
    name: 'employeepayrollaccounting',
    components: {
        datatable,
        datatablesimple,
    },
    data() {
        return {
            loadingText: this.$t('workBalance.payroll.loadingMonthlyData'),
            dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ().hours(0).minutes(0),
            timeFrameStart: this.$helpers.getMomentTZ().hours(0).minutes(0), //this.$helpers.getMomentTZ().date(14).hours(0).minutes(0), //changing .date here for debugging for now
            timeFrameLength: 24 * 60 * 60 * 1000,
            currentYear: this.$helpers.getCurrentMonthMomentTZ().year(),
            currentMonth: this.$helpers.getCurrentMonthMomentTZ().month(),
            currentDate: 1,
            employeeMap: {},
            workBalanceMap: {},
            confirmationCheckedAndPossible: false,
            employeeNextValidDateMap: {},
            earliestUnconfirmedMap: {},
            mzConfirmed: false,
            validEmployeeMap: {},
            employeeOptions: [],
            previousMonthWorkBalanceMap: {},
            latestEmployeeAccPeriodMap: {},
            actualShiftMap: {},
            actualBreakMap: {},
            employeePlanShiftMap: {},
            employeePreferenceMap: {},
            employeeContractMap: {},
            nextMonthEmployeeContractMap: {},
            multiCreateMap: {},
            holidayMap: {},
            currentrow: {},
            balanceerror: false,
            readyFlag: false,
            creationMode: 0,
            sortByName: true,
            filterDropdownOptions: [],

            tableDetailState: 0, //1 worketime, 2 vacation, 3 holiday, 4 nightwork, 5 overtime, 6 moretime, 7 bonustime
            workTimeDetail: false,
            holidayDetail: false,
            nightWorkDetail: false,
            overTimeDetail: false,
            vacationDetail: false,
            moreTimeDetail: false,
            bonusTimeDetail: false,
            useSimpleView: true,
            loading: false,

            dataTableCollapsedState: {},
        }
    },
    created: function () {
        this.$helpers.GetStoreSettings();
        //Setting the Date will trigger refresh so need to trigger refresh here manually
        if (this.rosterFromTo != null) {
            let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
            this.setDateSelection(startDate);
        } else {
            this.setDateSelection(this.$helpers.getCurrentMonthMomentTZ());
        }
    },
    computed: {
        ...mapGetters(['userInfo', 'storeId', 'storeSettings', 'rosterFromTo', 'isSuperUser','employeeWorkbalanceMap',
            'allowedContractMap', 'collectiveContractMap', 'spotMap', 'accountingPeriodSettingsMap',
            'contractExitSettingMap', 'uiDataMap',
            'imgCacheTimestamp', 'permissions',
            'bonusPaymentSettingsMap', 'exportSettingsMap',
            'employmentModelMap', 'employeeEmploymentModelMap',
            'employeeAvgWorktimeMap']),
        exitReasonReverseIdMap() {
            let map = {};
            this.uiDataMap.exitReasons.forEach(item => {
                if(item.idL != null){
                    map[""+item.idL] = item.id;
                }
            });
            return map;
        },
        canEditBalances() {
            let val = false;
            Object.values(this.permissions).forEach(perms => {
                let perm = perms.find(p => p.id == 70);
                if(perm && perm.level > 2) { //permission to edit balance fields
                    val = true;
                }
            });
            return val;
        },
        canOpenAndEditBalances() {
            let val1 = false;
            let val2 = false;
            Object.values(this.permissions).forEach(perms => {
                let perm = perms.find(p => p.id == 70);
                if(perm && perm.level > 2) { //permission to edit balance fields
                    val1 = true;
                }
                let perm2 = perms.find(p => p.id == 63);
                if(perm2 && perm2.level > 2) { //permission to edit balance fields
                    val2 = true;
                }
            });
            return val1 && val2;
        },
        allValid(){
            let allValid = true;
            Object.values(this.workBalanceMap).forEach((w) => {
                if(!w.valid) allValid = false;
            });
            return allValid;
        },

        allConfirmed(){
            let allConfirmed = true
            Object.values(this.workBalanceMap).forEach((w) => {
                if(!w.confirmed) allConfirmed = false;
            });
            return allConfirmed;
        },
        storeHasMZ(){
            let view = this;
            let licenseEndDate = this.storeSettings.mzLicExpiry == null ? this.$helpers.getMomentTZ().add(-1, 'days') : this.$helpers.getMomentFromStringTZ(this.storeSettings.mzLicExpiry);
            return !licenseEndDate < this.$helpers.getMomentTZ();
        },
        employeeEmployeeWorkBalanceMap() {
            let map = {}
            const employeeWorkBalanceMap = this.workBalanceMap;
            Object.values(employeeWorkBalanceMap).forEach(item => {
                map[item.employeeId] = item;
            });
            return map;
        },
        employeePrevMonthEmployeeWorkBalanceMap() {
            let map = {}
            const employeeWorkBalanceMap = this.previousMonthWorkBalanceMap;
            Object.values(employeeWorkBalanceMap).forEach(item => {
                map[item.employeeId] = item;
            });
            return map;
        },
        confirmEmployeeWorkBalanceState(){
            const employeeMap = this.employeeMap;
            const earliestUnconfirmedMap = this.earliestUnconfirmedMap;
            const employeeEmployeeWorkBalanceMap = this.employeeEmployeeWorkBalanceMap;

            let confirmableEmployees = [];
            let confirmTodoDates = [];
            Object.values(employeeMap).forEach(employee => {
                if(employeeEmployeeWorkBalanceMap[employee.id] && !employeeEmployeeWorkBalanceMap[employee.id].confirmed){
                    let balance = employeeEmployeeWorkBalanceMap[employee.id];
                    let earliestUnconfirmedDate = earliestUnconfirmedMap[employee.id];
                    if(earliestUnconfirmedDate && this.$helpers.getMomentFromStringUTC(balance.date).format() == earliestUnconfirmedDate.format()){
                        confirmableEmployees.push(employee.id);
                    } else if(earliestUnconfirmedDate && earliestUnconfirmedDate < this.currentMonthUTC && confirmTodoDates.filter(s => s.format() == earliestUnconfirmedDate.format()).length == 0){
                        /*console.log(employee.id);
                        console.log(employee.firstName+" "+employee.lastName)
                        console.log(this.$helpers.getMomentFromStringUTC(balance.date).format())
                        console.log(earliestUnconfirmedDate.format()) */
                        confirmTodoDates.push(earliestUnconfirmedDate);
                    }
                }
            });
            let state =  {
                confirmableEmployees: confirmableEmployees,
                confirmTodoDates: confirmTodoDates,
            }
            //console.log(JSON.stringify(state));
            return state;

        },
        monthHasTodos(){
            let res = (this.confirmEmployeeWorkBalanceState.confirmTodoDates.length > 0 || this.confirmEmployeeWorkBalanceState.confirmableEmployees.length > 0);
            return res;
        },
        preUsageStartDateMonth(){
            let usageStartDate = this.$helpers.getMomentFromStringUTC(this.storeSettings.usageStartDate);
            let from = this.currentMonthFrom;
            let usdMonth = usageStartDate.month();
            let usdYear = usageStartDate.year();
            let curMonth = from.month();
            let curYear = from.year();
            return (usdYear == curYear && curMonth == usdMonth - 1) || (curYear == usdYear - 1 && curMonth == 11 && usdMonth == 0);
        },
        isBeforeCurrentIRLMonth() {
            //determines whether the currently displayed month is before the current IRL month
            let currentSelectedDate = this.currentMonthFrom;
            let currentIRLDate = this.$helpers.getMomentTZ();
            let selMonth = currentSelectedDate.month();
            let selYear = currentSelectedDate.year();
            let selDate = currentSelectedDate.clone().endOf('month').date();
            let curMonth = currentIRLDate.month();
            let curYear = currentIRLDate.year();
            let curDay = currentIRLDate.date();

            let endOfMonth = currentSelectedDate.clone().endOf('month').add(1, 'days').startOf('day');
            let currentDay = currentIRLDate.clone().startOf('day');
            let diffDays = endOfMonth.diff(currentDay, 'days');


            return (this.storeSettings.id == 445 && diffDays <= 3) || (selYear == curYear && selMonth == curMonth && selDate == curDay) || (selYear == curYear && selMonth < curMonth) || (selYear < curYear);
        },
        contractTypes() {
            let types = [];
            this.uiDataMap.contractTypes.forEach(item => types.push({label: item.label_de, value: item.id}));
            return types;
        },
        employeeCategories() {
            let types = [];
            this.uiDataMap.employeeCategories.forEach(item => types.push({label: item.label_de, value: item.id}));
            return types;
        },
        employmentTypes() {
            let types = [];
            this.uiDataMap.employmentTypes.forEach(item => types.push({label: item.label_de, value: item.id}));
            return types;
        },
        employeeLevels() {
            let types = [];
            this.uiDataMap.employeeLevels.forEach(item => types.push({label: item.label_de, value: item.id}));
            return types;
        },
        months() {
            let months = [];
            for(let i = 0; i<12; i++){
                let month = this.$helpers.getMomentTZ().month(i).format("MMMM");
                let item = {label: month, value: i};
                months.push(item);
            }
            return months;

        },

        headerButtons() {
            let view = this;
            let state= {buttons: [

                    {
                        type: "block",
                        icon: "fa-sync-alt",
                        click: () => {view.refresh(true, true, false)},
                        tooltip: this.$t('global.general.refreshData')
                    },
                    {
                        classes: "validate",
                        type: !this.allValid? "block cyan" : "block",
                        disabled: this.allValid,
                        icon: "fa-check",
                        click: () => {
                            this.validateAllWorkBalances();
                        },
                        show:  this.monthHasTodos,
                        tooltip: this.$t('workBalance.payroll.confirmAllValues'),
                        helperText: this.$t('workBalance.payroll.confirmAllHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/26fde32e-e202-47b8-8ee9-1b2e9db11c61/article/1357611009"
                    },
                    {
                        classes: "mzconfirm",
                        type: this.allValid && !this.mzConfirmed? "block orange" : "block",
                        disabled: !this.allValid || this.mzConfirmed || !this.isBeforeCurrentIRLMonth,
                        icon: "fa-user-clock",
                        click: () => { this.startConfirmProcessMZ(); },
                        show: this.storeHasMZ && this.monthHasTodos && !this.preUsageStartDateMonth,
                        tooltip: this.$t('workBalance.payroll.mzConfirm'),
                        helperText: this.$t('workBalance.payroll.mzConfirmHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/26fde32e-e202-47b8-8ee9-1b2e9db11c61/article/1357611009"
                    },
                    {
                        classes: "confirm",
                        type: !this.allowMdConfirm? "block" : "block green",
                        disabled: !this.allowMdConfirm,
                        icon: "fa-play",
                        click: () => { this.startConfirmProcessMD(); },
                        show:  this.monthHasTodos,
                        tooltip: this.$t('workBalance.payroll.checkAndClose'),
                        helperText: this.$t('workBalance.payroll.closeMonthHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/26fde32e-e202-47b8-8ee9-1b2e9db11c61/article/1357611009"
                    },
                    {
                        type: "block border-r",
                        icon: "fa-balance-scale",
                        tooltip: this.$t('workBalance.payroll.balanceBalance'),
                        disabled: !this.monthHasTodos || !this.canEditBalances,
                        helperText: this.$t('workBalance.payroll.balanceHelp'),
                        click: () => { view.OpenAutoCompensationModal();}
                    },

                ],
                showListIconAlways: true
            };
            state.helperLinks = [
                {
                    icon: "fa-video",
                    title: this.$t('store.structure.watchTrainingVideo'),
                    helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                    externalUrl: "https://www.youtube.com/watch_popup?v=MCpuN6AxKVg",
                    externalLabel: this.$t('store.structure.watchTrainingVideoLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                },
                {
                    title:  this.$t('store.structure.getSupport'),
                    helperText:  this.$t('store.structure.getSupportHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15",
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                }
            ];
            return state;
        },
        sideButtons() {
            let view = this;

            let state= {
                buttons: [
                    {
                        classes: "spot-filter",
                        type: "block border-r",
                        disabled: false,
                        icon: "fa-filter",
                        click: ($event) => {
                            view.OpenFilterDropdown($event);
                        },
                        show:  true,
                        tooltip: this.$t('global.ui.viewFilter'),
                    },
                    {
                        type: "block border-r",
                        icon: "fa-eye",
                        tooltip: this.$t('global.ui.viewOptions'),
                        click: ($event) => {view.OpenMenuDetails($event, this.displayMenuState);},

                    },
                    {
                        type: "block border-r",
                        icon: "fa-redo-alt",
                        show: !view.useSimpleView,
                        tooltip: this.$t('workBalance.payroll.autoCalcConfig'),
                        click: ($event) => { view.OpenMenuDetails($event, this.autoCalcMenuState); },
                    },
                    {
                        type: "block border-r",
                        icon: "fa-cash-register",
                        show: !view.useSimpleView,
                        tooltip: this.$t('workBalance.payroll.balanceCompensation'),
                        click: ($event) => { view.OpenMenuDetails($event, this.autoEqualMenuState); }
                    },
                    {
                        type: "block border-r",
                        icon: "fa-print",
                        tooltip: this.$t('global.ui.reportsExports'),
                        click: ($event) => { view.OpenMenuDetails($event, this.reportMenuState); }
                    },
                    {
                        type: "block",
                        icon: "fa-bars",
                        tooltip: this.$t('global.ui.additionalOptions'),
                        click: ($event) => {view.OpenMenuDetails($event, this.burgerMenuState)}
                    }
                ]
            };


            return state;
        },
        autoCalcMenuState(){
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                items: [
                    {
                        closeOnClick: true,
                        icon: "fa-redo-alt",
                        text: this.$t('workBalance.payroll.autoCalcAll'),
                        disabled: !this.monthHasTodos,
                        click: () => { view.UpdateAutoCalcMulti(true);}
                    },
                    {
                        closeOnClick: true,
                        icon: "fa-times-circle",
                        text: this.$t('workBalance.payroll.autoCalcNone'),
                        disabled: !this.monthHasTodos,
                        click: () => { view.UpdateAutoCalcMulti(false);}
                    },
                    {
                        closeOnClick: true,
                        icon: "fa-random",
                        text: this.$t('workBalance.payroll.invertSelection'),
                        disabled: !this.monthHasTodos,
                        click: () => { view.ToggleAutoCalcMulti();}
                    },
                ]
            };
            return state;
        },
        autoEqualMenuState(){
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                items: [
                    {
                        closeOnClick: true,
                        icon: "fa-equals",
                        text: this.$t('workBalance.payroll.autoReconcileAll'),
                        disabled: !this.monthHasTodos || !this.canEditBalances,
                        click: () => { view.UpdateAutoEqualizeMulti(true);}
                    },
                    {
                        closeOnClick: true,
                        icon: "fa-not-equal",
                        text: this.$t('workBalance.payroll.autoReconcileNone'),
                        disabled: !this.monthHasTodos || !this.canEditBalances,
                        click: () => { view.UpdateAutoEqualizeMulti(false);}
                    },
                    {
                        closeOnClick: true,
                        icon: "fa-tasks",
                        text: this.$t('workBalance.payroll.autoReconcileSelect'),
                        disabled: !this.monthHasTodos || !this.canEditBalances,
                        click: () => { view.OpenSelectAutoEqualizeEmployeesPopup();}
                    },
                    {
                        closeOnClick: true,
                        icon: "fa-random",
                        text: this.$t('workBalance.payroll.invertSelection'),
                        disabled: !this.monthHasTodos || !this.canEditBalances,
                        click: () => { view.ToggleAutoEqualizeMulti();}
                    },
                    {
                        closeOnClick: true,
                        icon: "fa-history",
                        text: this.$t('workBalance.payroll.resetPaidHours'),
                        disabled: !this.monthHasTodos || !this.canEditBalances,
                        click: () => { view.resetPaidColumns();}
                    },
                ]
            };
            return state;
        },
        reportMenuState(){
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                groups: [],
                items: []
            };

            let exportGroup = {
                label: this.$t('global.ui.csvExport'),
                items: [
                    {
                        closeOnClick: true,
                        classes: "export-csv",
                        type: "block cyan",
                        disabled: false,
                        icon: "fa-file-csv",
                        click: () => { view.openExportSelection(true, true); },
                        show:  true,
                        tooltip: this.$t('global.ui.exportCsv'),
                        text: this.$t('global.ui.exportCsv'),
                        helperText: this.$t('workBalance.payroll.exportCsvHelp')
                    },
                    {
                        closeOnClick: true,
                        classes: "export-csv",
                        type: "block cyan",
                        disabled: false,
                        icon: "fa-file-csv",
                        click: () => { view.openExtraExportSelection(1, true); },
                        show:  true,
                        tooltip: this.$t('workBalance.payroll.exportCsvTable'),
                        text: this.$t('workBalance.payroll.exportCsvTable'),
                        helperText: this.$t('workBalance.payroll.exportCsvTableHelp')
                    },
                    {
                        closeOnClick: true,
                        classes: "export-paid-csv",
                        type: "block cyan",
                        disabled: false,
                        icon: "fa-file-csv",
                        click: () => { view.openPaidCsvExportPopup(); },
                        show:  this.isSuperUser || this.userInfo.id == '3572b5c2-2cbc-417b-9134-133f216b05d4', // only superuser and Vanessa as discussed 2022-04-06 in HL
                        tooltip: this.$t('workBalance.payroll.exportCsvLv'),
                        text: this.$t('workBalance.payroll.exportCsvLv'),
                        helperText: this.$t('workBalance.payroll.exportCsvLvHelp')
                    },
                    {
                        closeOnClick: true,
                        classes: "export-csv",
                        type: "block cyan",
                        disabled: false,
                        icon: "fa-file-csv",
                        click: () => { view.openExtraExportSelection(5, true); },
                        show:  true,
                        tooltip: this.$t('workBalance.payroll.exportCsvBonusPay'),
                        text: this.$t('workBalance.payroll.exportCsvBonusPay'),
                        helperText: this.$t('workBalance.payroll.exportCsvBonusPayHelp')
                    },
                    {
                        closeOnClick: true,
                        classes: "export-csv",
                        type: "block cyan",
                        disabled: (!this.allValid || this.mzConfirmed) && !this.allConfirmed,
                        icon: "fa-file-csv",
                        click: () => { view.openSPSReisertExportSelection(); },
                        show:  this.storeSettings.companyId == 198 || this.storeSettings.companyId == 98 || this.storeSettings.companyId == 99 || this.storeSettings.companyId == 221,
                        tooltip: this.$t('workBalance.payroll.exportCsvLvReisert'),
                        text: this.$t('workBalance.payroll.exportCsvLvReisert'),
                        helperText: this.$t('workBalance.payroll.exportCsvLvReisertHelp')
                    },


                ]
            }

            state.groups.push(exportGroup);

            let reportGroup = {
                label: this.$t('indicator.crew.pdfReport'),
                items: [
                    {
                        closeOnClick: true,
                        classes: "export-save",
                        type: "block green",
                        disabled: false,
                        icon: "fa-file-pdf",
                        click: () => { view.openExportSelection(true, false); },
                        show:  true,
                        tooltip: this.$t('workBalance.payroll.pdfReport'),
                        text: this.$t('workBalance.payroll.pdfReport'),
                        helperText: this.$t('workBalance.payroll.pdfReportHelp')
                    },
                    {
                        closeOnClick: true,
                        classes: "export-save",
                        type: "block green",
                        disabled: false,
                        icon: "fa-file-pdf",
                        click: () => { view.openExtraExportSelection(3, true); },
                        show:  true,
                        tooltip: this.$t('workBalance.payroll.pdfNightworkOvertime'),
                        text: this.$t('workBalance.payroll.pdfNightworkOvertime'),
                        helperText: this.$t('workBalance.payroll.pdfNightworkOvertimeHelp')
                    },
                    {
                        closeOnClick: true,
                        classes: "export-save",
                        type: "block green",
                        disabled: false,
                        icon: "fa-file-pdf",
                        click: () => { view.openExtraExportSelection(4, true); },
                        show:  true,
                        tooltip: this.$t('workBalance.payroll.pdfBonusPay'),
                        text: this.$t('workBalance.payroll.pdfBonusPay'),
                        helperText: this.$t('workBalance.payroll.pdfBonusPayHelp')
                    },

                ]
            }

            state.groups.push(reportGroup);

            return state;
        },
        displayMenuState(){
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                groups: [],
                items: []
            };

            let group0 = {
                label: this.$t('global.ui.viewOptions'),
                items: [
                    {
                        closeOnClick: true,
                        icon: this.sortByName? "fa-sort-numeric-down" : "fa-sort-alpha-down",
                        text: this.sortByName? this.$t('global.ui.sortByPersonalNumber') : this.$t('global.ui.sortByName'),
                        disabled: false,
                        show: true,
                        click: () => { view.sortByName = !view.sortByName;}
                    },
                    {
                        type: "block",
                        icon: "fa-table",
                        show: true,//this.isSuperUser,
                        closeOnClick: true,
                        disabled: false,
                        click: () => {view.useSimpleView = !view.useSimpleView},
                        text: view.useSimpleView? this.$t('global.ui.tableView') : this.$t('workBalance.payroll.unfoldWorkBalance')
                    },

                ]
            };

            state.groups.push(group0);
            //state.groups.push(spotGroup);

            return state;
        },
        burgerMenuState(){
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                groups: [],
                items: []
            };
            if(this.canEditBalances && this.preUsageStartDateMonth){
                state.groups.push(
                    {
                        label: this.$t('pages.employeeContext.import'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: 'fa-file-csv',
                                disabled: false,
                                text: this.$t('global.ui.csvImport'),
                                click: () => {
                                    view.OpenCSVDataImportPopup();
                                }
                            }
                        ]
                    }
                )
            }
            let group1 = {
                label: this.$t('global.ui.additionalOptions'),
                items: [


                    {
                        closeOnClick: true,
                        disabled: this.mzConfirmed,
                        icon: "fa-calculator",
                        click: () => { view.OpenRecalculatePopup(); },
                        show:  this.monthHasTodos && !this.allConfirmed,// && !this.preUsageStartDateMonth,
                        text: this.$tc('workBalance.payroll.recalculateWorkBalance', 2),
                        title: this.$t('workBalance.payroll.recalculateTotal'),
                    },
                    {
                        closeOnClick: true,
                        icon: "fa-edit",
                        text: this.$t('workBalance.payroll.editStartingValues'),
                        show:  this.isSuperUser || this.canOpenAndEditBalances,
                        disabled: false,
                        click: () => { view.OpenChangeStartValuesPopup();}
                    },
                    {
                        closeOnClick: true,
                        icon: "fa-umbrella-beach",
                        text: this.$t('workBalance.payroll.updateVacationBalance'),
                        show:  this.isSuperUser || this.canOpenAndEditBalances,
                        disabled: false,
                        click: () => { view.OpenUpdateVacationTimeBalancePopup();}
                    },

                ]
            }


            group1.items.push(
                {
                    closeOnClick: true,
                    icon: "fa-undo",
                    text: this.$t('workBalance.payroll.undoCalc'),
                    click: () => { view.OpenUnconfirmPopup();}
                }
            )

            state.groups.push(group1);


            return state;
        },
        allowMdConfirm(){
            if(this.storeHasMZ && !this.isSuperUser){
                return this.allValid && (this.mzConfirmed || this.preUsageStartDateMonth) && this.isBeforeCurrentIRLMonth;
            } else {
                return this.allValid;
            }

        },
        employeesWithoutAvgWorktime(){
            if(this.storeSettings.useAvgWorkTimeForPrefs && !this.preUsageStartDateMonth){
                let employees = Object.values(this.workBalanceMap).filter(wb => !wb.confirmed && this.employeeMap[wb.employeeId].remoteId != null).map(wb => this.employeeMap[wb.employeeId]);
                let avgWorktimeEmployees = Object.keys(this.employeeAvgWorktimeMap);
                return employees.filter(e => !avgWorktimeEmployees.includes(''+e.remoteId));
            } else {
                return [];
            }

        },
        sideMenuState(){
            let view = this;
            const map = view.accountingPeriodSettingsMap;

            let currentSettings = Object.values(map).filter(i => i.month == this.currentMonthFrom.month());
            let currentAccSetting = null;
            if(currentSettings.length > 0){
                currentAccSetting = currentSettings.reduce((prev, current) => prev.priority < current.priority ? prev : current, currentSettings[0])
            }

            let employees = Object.values(view.workBalanceMap).filter(i => view.employeeMap[i.employeeId] != null).map(i => {

                return {label: view.employeeMap[i.employeeId].lastName.toUpperCase() + " "+view.employeeMap[i.employeeId].firstName, value: i.employeeId}
            });
            employees.sort((a,b)=> {
                if(a.label.toUpperCase() < b.label.toUpperCase()){
                    return -1;
                } else if (a.label.toUpperCase() < b.label.toUpperCase()){
                    return 1;
                }
                return 0;
            })
            let tabs = [];
            if(view.allowMdConfirm){
                tabs.push({
                    tabHeader: this.$t('workBalance.payroll.finishCalc'),
                    components: [{
                        type: 'datafill',
                        state: view.$helpers.GetAccountingPeriodSettingState(currentAccSetting, view.currentMonthFrom.month(), null, view.calculateAvailableMonths(), view.contractTypes, view.employeeCategories, view.employmentTypes, view.employeeLevels, view.storeSettings, false, employees, (item)  => {
                            if(item.saveSetting){
                                if(item.id == null){
                                    let items = [item]
                                    view.createMultiAccountingPeriodSetting(items);
                                } else {
                                    view.updateAccountingPeriodSetting(item);
                                }
                            } else {

                                let employeeIds = Object.values(view.workBalanceMap).filter(wb => !wb.confirmed && (!item.employeeFlag || (item.employees != null && item.employees.includes(wb.employeeId)))).map(wb => wb.employeeId);
                                let confirm = view.allowMdConfirm && item.employeeFlag;
                                let mode = view.mzConfirmed || confirm ? 2 : 1;

                                view.doMultiCreate(employeeIds, false, mode, true, item, confirm);
                            }

                        })
                    }],
                })
            }
            for(let i = 1; i <= 3; i++){
                let accPTabComponents = [];
                let apLabels = [];
                let settings = Object.values(map).filter(a => a.priority == i).sort((a,b) => {
                    return a.month - b.month;
                })
                if(settings.length < 12){
                    accPTabComponents.push({
                        type: 'buttonc',
                        propContainer: {type: 'green allow-hover',
                                        label: this.$t('workBalance.payroll.addNewConfig'),
                                        styleButton:{width: '100%', margin:  0, padding: '10px'},

                        },
                        customEvents:{ click: (event) => {
                            view.AddAccountingPeriodSetting(i);
                        }},
                        })
                }

                settings.forEach(aP => {
                    let name = view.$helpers.getMomentTZ().month(aP.month).format("MMMM");
                    let label = {
                        text: name,
                        type: "block",
                        components: [
                            {
                                type: 'buttonc', tooltip: this.$t('global.ui.edit'),
                                propContainer: {type: 'icon-overlay allow-hover', icon: 'fa-pencil'},
                                styles: {position: 'absolute', right: '35px'},
                                customEvents:{ click: (event) => {
                                        view.EditAccountingPeriodSetting(aP)
                                    }},

                            },
                            {
                                type: 'buttonc', tooltip: this.$t('global.ui.edit'),
                                propContainer: {type: 'icon-overlay allow-hover', icon: 'fa-trash'},
                                styles: {position: 'absolute', right: '10px'},
                                customEvents:{ click: (event) => {
                                        view.DeleteAccountingPeriodSetting(aP)
                                    }},

                            }
                        ]
                    }
                    apLabels.push(label);
                })
                accPTabComponents.push({
                    type: 'listlabel',
                    state:{
                        labels: apLabels
                    }
                })
                tabs.push({
                    tabHeader: this.$t('global.ui.prio') + ' '+i,
                    components: accPTabComponents,
                })
            }


            return [{
                label: this.$t('workBalance.accounting.title'),
                view: 'dropdowncontainer',
                bgcolor: view.allowMdConfirm ? '#6d8d23' : '',
                color: view.allowMdConfirm ? '#e8f5e7' : '',
                props:{
                    styles: {position: 'absolute', width: 'calc(100% - 40px)', top: '140px', left: '20px'},
                    state: {
                        staticElement: true,
                        tabs: tabs
                    }
                }
            }];
        },
        dataTableSimpleState(){
            let view = this;

            const wbMap = this.workBalanceMap;
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

            let data = Object.values(wbMap).filter(wb => visibleSpots.includes(view.employeeMap[wb.employeeId].spotId)).map((e) => { return Object.assign({}, e)});

            data.sort(function(a, b) {
                if(a.confirmed && !b.confirmed){
                    return 1;
                }
                if(!a.confirmed && b.confirmed){
                    return -1;
                }
                let ea = view.employeeMap[a.employeeId];
                let eb = view.employeeMap[b.employeeId];
                if(view.sortByName){
                    if(ea != undefined && eb != undefined){
                        let aName = ea.lastName + " " + ea.firstName;
                        let bName = eb.lastName + " " + eb.firstName;
                        return aName.toLocaleLowerCase().localeCompare(bName.toLocaleLowerCase());

                    }
                }else{
                    if(ea != undefined && eb != undefined){
                        let eaNum = ea.personnelId;
                        let ebNum = eb.personnelId;
                        if(eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null){
                            eaNum = parseInt(eaNum);
                            ebNum = parseInt(ebNum);
                            if(eaNum < ebNum) return - 1;
                            if(eaNum > ebNum) return 1;
                        }else if(eaNum == null || eaNum == undefined){
                            return 1;
                        }else{
                            return -1;
                        }
                    }
                }

                return 0;
            });



            data.forEach(d => {
                d.subEntries = [
                    {componentOverride: 'monthlyclosingsummary',
                        componentStateBuilders: [(data) => {
                            return {
                                employeeData: d,
                                enableWorkBalanceMultiplier: view.storeSettings.enableWorkBalanceMultiplier,
                                prevMonthWorkBalance: view.previousMonthWorkBalanceMap[d.employeeId],
                                optionalColumn: !view.sortByName,
                                componentType: 'monthlyclosingsummary',
                                customEvents: {
                                    Update: (   ) => {
                                    }
                                }
                            }
                        }]
                    }
                ]
            });
            //data.push(view.positiveBalanceSummaryData);

            let state = {};

            let columns = {};
            if(!this.sortByName){
                columns.personnelId = "PN";
            }
            columns.name = this.$tc('global.general.employee');
            columns.workTimeBalance= this.$t('workBalance.payroll.workTimeBalance');
            columns.vacationTimeBalance= this.$t('workBalance.payroll.leaveBalance');
            columns.holidayTimeBalance= this.$t('workBalance.payroll.holidayBalance');
            columns.nightWorkTimeBalance= this.$t('workBalance.payroll.nightWorkBalance');
            columns.overTimeBalance= this.$t('workBalance.payroll.overTimeBalance');
            if(this.storeSettings.country == 1){
                columns.moreTimeBalance= this.$t('workBalance.payroll.moreTimeBalance');
            }
            columns.bonusTimeBalance = this.$t('workBalance.payroll.bonusHoursBalance');
            columns.actions = ' ';

            state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            if(!this.sortByName){
                state.headerMap.personnelId.componentStateBuilders = [(data, entry) => {
                    let e = view.employeeMap[data.employeeId];
                    return {
                        componentType: 'labelc',
                        state:{ text: e.personnelId ? e.personnelId : '', },
                        styleLabel: {display: 'flex', alignItems: 'center', justifyContent: 'center',background: '', height: 'calc(100% - 10px)'},
                    }
                }];
            }

            state.headerMap.name.stylesEntrySum = {color: 'black'}
            state.headerMap.name.componentStateBuilders = [(data, entry) => {

                let employee = view.employeeMap[data.employeeId] ? view.employeeMap[data.employeeId] : {firstName: "Unbekannt", lastName: "Unbekannt"};

                return {
                    componentType: 'employeeentry', state:{ firstName: employee.firstName, lastName:  employee.lastName, employee: employee, splitName: true, hideShadow: true, textStyle: {color: 'white', fontSize: '12px', margin: '2.5px'}}
                }
            }];

            state.headerMap.workTimeBalance.stylesEntrySum = {color: 'black'}
            state.headerMap.workTimeBalance.componentStateBuilders = [(data, entry) => {
                if(data.confirmed || !view.canEditBalances){
                    return {
                        componentType: 'labelc',
                        state: {
                            text: (data.workTimeBalance / 60.0).toFixed(2),
                        },
                        styleLabel: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '',
                            height: 'calc(100% - 10px)'
                        },
                    }
                } else {
                    return {
                        componentType: 'inputc',
                        inputProp: (data.workTimeBalance / 60).toFixed(2),
                        customEvents: {
                            Update: (input, inputPrev) => {

                                view.dataUpdatedByUser(input, data, "workTimeBalance", 60);

                            },
                        },
                        DisplayLabel: (value) => {
                            let val = parseFloat(value);
                            if (isNaN(val)) {
                                return this.$t('workBalance.payroll.incorrectInput')
                            } else {
                                return val != null ? val.toFixed(2) : 0.00;
                            }

                        },
                        style: {
                            background: 'white',
                            height: 'calc(100% - 10px)',
                            width: 'calc(100% - 10px)',
                            margin: "auto",
                            right: "0",
                            left: "0"
                        },
                    }
                }

            }];

            state.headerMap.vacationTimeBalance.stylesEntrySum = {color: 'black'}
            state.headerMap.vacationTimeBalance.componentStateBuilders = [(data, entry) => {
                if (data.confirmed || !view.canEditBalances) {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: (data.vacationTimeBalance / 60 / 24).toFixed(2),
                        },
                        styleLabel: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '',
                            height: 'calc(100% - 10px)'
                        },
                    }
                } else {
                    return {
                        componentType: 'inputc',
                        inputProp: (data.vacationTimeBalance / 60 / 24).toFixed(2),
                        customEvents: {
                            Update: (input, inputPrev) => {
                                view.dataUpdatedByUser(input, data, "vacationTimeBalance", 60 * 24);
                            }
                        },
                        DisplayLabel: (value) => {
                            let val = parseFloat(value);
                            if (isNaN(val)) {
                                return this.$t('workBalance.payroll.incorrectInput')
                            } else {
                                return val != null ? val.toFixed(2) : 0.00;
                            }
                        },
                        style: {
                            background: 'white',
                            height: 'calc(100% - 10px)',
                            width: 'calc(100% - 10px)',
                            margin: "auto",
                            right: "0",
                            left: "0"
                        },
                    }
                }

            }];

            state.headerMap.holidayTimeBalance.stylesEntrySum = {color: 'black'}
            state.headerMap.holidayTimeBalance.componentStateBuilders = [(data, entry) => {
                if (data.confirmed || !view.canEditBalances) {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: (data.holidayTimeBalance / 60.0).toFixed(2),
                        },
                        styleLabel: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '',
                            height: 'calc(100% - 10px)'
                        },
                    }
                } else {
                    return {
                        componentType: 'inputc',
                        inputProp: (data.holidayTimeBalance / 60.0).toFixed(2),
                        customEvents: {
                            Update: (input, inputPrev) => {
                                view.dataUpdatedByUser(input, data, "holidayTimeBalance", 60);
                            }
                        },
                        DisplayLabel: (value) => {
                            let val = parseFloat(value);
                            if (isNaN(val)) {
                                return this.$t('workBalance.payroll.incorrectInput')
                            } else {
                                return val != null ? val.toFixed(2) : 0.00;
                            }
                        },
                        style: {
                            background: 'white',
                            height: 'calc(100% - 10px)',
                            width: 'calc(100% - 10px)',
                            margin: "auto",
                            right: "0",
                            left: "0"
                        },
                    }
                }

            }];

            state.headerMap.nightWorkTimeBalance.stylesEntrySum = {color: 'black'}
            state.headerMap.nightWorkTimeBalance.componentStateBuilders = [(data, entry) => {
                if (data.confirmed || !view.canEditBalances) {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: (data.nightWorkTimeBalance / 60.0).toFixed(2),
                        },
                        styleLabel: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '',
                            height: 'calc(100% - 10px)'
                        },
                    }
                } else {
                    return {
                        componentType: 'inputc',
                        inputProp: (data.nightWorkTimeBalance / 60.0).toFixed(2),
                        customEvents: {
                            Update: (input, inputPrev) => {
                                view.dataUpdatedByUser(input, data, "nightWorkTimeBalance", 60);
                            }
                        },
                        DisplayLabel: (value) => {
                            let val = parseFloat(value);
                            if (isNaN(val)) {
                                return this.$t('workBalance.payroll.incorrectInput')
                            } else {
                                return val != null ? val.toFixed(2) : 0.00;
                            }
                        },
                        style: {
                            background: 'white',
                            height: 'calc(100% - 10px)',
                            width: 'calc(100% - 10px)',
                            margin: "auto",
                            right: "0",
                            left: "0"
                        },
                    }
                }

            }];

            state.headerMap.overTimeBalance.stylesEntrySum = {color: 'black'}
            state.headerMap.overTimeBalance.componentStateBuilders = [(data, entry) => {
                if (data.confirmed || !view.canEditBalances || data.employeeId == "positiveSum") {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: (data.overTimeBalance / 60.0).toFixed(2),
                        },
                        styleLabel: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '',
                            height: 'calc(100% - 10px)'
                        },
                    }
                } else {
                    return {
                        componentType: 'inputc',
                        inputProp: (data.overTimeBalance / 60.0).toFixed(2),
                        customEvents: {
                            Update: (input, inputPrev) => {
                                view.dataUpdatedByUser(input, data, "overTimeBalance", 60);
                            }
                        },
                        DisplayLabel: (value) => {
                            let val = parseFloat(value);
                            if (isNaN(val)) {
                                return this.$t('workBalance.payroll.incorrectInput')
                            } else {
                                return val != null ? val.toFixed(2) : 0.00;
                            }
                        },
                        style: {
                            background: 'white',
                            height: 'calc(100% - 10px)',
                            width: 'calc(100% - 10px)',
                            margin: "auto",
                            right: "0",
                            left: "0"
                        },
                    }
                }

            }];

            if (this.storeSettings.country == 1) {
                state.headerMap.moreTimeBalance.stylesEntrySum = {color: 'black'}
                state.headerMap.moreTimeBalance.componentStateBuilders = [(data, entry) => {
                    if (data.confirmed || !view.canEditBalances || data.employeeId == "positiveSum") {
                        return {
                            componentType: 'labelc',
                            state: {
                                text: (data.moreTimeBalance / 60.0).toFixed(2),
                            },
                            styleLabel: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: '',
                                height: 'calc(100% - 10px)'
                            },
                        }
                    } else {
                        return {
                            componentType: 'inputc',
                            inputProp: (data.moreTimeBalance / 60.0).toFixed(2),
                            customEvents: {
                                Update: (input, inputPrev) => {
                                    view.dataUpdatedByUser(input, data, "moreTimeBalance", 60);
                                }
                            },
                            DisplayLabel: (value) => {
                                let val = parseFloat(value);
                                if (isNaN(val)) {
                                    return this.$t('workBalance.payroll.incorrectInput')
                                } else {
                                    return val != null ? val.toFixed(2) : 0.00;
                                }
                            },
                            style: {
                                background: 'white',
                                height: 'calc(100% - 10px)',
                                width: 'calc(100% - 10px)',
                                margin: "auto",
                                right: "0",
                                left: "0"
                            },
                        }
                    }

                }];
            }

            state.headerMap.bonusTimeBalance.stylesEntrySum = {color: 'black'}
            state.headerMap.bonusTimeBalance.componentStateBuilders = [(data, entry) => {
                if (data.confirmed || !view.canEditBalances || data.employeeId == "positiveSum") {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: (data.bonusTimeBalance / 60.0).toFixed(2),
                        },
                        styleLabel: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '',
                            height: 'calc(100% - 10px)'
                        },
                    }
                } else {
                    return {
                        componentType: 'inputc',
                        inputProp: (data.bonusTimeBalance / 60.0).toFixed(2),
                        customEvents: {
                            Update: (input, inputPrev) => {
                                view.dataUpdatedByUser(input, data, "bonusTimeBalance", 60);
                            }
                        },
                        DisplayLabel: (value) => {
                            let val = parseFloat(value);
                            if (isNaN(val)) {
                                return this.$t('workBalance.payroll.incorrectInput')
                            } else {
                                return val != null ? val.toFixed(2) : 0.00;
                            }
                        },
                        style: {
                            background: 'white',
                            height: 'calc(100% - 10px)',
                            width: 'calc(100% - 10px)',
                            margin: "auto",
                            right: "0",
                            left: "0"
                        },
                    }
                }

            }];


            state.headerMap.actions.stylesEntry = {'justify-content': 'center'};
            state.headerMap.actions.componentStateBuilders = [
                (data, entry) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return view.workBalanceMap[data.id].valid ? (view.workBalanceMap[data.id].appliedAccountingPeriod ? this.$t('workBalance.payroll.validFinishAccounting') : this.$t('global.ui.valid')) : this.$t('workBalance.payroll.invalid')
                        },
                        type: 'button icon-overlay square',
                        icon: data.appliedAccountingPeriod ? "fa-check-double" : "fa-check",
                        disabled: data.confirmed,
                        styleButton: {
                            margin: '0 5px 0 5px',
                            color: data.valid ? (data.appliedAccountingPeriod ? "var(--contrast-4)" : 'var(--bg)') : 'var(--bg)'
                        },
                        customEvents: {
                            click: (event) => {
                                if (!data.valid) {
                                    view.dataUpdatedByUser(true, data, "valid")
                                    let employeeWorkBalance = view.workBalanceMap[data.id];
                                    view.createEmployeeWorkBalance(employeeWorkBalance, false);
                                }
                            }

                        }

                    }

                },
                (data, entry) => {
                    return {
                        componentType: 'buttonc',
                        tooltip: () => {
                            return view.workBalanceMap[data.id].confirmed ? this.$t('workBalance.payroll.finished') : this.$t('workBalance.payroll.open')
                        },
                        type: 'button icon-overlay square',
                        icon: data.confirmed ? 'fas fa-lock' : "fa-lock-open",
                        disabled: !data.confirmed,
                        styleButton: {margin: '0 5px 0 5px', color: data.confirmed ? 'var(--contrast-4)' : 'var(--bg)'},
                        customEvents: {
                            click: (event) => {
                                if (data.confirmed && data.confirmDate) {
                                    view.$helpers.OpenAlert(
                                        {
                                            header: this.$t('workBalance.payroll.finishInfo'),
                                            description: this.$t('workBalance.payroll.finishInfoDate') + view.$helpers.getMomentFromStringTZ(data.confirmDate).format("DD.MM.YYYY HH:mm"),
                                            callbackAccept: function (popup) {

                                                popup.hidden = true;
                                            },
                                        }
                                    );
                                }
                            }

                        }

                    }

                },
                (data, entry) => {
                    return {

                        componentType: 'buttonc',
                        tooltip: this.$t('global.general.comment'),
                        type: 'button icon-overlay square',
                        icon: 'fas fa-comment-alt',
                        styleButton: {margin: '0 20px 0 5px', color: data.comment ? 'var(--contrast-4)' : 'var(--bg)'},
                        customEvents: {
                            click: ($event) => {
                                view.openCommentPopup($event, data);
                            }

                        }
                    }

                }];

            if (this.storeSettings.enableWorkBalanceMultiplier) {
                state.headerMap.actions.componentStateBuilders.unshift(
                    (data, entry) => {

                        return {
                            componentType: 'buttonc',
                            tooltip: () => {
                                return view.workBalanceMap[data.id].multiplier != 100 ? this.$t('workBalance.payroll.balanceMultiplicator') : null
                            },
                            type: 'button icon-overlay square',
                            icon: "fa-level-up-alt",
                            disabled: data.multiplier == 100,
                            styleButton: {
                                margin: '0 5px 0 5px',
                                color: data.multiplier != 100 ? 'var(--contrast-4)' : 'var(--bg)'
                            },
                            customEvents: {}

                        }

                    }
                )
            }

            let entries = Object.entries(state.headerMap);

            let mainColumnWidth = 12.5;
            let mainColumns = ["workTimeBalance", "vacationTimeBalance", "holidayTimeBalance", "nightWorkTimeBalance", "overTimeBalance", "bonusTimeBalance"];
            let nameColumns = ["name"];
            let nameColumnWidth = this.sortByName ? 15 : 10;
            if (this.storeSettings.country == 1) {
                mainColumns.push("moreTimeBalance");
                mainColumnWidth = 11;
                nameColumnWidth = this.sortByName ? 13 : 8;
            }


            let persColumns = ["personnelId"];
            let persColumnWidth = 5;
            let actionColumns = ["actions"];
            let actionColumnWidth = 10;
            for (let x in entries) {

                if (mainColumns.includes(entries[x][0])) {
                    entries[x][1].width = mainColumnWidth + '%';
                } else if (nameColumns.includes(entries[x][0])) {
                    entries[x][1].width = nameColumnWidth + '%';
                } else if (persColumns.includes(entries[x][0])) {
                    entries[x][1].width = persColumnWidth + '%';
                } else if (actionColumns.includes(entries[x][0])) {
                    entries[x][1].width = actionColumnWidth + '%';
                }
                //entries[x][1].width = ((100 / (entries.length + 1)) * (x === (''+(entries.length-1)) ? 0.5 : 1)) + '%';
                //console.log(entries[x][1].width)
                entries[x][1].key = entries[x][0];

            }
            state.headerStyles = {position: "sticky", top: 0, zIndex: 10, background: 'var(--sub-menu)'};
            state.heightSubRow = 'fit-content';
            state.rowStyles = {background: '#6d8d23'};
            state.rowStylesCollapsed = {background: 'var(--contrast-1)'};
            state.sumRowStyles = {background: 'var(--sub-menu)'}
            state.dataSum = [this.positiveBalanceSummary, this.negativeBalanceSummary, this.balanceSummary];
            return state;
        },
        dataTableState() {
            let view = this;
            let state = {};
            let hmap = {};
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

            let balances = Object.values(this.workBalanceMap).filter(wb => visibleSpots.includes(view.employeeMap[wb.employeeId].spotId));

            balances.sort(function (a, b) {
                if (a.confirmed && !b.confirmed) {
                    return 1;
                }
                if (!a.confirmed && b.confirmed) {
                    return -1;
                }
                let ea = view.employeeMap[a.employeeId];
                let eb = view.employeeMap[b.employeeId];
                if (view.sortByName) {
                    if (ea != undefined && eb != undefined) {
                        let aName = ea.lastName + " " + ea.firstName;
                        let bName = eb.lastName + " " + eb.firstName;
                        return aName.toLocaleLowerCase().localeCompare(bName.toLocaleLowerCase());
                    }
                } else {
                    if (ea != undefined && eb != undefined) {
                        let eaNum = ea.personnelId;
                        let ebNum = eb.personnelId;
                        if (eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null) {
                            eaNum = parseInt(eaNum);
                            ebNum = parseInt(ebNum);
                            if (eaNum < ebNum) return -1;
                            if (eaNum > ebNum) return 1;
                        } else if (eaNum == null || eaNum == undefined) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                }

                return 0;
            });

            if (!this.sortByName) {
                hmap.personnelId = this.headerMapEntry('personnelId', 'PN', (i) => {
                    let e = view.employeeMap[i.employeeId];
                    if (e != undefined) {
                        return e.personnelId != null ? e.personnelId : '';
                    }
                }, false, 'left', 'left', null, this.$t('pages.employeeCoreData.personnelNumber'));
            }

            hmap.name = this.headerMapEntry('name', this.$t('pages.employeeData.name'), (i) => {
                let e = view.employeeMap[i.employeeId];
                if (e != undefined) {
                    return e.lastName + ' ' + e.firstName;
                }
            }, view.sortByName);
            hmap.name.width = '10%';

            let aButtons = [];
            let hButton = {};

            if (this.preUsageStartDateMonth) {

                hmap.vacationTimeBalance = this.headerMapMinutesToDaysValueEntry('vacationTimeBalance', this.$t('pages.employeeContract.vacationEntitlement'), this.monthHasTodos, this.$t('workBalance.payroll.remainingLeave'));
                hmap.holidayTimeBalance = this.headerMapMinutesToHoursValueEntry('holidayTimeBalance', this.$t('workBalance.payroll.holidayBalance'), this.monthHasTodos, this.$t('workBalance.payroll.holidayBalance'));
                hmap.workTimeBalance = this.headerMapMinutesToHoursValueEntry('workTimeBalance', this.$t('workBalance.payroll.balance'), this.monthHasTodos, this.$t('workBalance.payroll.workTimeBalance'));


                if (this.monthHasTodos) {
                    hmap.status = {
                        key: 'valid',
                        label: this.$t('global.ui.valid'),
                        sort: false,
                        align: 'right',
                        alignHeaderLabel: 'center',
                        tooltip: this.$t('global.ui.valid'),
                        DisplayLabel: (i) => {
                            return i.valid;
                        },
                        OnChange: (value, rowData, key) => {
                            if (value == true) {
                                view.dataUpdatedByUser(value, rowData, key)
                                let employeeWorkBalance = view.workBalanceMap[rowData.id];
                                view.createEmployeeWorkBalance(employeeWorkBalance, false);
                            }

                        }
                    };
                }
            } else {
                // TODO: REMOVE THIS WHEN THE JARZ GUYS FINALLY USE MZ!!!!!!!!
                let is34or120 = this.$store.state.storeId == 12 || this.$store.state.storeId == 14;
                if (this.tableDetailState == 0 || this.tableDetailState == 1) {


                    if (this.tableDetailState == 1) {
                        hmap.workTimeRegular = this.headerMapMinutesToHoursValueEntry('workTimeRegular', this.$t('workBalance.summary.target'), false, this.$t('workBalance.payroll.workTimeTarget'),);
                        hmap.prevMonthTime = this.headerMapMinutesToHoursValueEntry('prevMonthTime', this.$t('workBalance.payroll.previousMonthShort'), false, this.$t('workBalance.payroll.carryOver'));
                        hmap.workTime = this.headerMapMinutesToHoursValueEntry('workTime', this.$t('workBalance.payroll.pActual'), (is34or120 || !this.storeHasMZ || this.isSuperUser) && this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.pActualWorkTime'));
                        hmap.unproductiveWorkTime = this.headerMapMinutesToHoursValueEntry('unproductiveWorkTime', this.$t('workBalance.payroll.upActual'), !this.storeHasMZ && this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.upActualWorkTime'));

                        hmap.sickWorkTime = this.headerMapMinutesToHoursValueEntry('sickWorkTime', this.$t('workBalance.summary.sickLeaveShort'), false, this.$t('workBalance.summary.sickLeaveH'));
                        hmap.wageContinuationWorkTime = this.headerMapMinutesToHoursValueEntry('wageContinuationWorkTime', this.$t('workBalance.summary.sickPayShort'), false, this.$t('workBalance.summary.sickPayH'));
                        hmap.educationWorkTime = this.headerMapMinutesToHoursValueEntry('educationWorkTime', this.$t('workBalance.summary.traineeShort'), false, this.$t('workBalance.summary.traineeH'));
                        hmap.nursingVacationWorkTime = this.headerMapMinutesToHoursValueEntry('nursingVacationWorkTime', this.$t('workBalance.summary.nursingLeaveShort'), false, this.$t('workBalance.summary.nursingLeaveH'));
                        hmap.vacationWorkTime = this.headerMapMinutesToHoursValueEntry('vacationWorkTime', this.$t('workBalance.payroll.vacationShort'), false, this.$t('workBalance.summary.vacationH'));
                        hmap.miscWorkTime = this.headerMapMinutesToHoursValueEntry('miscWorkTime', this.$t('workBalance.summary.otherShort'), false, this.$t('workBalance.summary.otherAbsencesH'));

                    }
                    hmap.paidWorkTime = this.headerMapMinutesToHoursValueEntry('paidWorkTime', this.$t('workBalance.payroll.workTimeModifiedShort'), this.monthHasTodos && view.canEditBalances, this.$t('workBalance.summary.workTimeModified'));


                    hmap.workTimeBalance = this.headerMapMinutesToHoursValueEntry('workTimeBalance', this.$t('workBalance.payroll.workTimeBalanceShort'), false, this.$t('workBalance.payroll.workTimeBalance'), "var(--col-ewb-saldo)");
                    hmap.workTimeBalance.labelicon = this.tableDetailState == 1 ? 'fas fa-eye-slash' : 'fas fa-eye';
                    hmap.workTimeBalance.action = () => {
                        view.SwitchTableDetailState(1);

                    };
                    if (this.storeSettings.enableWorkBalanceMultiplier) {
                        hmap.accountingPeriodBalance = this.headerMapMinutesToHoursValueEntry('accountingPeriodBalance', this.$t('workBalance.summary.carryOverShort'), false, this.$t('workBalance.summary.accPeriodCarryOver'));
                    }
                    if (this.tableDetailState == 1 && this.storeSettings.enableWorkBalanceMultiplier) {
                        hmap.multiplier = this.headerMapFloatValueEntry("multiplier", this.$t('workBalance.payroll.multiplierShort'), false, this.$t('workBalance.summary.multiplier'), 100, 2);
                    }


                }
                if (this.tableDetailState == 0 || this.tableDetailState == 2) {
                    if (this.tableDetailState == 2) {
                        hmap.prevMonthVacation = {
                            key: 'prevMonthVacation',
                            label: this.$t('workBalance.payroll.vacationPreviousMonthShort'),
                            sort: false,
                            align: 'right',
                            alignHeaderLabel: 'left',
                            tooltip: this.$t('workBalance.payroll.vacationPreviousMonth'),

                            DisplayLabel: (i) => {
                                let prevMonthBalance = this.previousMonthWorkBalanceMap[i.employeeId] == null ? 0 : this.previousMonthWorkBalanceMap[i.employeeId].vacationTimeBalance;

                                return (prevMonthBalance / 60 / 24).toFixed(2);
                            },

                        };
                        hmap.contractVacation = {
                            key: 'contractVacation',
                            label: this.$t('workBalance.payroll.vacationShortPlus'),
                            sort: false,
                            align: 'right',
                            alignHeaderLabel: 'left',
                            tooltip: this.$t('workBalance.payroll.vacationIncrease'),

                            DisplayLabel: (i) => {
                                let prevMonthBalance = this.previousMonthWorkBalanceMap[i.employeeId] == null ? 0 : this.previousMonthWorkBalanceMap[i.employeeId].vacationTimeBalance;

                                return ((i.vacationTimeBalance - prevMonthBalance + i.vacationTime) / 60 / 24).toFixed(2);
                            },

                        };
                        hmap.vacationTime = this.headerMapMinutesToDaysValueEntry('vacationTime', this.$t('workBalance.payroll.vacationShort'), false, this.$t('workBalance.summary.vacationDays'));
                    }
                    hmap.paidVacationTime = this.headerMapMinutesToDaysValueEntry('paidVacationTime', this.$t('workBalance.payroll.modifiedVacationShort'), this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.modifiedVacation'));
                    hmap.vacationTimeBalance = this.headerMapMinutesToDaysValueEntry('vacationTimeBalance', this.$t('workBalance.payroll.vacationBalanceShort'), false, this.currentMonthFromTZ.year() < 2021 ? this.$t('workBalance.payroll.remainingLeave') : this.$t('workBalance.payroll.aliquotVacation'), "var(--col-ewb-saldo)");
                    hmap.vacationTimeBalance.labelicon = this.tableDetailState == 2 ? 'fas fa-eye-slash' : 'fas fa-eye';
                    hmap.vacationTimeBalance.action = () => {
                        view.SwitchTableDetailState(2);
                    };


                }

                if (this.tableDetailState == 0 || this.tableDetailState == 3) {
                    if (this.tableDetailState == 3) {
                        hmap.holidayTime = this.headerMapMinutesToHoursValueEntry('holidayTime', this.$t('workBalance.payroll.holidayShort'), false, this.$t('workBalance.payroll.holidayWorkTime'));
                        hmap.holidayAdjustmentWorkTime = this.headerMapMinutesToHoursValueEntry('holidayAdjustmentWorkTime', this.$t('workBalance.payroll.holidayCompensationShort'), false, this.$t('workBalance.payroll.holidayCompensation'));
                    }

                    hmap.paidHolidayTime = this.headerMapMinutesToHoursValueEntry('paidHolidayTime', this.$t('workBalance.payroll.holidayModifiedShort'), this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.modifiedHolidays'));
                    hmap.holidayTimeBalance = this.headerMapMinutesToHoursValueEntry('holidayTimeBalance', this.$t('workBalance.payroll.holidayBalanceShort'), false, this.$t('workBalance.payroll.holidayBalance'), "var(--col-ewb-saldo)");
                    hmap.holidayTimeBalance.labelicon = this.tableDetailState == 3 ? 'fas fa-eye-slash' : 'fas fa-eye';
                    hmap.holidayTimeBalance.action = () => {
                        view.SwitchTableDetailState(3);
                    }
                }

                //only show overtime and nightwork if work or holiday detail isnt on
                if (this.tableDetailState == 0 || this.tableDetailState == 4) {
                    if (this.tableDetailState == 4) {
                        hmap.previousMonthNightWorkTime = this.headerMapMinutesToHoursValueEntry("prevMonthNightWorkTime", this.$t('workBalance.payroll.nightWorkPreviousMonthShort'), false, this.$t('workBalance.payroll.nightWorkPreviousMonth'));
                        hmap.nightWorkTime = this.headerMapMinutesToHoursValueEntry("nightWorkTime", this.$t('workBalance.payroll.nightWorkShort'), false, this.$t('workBalance.payroll.nightWork'));
                        hmap.nightWorkCount = this.headerMapIntValueEntry("nightWorkCount", this.$t('workBalance.payroll.nightWorkShiftsShort'), this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.nightWorkShifts'))
                    }
                    hmap.paidNightWorkTime = this.headerMapMinutesToHoursValueEntry("paidNightWorkTime", this.$t('workBalance.payroll.nightWorkModifiedShort'), this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.nightWorkModified'));
                    hmap.nightWorkTimeBalance = this.headerMapMinutesToHoursValueEntry("nightWorkTimeBalance", this.$t('workBalance.payroll.nightWorkBalanceShort'), false, this.$t('workBalance.payroll.nightWorkBalance'), "var(--col-ewb-saldo)");
                    hmap.nightWorkTimeBalance.labelicon = this.tableDetailState == 4 ? 'fas fa-eye-slash' : 'fas fa-eye';
                    hmap.nightWorkTimeBalance.action = () => {
                        view.SwitchTableDetailState(4);
                    }


                }

                if (this.tableDetailState == 0 || this.tableDetailState == 5) {

                    if (this.tableDetailState == 5) {
                        hmap.previousMonthOverTime = this.headerMapMinutesToHoursValueEntry("prevMonthOverTime", this.$t('workBalance.payroll.overTimePreviousMonthShort'), false, this.$t('workBalance.payroll.overTimePreviousMonth'));
                        hmap.overTime = this.headerMapMinutesToHoursValueEntry("overTime", this.$t('workBalance.payroll.overTimeShort'), false, this.$t('workBalance.payroll.overTime'));
                        hmap.overTimeCount = this.headerMapIntValueEntry("overTimeCount", this.$t('workBalance.payroll.overTimeShiftsShort'), this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.overTimeShifts'))
                    }
                    hmap.paidOverTime = this.headerMapMinutesToHoursValueEntry("paidOverTime", this.$t('workBalance.payroll.overTimeModifiedShort'), this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.overTimeModified'));
                    hmap.overTimeBalance = this.headerMapMinutesToHoursValueEntry("overTimeBalance", this.$t('workBalance.payroll.overTimeBalanceShort'), false, this.$t('workBalance.payroll.overTimeBalance'), "var(--col-ewb-saldo)");
                    hmap.overTimeBalance.labelicon = this.tableDetailState == 5 ? 'fas fa-eye-slash' : 'fas fa-eye';
                    hmap.overTimeBalance.action = () => {
                        view.SwitchTableDetailState(5);
                    }
                }

                if (this.tableDetailState == 0 || this.tableDetailState == 6) {

                    if (this.tableDetailState == 6) {
                        hmap.previousMonthMoreTime = this.headerMapMinutesToHoursValueEntry("prevMonthMoreTime", this.$t('workBalance.payroll.moreTimePreviousMonthShort'), false, this.$t('workBalance.payroll.moreTimePreviousMonth'));
                        hmap.moreTime = this.headerMapMinutesToHoursValueEntry("moreTime", this.$t('workBalance.payroll.moreTimeShort'), false, this.$t('workBalance.payroll.moreTime'));
                        //hmap.moreTimeCount = this.headerMapIntValueEntry("moreTimeCount", 'MS Anzahl', this.monthHasTodos && view.canEditBalances, "Anzahl der Mehrstunden Wochen")
                    }
                    hmap.paidMoreTime = this.headerMapMinutesToHoursValueEntry("paidMoreTime", this.$t('workBalance.payroll.moreTimeModifiedShort'), this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.moreTimeModified'));
                    hmap.moreTimeBalance = this.headerMapMinutesToHoursValueEntry("moreTimeBalance", this.$t('workBalance.payroll.moreTimeBalanceShort'), false, this.$t('workBalance.payroll.moreTimeBalance'), "var(--col-ewb-saldo)");
                    hmap.moreTimeBalance.labelicon = this.tableDetailState == 6 ? 'fas fa-eye-slash' : 'fas fa-eye';
                    hmap.moreTimeBalance.action = () => {
                        view.SwitchTableDetailState(6);
                    }
                }

                if (this.tableDetailState == 0 || this.tableDetailState == 7) {

                    if (this.tableDetailState == 7) {
                        hmap.previousMonthBonusTime = this.headerMapMinutesToHoursValueEntry("prevMonthBonusTime", this.$t('workBalance.payroll.bonusHoursPreviousMonthShort'), false, this.$t('workBalance.payroll.bonusHoursPreviousMonth'));
                        hmap.bonusTime = this.headerMapMinutesToHoursValueEntry("bonusTime", this.$t('workBalance.payroll.bonusHoursShort'), false, this.$t('workBalance.payroll.bonusHours'));
                        hmap.bonusTimeCount = this.headerMapIntValueEntry("bonusTimeCount", this.$t('workBalance.payroll.bonusHoursShiftsShort'), this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.bonusHoursShifts'))
                    }
                    hmap.paidBonusTime = this.headerMapMinutesToHoursValueEntry("paidBonusTime", this.$t('workBalance.payroll.bonusHoursModifiedShort'), this.monthHasTodos && view.canEditBalances, this.$t('workBalance.payroll.bonusHoursModified'));
                    hmap.bonusTimeBalance = this.headerMapMinutesToHoursValueEntry("bonusTimeBalance", this.$t('workBalance.payroll.bonusHoursBalanceShort'), false, this.$t('workBalance.payroll.bonusHoursBalance'), "var(--col-ewb-saldo)");
                    hmap.bonusTimeBalance.labelicon = this.tableDetailState == 7 ? 'fas fa-eye-slash' : 'fas fa-eye';
                    hmap.bonusTimeBalance.action = () => {
                        view.SwitchTableDetailState(7);
                    }
                }


                if (this.monthHasTodos) {
                    hmap.status = {
                        key: 'valid',
                        label: this.$t('global.ui.valid'),
                        icon: 'fas fa-check cyan',
                        sort: false,
                        align: 'center',
                        alignHeaderLabel: 'center',
                        tooltip: this.$t('global.ui.valid'),
                        DisplayLabel: (i) => {
                            return i.valid;
                        },
                        OnChange: (value, rowData, key) => {
                            if (value == true) {
                                view.dataUpdatedByUser(value, rowData, key)
                                let employeeWorkBalance = view.workBalanceMap[rowData.id];
                                view.createEmployeeWorkBalance(employeeWorkBalance, false);
                            }

                        }
                    };
                    hmap.status.collapsedIcon = "fa-check cyan";
                    hmap.status.collapsed = false;

                }

            }

            hmap.confirmed = {
                key: 'confirmed',
                label: 'Abg.',
                sort: false,
                icon: 'fas fa-play green',
                align: 'center',
                alignHeaderLabel: 'center',
                tooltip: this.$t('workBalance.payroll.finished'),
                DisplayLabel: (i) => {
                    return i.confirmed;
                },
                OnChange: (value, rowData, key) => {
                    let ewb = view.workBalanceMap[rowData.id];
                    if (ewb.confirmed && ewb.confirmDate) {
                        view.$helpers.OpenAlert(
                            {
                                header: this.$t('workBalance.payroll.finishInfo'),
                                description: this.$t('workBalance.payroll.finishInfoDate') + view.$helpers.getMomentFromStringTZ(ewb.confirmDate).format("DD.MM.YYYY HH:mm"),
                                callbackAccept: function (popup) {

                                    popup.hidden = true;
                                },
                            }
                        );
                    }


                }

            };
            hmap.confirmed.collapsedIcon = "fa-play";
            hmap.confirmed.collapsed = false;

            hmap.appliedAccountingPeriod = {
                key: 'valid',
                label: this.$t('workBalance.payroll.accountingPeriodEndShort'),
                sort: false,
                align: 'center',
                alignHeaderLabel: 'center',
                tooltip: this.$t('workBalance.payroll.accountingPeriodEnd'),
                DisplayLabel: (i) => {
                    return i.appliedAccountingPeriod;
                },
                OnChange: (value, rowData, key) => {


                }
            };
            hmap.appliedAccountingPeriod.collapsedIcon = "fa-check";
            hmap.appliedAccountingPeriod.collapsed = false;

            hmap.autoCalc = {
                key: 'autoCalc',
                label: this.$t('workBalance.payroll.autoCalcInvalidShort'),
                icon: 'fas fa-redo-alt',
                sort: false,
                align: 'center',
                alignHeaderLabel: 'center',
                tooltip: this.$t('workBalance.payroll.autoCalcInvalid'),
                DisplayLabel: (i) => {
                    return i.autoCalc;
                },
                OnChange: (value, rowData, key) => {
                    if (!rowData.confirmed) {
                        view.ToggleAutoCalc(rowData.id, value);
                    }
                }
            };
            hmap.autoCalc.collapsedIcon = "fa-redo-alt";
            hmap.autoCalc.collapsed = true;

            hmap.autoEqualize = {
                key: 'autoEqualize',
                icon: 'fas fa-cash-register',
                label: this.$t('workBalance.payroll.autoRebalance'),
                sort: false,
                align: 'center',
                alignHeaderLabel: 'center',
                tooltip: this.$t('workBalance.payroll.autoRebalance'),
                DisplayLabel: (i) => {
                    return i.autoEqualize;
                },
                OnChange: (value, rowData, key) => {
                    if (!rowData.confirmed && view.canEditBalances) {
                        view.ToggleAutoEqualize(rowData.id, value);
                    }
                }
            };
            hmap.autoEqualize.collapsedIcon = "fa-cash-register";
            hmap.autoEqualize.collapsed = true;

            hmap.comment = {
                key: 'comment',
                icon: 'fas fa-comment-alt',
                label: this.$t('global.general.comment'),
                sort: false,
                align: 'center',
                alignHeaderLabel: 'center',
                tooltip: this.$t('global.general.comment'),
                componentTypeRow: 'buttonc',
                componentStateBuilder: (data, entry) => {
                    return {
                        propContainer: {
                            icon: data.comment ? 'fas fa-comment-alt' : 'fa-plus',
                            type: 'datatable-icon',
                        },
                        customEvents: {
                            click: ($event) => {
                                view.openCommentPopup($event, data);
                            }
                        }
                    }

                },
                collapsedIcon: 'fa-comment-alt',
                collapsed: false
            };


            state.headerMap = hmap;
            state.data = balances;
            state.dataSum = [this.positiveBalanceSummary, this.negativeBalanceSummary, this.balanceSummary];

            return state;
        },

        positiveBalanceSummary() {
            let view = this;
            let alignment = view.useSimpleView ? "center" : "right";
            let summary = {
                employeeId: "positiveSum",
                totalWorkTime: 0,
                vacationTimeBalance: 0,
                holidayTimeBalance: 0,
                workTimeBalance: 0,
                workTimeRegular: 0,
                workTime: 0,
                unproductiveWorkTime: 0,
                holidayAdjustmentTime: 0,
                holidayTime: 0,
                vacationTime: 0,
                sickTime: 0,
                nursingVacationTime: 0,
                educationTime: 0,
                wageContinuationTime: 0,
                paidWorkTime: 0,
                paidHolidayTime: 0,
                nightWorkTime: 0,
                nightWorkCount: 0,
                overTime: 0,
                overTimeCount: 0,
                moreTime: 0,
                moreTimeCount: 0,
                prevMonthTime: 0,
                holidayAdjustmentWorkTime: 0,
                sickWorkTime: 0,
                vacationWorkTime: 0,
                educationWorkTime: 0,
                nursingVacationWorkTime: 0,
                wageContinuationWorkTime: 0,
                paidVacationTime: 0,
                prevMonthOverTime: 0,
                prevMonthNightWorkTime: 0,
                overTimeBalance: 0,
                nightWorkTimeBalance: 0,
                paidOverTime: 0,
                paidNightWorkTime: 0,
                dailyOverTime: 0,
                weeklyOverTime: 0,
                workDayOverTime: 0,
                prevMonthMoreTime: 0,
                moreTimeBalance: 0,
                paidMoreTime: 0,
                miscWorkTime: 0,
                accountingPeriodBalance: 0,
                prevMonthBonusTime: 0,
                bonusTimeBalance: 0,
                paidBonusTime: 0,
                bonusTimeCount: 0,
                bonusTime: 0
            }
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

            let balances = Object.values(this.workBalanceMap).filter(wb => visibleSpots.includes(view.employeeMap[wb.employeeId].spotId));
            balances.forEach(item => {
                let totalWorkTime = 0;

                Object.keys(item).forEach(key => {
                    if (typeof item[key] == "number") {
                        if (!summary[key]) {
                            summary[key] = 0;
                        }
                        if (key == 'prevMonthTime' || key == 'workTime' || key == 'unproductiveWorkTime') {
                            totalWorkTime += item[key];
                        }
                        if (item[key] >= 0) {


                            summary[key] += item[key];
                        }

                    }

                })
                if (totalWorkTime >= 0) {
                    summary.totalWorkTime += totalWorkTime;
                }

            });

            let sumRow = {}
            if (this.preUsageStartDateMonth) {
                sumRow.name = {label: this.$t('workBalance.payroll.sumPositiveValues'), key: 'name', align: 'left'};
                sumRow.vacationTimeBalance = {
                    label: (summary.vacationTimeBalance / 24 / 60).toFixed(2),
                    key: 'vacationTimeBalance',
                    align: alignment
                };
                sumRow.holidayTimeBalance = {
                    label: (summary.holidayTimeBalance / 60).toFixed(2),
                    key: 'holidayTimeBalance',
                    align: alignment
                };
                sumRow.workTimeBalance = {
                    label: (summary.workTimeBalance / 60).toFixed(2),
                    key: 'workTimeBalance',
                    align: alignment
                };

            } else {
                sumRow.name = {label: this.$t('workBalance.payroll.sumPositiveValues'), key: 'name', align: 'left'};
                sumRow.vacationTimeBalance = {
                    label: (summary.vacationTimeBalance / 24 / 60).toFixed(2),
                    key: 'vacationTimeBalance',
                    align: alignment
                };
                sumRow.holidayTimeBalance = {
                    label: (summary.holidayTimeBalance / 60).toFixed(2),
                    key: 'holidayTimeBalance',
                    align: alignment
                };

                sumRow.workTimeBalance = {
                    label: (summary.workTimeBalance / 60).toFixed(2),
                    key: 'workTimeBalance',
                    align: alignment
                };
                sumRow.totalWorkTime = {
                    label: (summary.totalWorkTime / 60).toFixed(2),
                    key: 'totalWorkTime',
                    align: alignment
                };

                sumRow.prevMonthTime = {
                    label: (summary.prevMonthTime / 60).toFixed(2),
                    key: 'prevMonthTime',
                    align: alignment
                };
                sumRow.workTimeRegular = {
                    label: (summary.workTimeRegular / 60).toFixed(2),
                    key: 'workTimeRegular',
                    align: alignment
                };
                sumRow.workTime = {label: (summary.workTime / 60).toFixed(2), key: 'workTime', align: alignment};
                sumRow.unproductiveWorkTime = {
                    label: (summary.unproductiveWorkTime / 60).toFixed(2),
                    key: 'unproductiveWorkTime',
                    align: alignment
                };
                sumRow.holidayAdjustmentWorkTime = {
                    label: (summary.holidayAdjustmentWorkTime / 60).toFixed(2),
                    key: 'holidayAdjustmentWorkTime',
                    align: alignment
                };

                sumRow.holidayTime = {
                    label: (summary.holidayTime / 60).toFixed(2),
                    key: 'holidayTime',
                    align: alignment
                };
                sumRow.paidVacationTime = {
                    label: (summary.paidVacationTime / 24 / 60).toFixed(2),
                    key: 'paidVacationTime',
                    align: alignment
                };
                sumRow.vacationTime = {
                    label: (summary.vacationTime / 24 / 60).toFixed(2),
                    key: 'vacationTime',
                    align: alignment
                };

                sumRow.sickTime = {label: (summary.sickTime / 24 / 60).toFixed(2), key: 'sickTime', align: alignment};
                sumRow.nursingVacationTime = {
                    label: (summary.nursingVacationTime / 24 / 60).toFixed(2),
                    key: 'nursingVacationTime',
                    align: alignment
                };
                sumRow.educationTime = {
                    label: (summary.educationTime / 24 / 60).toFixed(2),
                    key: 'educationTime',
                    align: alignment
                };
                sumRow.wageContinuationTime = {
                    label: (summary.wageContinuationTime / 24 / 60).toFixed(2),
                    key: 'wageContinuationTime',
                    align: alignment
                };
                sumRow.paidWorkTime = {
                    label: (summary.paidWorkTime / 60).toFixed(2),
                    key: 'paidWorkTime',
                    align: alignment
                };

                sumRow.sickWorkTime = {
                    label: (summary.sickWorkTime / 60).toFixed(2),
                    key: 'sickWorkTime',
                    align: alignment
                };
                sumRow.vacationWorkTime = {
                    label: (summary.vacationWorkTime / 60).toFixed(2),
                    key: 'vacationWorkTime',
                    align: alignment
                };
                sumRow.nursingVacationWorkTime = {
                    label: (summary.nursingVacationWorkTime / 60).toFixed(2),
                    key: 'nursingVacationWorkTime',
                    align: alignment
                };
                sumRow.educationWorkTime = {
                    label: (summary.educationWorkTime / 60).toFixed(2),
                    key: 'educationWorkTime',
                    align: alignment
                };
                sumRow.wageContinuationWorkTime = {
                    label: (summary.wageContinuationWorkTime / 60).toFixed(2),
                    key: 'wageContinuationWorkTime',
                    align: alignment
                };
                sumRow.miscWorkTime = {
                    label: (summary.miscWorkTime / 24 / 60).toFixed(2),
                    key: 'miscWorkTime',
                    align: alignment
                };
                sumRow.accountingPeriodBalance = {
                    label: (summary.accountingPeriodBalance / 60).toFixed(2),
                    key: 'accountingPeriodBalance',
                    align: alignment
                };

                sumRow.paidHolidayTime = {
                    label: (summary.paidHolidayTime / 60).toFixed(2),
                    key: 'paidHolidayTime',
                    align: alignment
                };

                sumRow.prevMonthNightWorkTime = {
                    label: (summary.prevMonthNightWorkTime / 60).toFixed(2),
                    key: 'prevMonthNightWorkTime',
                    align: alignment
                };
                sumRow.paidNightWorkTime = {
                    label: (summary.paidNightWorkTime / 60).toFixed(2),
                    key: 'paidNightWorkTime',
                    align: alignment
                };
                sumRow.nightWorkTimeBalance = {
                    label: (summary.nightWorkTimeBalance / 60).toFixed(2),
                    key: 'nightWorkTimeBalance',
                    align: alignment
                };
                sumRow.nightWorkTime = {
                    label: (summary.nightWorkTime / 60).toFixed(2),
                    key: 'nightWorkTime',
                    align: alignment
                };
                sumRow.nightWorkCount = {
                    label: (summary.nightWorkCount).toFixed(0),
                    key: 'nightWorkCount',
                    align: alignment
                };

                sumRow.prevMonthOverTime = {
                    label: (summary.prevMonthOverTime / 60).toFixed(2),
                    key: 'prevMonthOverTime',
                    align: alignment
                };
                sumRow.paidOverTime = {
                    label: (summary.paidOverTime / 60).toFixed(2),
                    key: 'paidOverTime',
                    align: alignment
                };
                sumRow.overTimeBalance = {
                    label: (summary.overTimeBalance / 60).toFixed(2),
                    key: 'overTimeBalance',
                    align: alignment
                };
                sumRow.overTime = {label: (summary.overTime / 60).toFixed(2), key: 'overTime', align: alignment};
                sumRow.overTimeCount = {
                    label: (summary.overTimeCount).toFixed(0),
                    key: 'overTimeCount',
                    align: alignment
                };

                sumRow.prevMonthMoreTime = {
                    label: (summary.prevMonthMoreTime / 60).toFixed(2),
                    key: 'prevMonthMoreTime',
                    align: alignment
                };
                sumRow.paidMoreTime = {
                    label: (summary.paidMoreTime / 60).toFixed(2),
                    key: 'paidMoreTime',
                    align: alignment
                };
                sumRow.moreTime = {label: (summary.moreTime / 60).toFixed(2), key: 'moreTime', align: alignment};
                sumRow.moreTimeBalance = {
                    label: (summary.moreTimeBalance / 60).toFixed(2),
                    key: 'moreTime',
                    align: alignment
                };
                sumRow.moreTimeCount = {
                    label: (summary.moreTimeCount).toFixed(0),
                    key: 'moreTimeCount',
                    align: alignment
                };

                sumRow.prevMonthBonusTime = {
                    label: (summary.prevMonthBonusTime / 60).toFixed(2),
                    key: 'prevMonthBonusTime',
                    align: alignment
                };
                sumRow.paidBonusTime = {
                    label: (summary.paidBonusTime / 60).toFixed(2),
                    key: 'paidBonusTime',
                    align: alignment
                };
                sumRow.bonusTime = {label: (summary.bonusTime / 60).toFixed(2), key: 'bonusTime', align: alignment};
                sumRow.bonusTimeBalance = {
                    label: (summary.bonusTimeBalance / 60).toFixed(2),
                    key: 'bonusTime',
                    align: alignment
                };
                sumRow.bonusTimeCount = {
                    label: (summary.bonusTimeCount).toFixed(0),
                    key: 'bonusTimeCount',
                    align: alignment
                };


            }

            return sumRow;

        },
        negativeBalanceSummary() {
            let view = this;
            let alignment = view.useSimpleView ? "center" : "right";
            let summary = {
                employeeId: "positiveSum",
                totalWorkTime: 0,
                vacationTimeBalance: 0,
                holidayTimeBalance: 0,
                workTimeBalance: 0,
                workTimeRegular: 0,
                workTime: 0,
                unproductiveWorkTime: 0,
                holidayAdjustmentTime: 0,
                holidayTime: 0,
                vacationTime: 0,
                sickTime: 0,
                nursingVacationTime: 0,
                educationTime: 0,
                wageContinuationTime: 0,
                paidWorkTime: 0,
                paidHolidayTime: 0,
                nightWorkTime: 0,
                nightWorkCount: 0,
                overTime: 0,
                overTimeCount: 0,
                moreTime: 0,
                moreTimeCount: 0,
                prevMonthTime: 0,
                holidayAdjustmentWorkTime: 0,
                sickWorkTime: 0,
                vacationWorkTime: 0,
                educationWorkTime: 0,
                nursingVacationWorkTime: 0,
                wageContinuationWorkTime: 0,
                paidVacationTime: 0,
                prevMonthOverTime: 0,
                prevMonthNightWorkTime: 0,
                overTimeBalance: 0,
                nightWorkTimeBalance: 0,
                paidOverTime: 0,
                paidNightWorkTime: 0,
                dailyOverTime: 0,
                weeklyOverTime: 0,
                workDayOverTime: 0,
                prevMonthMoreTime: 0,
                moreTimeBalance: 0,
                paidMoreTime: 0,
                miscWorkTime: 0,
                accountingPeriodBalance: 0,
                prevMonthBonusTime: 0,
                bonusTimeBalance: 0,
                paidBonusTime: 0,
                bonusTimeCount: 0,
                bonusTime: 0
            }
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

            let balances = Object.values(this.workBalanceMap).filter(wb => visibleSpots.includes(view.employeeMap[wb.employeeId].spotId));
            balances.forEach(item => {
                let totalWorkTime = 0;

                Object.keys(item).forEach(key => {
                    if (typeof item[key] == "number") {
                        if (!summary[key]) {
                            summary[key] = 0;
                        }
                        if (key == 'prevMonthTime' || key == 'workTime' || key == 'unproductiveWorkTime') {
                            totalWorkTime += item[key];
                        }
                        if (item[key] < 0) {
                            summary[key] += item[key];
                        }
                    }

                })
                if (totalWorkTime < 0) {
                    summary.totalWorkTime + totalWorkTime;
                }

            });

            let sumRow = {}
            if (this.preUsageStartDateMonth) {
                sumRow.name = {label: this.$t('workBalance.payroll.sumNegativeValues'), key: 'name', align: 'left'};
                sumRow.vacationTimeBalance = {
                    label: (summary.vacationTimeBalance / 24 / 60).toFixed(2),
                    key: 'vacationTimeBalance',
                    align: alignment
                };
                sumRow.holidayTimeBalance = {
                    label: (summary.holidayTimeBalance / 60).toFixed(2),
                    key: 'holidayTimeBalance',
                    align: alignment
                };
                sumRow.workTimeBalance = {
                    label: (summary.workTimeBalance / 60).toFixed(2),
                    key: 'workTimeBalance',
                    align: alignment
                };

            } else {
                sumRow.name = {label: this.$t('workBalance.payroll.sumNegativeValues'), key: 'name', align: 'left'};
                sumRow.vacationTimeBalance = {
                    label: (summary.vacationTimeBalance / 24 / 60).toFixed(2),
                    key: 'vacationTimeBalance',
                    align: alignment
                };
                sumRow.holidayTimeBalance = {
                    label: (summary.holidayTimeBalance / 60).toFixed(2),
                    key: 'holidayTimeBalance',
                    align: alignment
                };

                sumRow.workTimeBalance = {
                    label: (summary.workTimeBalance / 60).toFixed(2),
                    key: 'workTimeBalance',
                    align: alignment
                };
                sumRow.totalWorkTime = {
                    label: (summary.totalWorkTime / 60).toFixed(2),
                    key: 'totalWorkTime',
                    align: alignment
                };

                sumRow.prevMonthTime = {
                    label: (summary.prevMonthTime / 60).toFixed(2),
                    key: 'prevMonthTime',
                    align: alignment
                };
                sumRow.workTimeRegular = {
                    label: (summary.workTimeRegular / 60).toFixed(2),
                    key: 'workTimeRegular',
                    align: alignment
                };
                sumRow.workTime = {label: (summary.workTime / 60).toFixed(2), key: 'workTime', align: alignment};
                sumRow.unproductiveWorkTime = {
                    label: (summary.unproductiveWorkTime / 60).toFixed(2),
                    key: 'unproductiveWorkTime',
                    align: alignment
                };
                sumRow.holidayAdjustmentWorkTime = {
                    label: (summary.holidayAdjustmentWorkTime / 60).toFixed(2),
                    key: 'holidayAdjustmentWorkTime',
                    align: alignment
                };

                sumRow.holidayTime = {
                    label: (summary.holidayTime / 60).toFixed(2),
                    key: 'holidayTime',
                    align: alignment
                };
                sumRow.paidVacationTime = {
                    label: (summary.paidVacationTime / 24 / 60).toFixed(2),
                    key: 'paidVacationTime',
                    align: alignment
                };
                sumRow.vacationTime = {
                    label: (summary.vacationTime / 24 / 60).toFixed(2),
                    key: 'vacationTime',
                    align: alignment
                };

                sumRow.sickTime = {label: (summary.sickTime / 24 / 60).toFixed(2), key: 'sickTime', align: alignment};
                sumRow.nursingVacationTime = {
                    label: (summary.nursingVacationTime / 24 / 60).toFixed(2),
                    key: 'nursingVacationTime',
                    align: alignment
                };
                sumRow.educationTime = {
                    label: (summary.educationTime / 24 / 60).toFixed(2),
                    key: 'educationTime',
                    align: alignment
                };
                sumRow.wageContinuationTime = {
                    label: (summary.wageContinuationTime / 24 / 60).toFixed(2),
                    key: 'wageContinuationTime',
                    align: alignment
                };
                sumRow.paidWorkTime = {
                    label: (summary.paidWorkTime / 60).toFixed(2),
                    key: 'paidWorkTime',
                    align: alignment
                };

                sumRow.sickWorkTime = {
                    label: (summary.sickWorkTime / 60).toFixed(2),
                    key: 'sickWorkTime',
                    align: alignment
                };
                sumRow.vacationWorkTime = {
                    label: (summary.vacationWorkTime / 60).toFixed(2),
                    key: 'vacationWorkTime',
                    align: alignment
                };
                sumRow.nursingVacationWorkTime = {
                    label: (summary.nursingVacationWorkTime / 60).toFixed(2),
                    key: 'nursingVacationWorkTime',
                    align: alignment
                };
                sumRow.educationWorkTime = {
                    label: (summary.educationWorkTime / 60).toFixed(2),
                    key: 'educationWorkTime',
                    align: alignment
                };
                sumRow.wageContinuationWorkTime = {
                    label: (summary.wageContinuationWorkTime / 60).toFixed(2),
                    key: 'wageContinuationWorkTime',
                    align: alignment
                };
                sumRow.miscWorkTime = {
                    label: (summary.miscWorkTime / 24 / 60).toFixed(2),
                    key: 'miscWorkTime',
                    align: alignment
                };
                sumRow.accountingPeriodBalance = {
                    label: (summary.accountingPeriodBalance / 60).toFixed(2),
                    key: 'accountingPeriodBalance',
                    align: alignment
                };

                sumRow.paidHolidayTime = {
                    label: (summary.paidHolidayTime / 60).toFixed(2),
                    key: 'paidHolidayTime',
                    align: alignment
                };

                sumRow.prevMonthNightWorkTime = {
                    label: (summary.prevMonthNightWorkTime / 60).toFixed(2),
                    key: 'prevMonthNightWorkTime',
                    align: alignment
                };
                sumRow.paidNightWorkTime = {
                    label: (summary.paidNightWorkTime / 60).toFixed(2),
                    key: 'paidNightWorkTime',
                    align: alignment
                };
                sumRow.nightWorkTimeBalance = {
                    label: (summary.nightWorkTimeBalance / 60).toFixed(2),
                    key: 'nightWorkTimeBalance',
                    align: alignment
                };
                sumRow.nightWorkTime = {
                    label: (summary.nightWorkTime / 60).toFixed(2),
                    key: 'nightWorkTime',
                    align: alignment
                };
                sumRow.nightWorkCount = {
                    label: (summary.nightWorkCount).toFixed(0),
                    key: 'nightWorkCount',
                    align: alignment
                };

                sumRow.prevMonthOverTime = {
                    label: (summary.prevMonthOverTime / 60).toFixed(2),
                    key: 'prevMonthOverTime',
                    align: alignment
                };
                sumRow.paidOverTime = {
                    label: (summary.paidOverTime / 60).toFixed(2),
                    key: 'paidOverTime',
                    align: alignment
                };
                sumRow.overTimeBalance = {
                    label: (summary.overTimeBalance / 60).toFixed(2),
                    key: 'overTimeBalance',
                    align: alignment
                };
                sumRow.overTime = {label: (summary.overTime / 60).toFixed(2), key: 'overTime', align: alignment};
                sumRow.overTimeCount = {
                    label: (summary.overTimeCount).toFixed(0),
                    key: 'overTimeCount',
                    align: alignment
                };

                sumRow.prevMonthMoreTime = {
                    label: (summary.prevMonthMoreTime / 60).toFixed(2),
                    key: 'prevMonthMoreTime',
                    align: alignment
                };
                sumRow.paidMoreTime = {
                    label: (summary.paidMoreTime / 60).toFixed(2),
                    key: 'paidMoreTime',
                    align: alignment
                };
                sumRow.moreTime = {label: (summary.moreTime / 60).toFixed(2), key: 'moreTime', align: alignment};
                sumRow.moreTimeBalance = {
                    label: (summary.moreTimeBalance / 60).toFixed(2),
                    key: 'moreTime',
                    align: alignment
                };
                sumRow.moreTimeCount = {
                    label: (summary.moreTimeCount).toFixed(0),
                    key: 'moreTimeCount',
                    align: alignment
                };

                sumRow.prevMonthBonusTime = {
                    label: (summary.prevMonthBonusTime / 60).toFixed(2),
                    key: 'prevMonthBonusTime',
                    align: alignment
                };
                sumRow.paidBonusTime = {
                    label: (summary.paidBonusTime / 60).toFixed(2),
                    key: 'paidBonusTime',
                    align: alignment
                };
                sumRow.bonusTime = {label: (summary.bonusTime / 60).toFixed(2), key: 'bonusTime', align: alignment};
                sumRow.bonusTimeBalance = {
                    label: (summary.bonusTimeBalance / 60).toFixed(2),
                    key: 'bonusTime',
                    align: alignment
                };
                sumRow.bonusTimeCount = {
                    label: (summary.bonusTimeCount).toFixed(0),
                    key: 'bonusTimeCount',
                    align: alignment
                };


            }

            return sumRow;

        },
        balanceSummary() {
            let view = this;
            let alignment = view.useSimpleView ? "center" : "right";
            let summary = {
                employeeId: "positiveSum",
                totalWorkTime: 0,
                vacationTimeBalance: 0,
                holidayTimeBalance: 0,
                workTimeBalance: 0,
                workTimeRegular: 0,
                workTime: 0,
                unproductiveWorkTime: 0,
                holidayAdjustmentTime: 0,
                holidayTime: 0,
                vacationTime: 0,
                sickTime: 0,
                nursingVacationTime: 0,
                educationTime: 0,
                wageContinuationTime: 0,
                paidWorkTime: 0,
                paidHolidayTime: 0,
                nightWorkTime: 0,
                nightWorkCount: 0,
                overTime: 0,
                overTimeCount: 0,
                moreTime: 0,
                moreTimeCount: 0,
                prevMonthTime: 0,
                holidayAdjustmentWorkTime: 0,
                sickWorkTime: 0,
                vacationWorkTime: 0,
                educationWorkTime: 0,
                nursingVacationWorkTime: 0,
                wageContinuationWorkTime: 0,
                paidVacationTime: 0,
                prevMonthOverTime: 0,
                prevMonthNightWorkTime: 0,
                overTimeBalance: 0,
                nightWorkTimeBalance: 0,
                paidOverTime: 0,
                paidNightWorkTime: 0,
                dailyOverTime: 0,
                weeklyOverTime: 0,
                workDayOverTime: 0,
                prevMonthMoreTime: 0,
                moreTimeBalance: 0,
                paidMoreTime: 0,
                miscWorkTime: 0,
                accountingPeriodBalance: 0,
                prevMonthBonusTime: 0,
                bonusTimeBalance: 0,
                paidBonusTime: 0,
                bonusTimeCount: 0,
                bonusTime: 0
            }
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

            let balances = Object.values(this.workBalanceMap).filter(wb => visibleSpots.includes(view.employeeMap[wb.employeeId].spotId));
            balances.forEach(item => {
                let totalWorkTime = 0;

                Object.keys(item).forEach(key => {
                    if (typeof item[key] == "number") {
                        if (!summary[key]) {
                            summary[key] = 0;
                        }
                        if (key == 'prevMonthTime' || key == 'workTime' || key == 'unproductiveWorkTime') {
                            totalWorkTime += item[key];
                        }
                        summary[key] += item[key];

                    }

                })
                summary.totalWorkTime += totalWorkTime;

            });

            let sumRow = {}
            if (this.preUsageStartDateMonth) {
                sumRow.name = {label: this.$t('global.ui.sum'), key: 'name', align: 'left'};
                sumRow.vacationTimeBalance = {
                    label: (summary.vacationTimeBalance / 24 / 60).toFixed(2),
                    key: 'vacationTimeBalance',
                    align: alignment
                };
                sumRow.holidayTimeBalance = {
                    label: (summary.holidayTimeBalance / 60).toFixed(2),
                    key: 'holidayTimeBalance',
                    align: alignment
                };
                sumRow.workTimeBalance = {
                    label: (summary.workTimeBalance / 60).toFixed(2),
                    key: 'workTimeBalance',
                    align: alignment
                };

            } else {
                sumRow.name = {label: this.$t('global.ui.sum'), key: 'name', align: 'left'};
                sumRow.vacationTimeBalance = {
                    label: (summary.vacationTimeBalance / 24 / 60).toFixed(2),
                    key: 'vacationTimeBalance',
                    align: alignment
                };
                sumRow.holidayTimeBalance = {
                    label: (summary.holidayTimeBalance / 60).toFixed(2),
                    key: 'holidayTimeBalance',
                    align: alignment
                };

                sumRow.workTimeBalance = {
                    label: (summary.workTimeBalance / 60).toFixed(2),
                    key: 'workTimeBalance',
                    align: alignment
                };
                sumRow.totalWorkTime = {
                    label: (summary.totalWorkTime / 60).toFixed(2),
                    key: 'totalWorkTime',
                    align: alignment
                };

                sumRow.prevMonthTime = {
                    label: (summary.prevMonthTime / 60).toFixed(2),
                    key: 'prevMonthTime',
                    align: alignment
                };
                sumRow.workTimeRegular = {
                    label: (summary.workTimeRegular / 60).toFixed(2),
                    key: 'workTimeRegular',
                    align: alignment
                };
                sumRow.workTime = {label: (summary.workTime / 60).toFixed(2), key: 'workTime', align: alignment};
                sumRow.unproductiveWorkTime = {
                    label: (summary.unproductiveWorkTime / 60).toFixed(2),
                    key: 'unproductiveWorkTime',
                    align: alignment
                };
                sumRow.holidayAdjustmentWorkTime = {
                    label: (summary.holidayAdjustmentWorkTime / 60).toFixed(2),
                    key: 'holidayAdjustmentWorkTime',
                    align: alignment
                };

                sumRow.holidayTime = {
                    label: (summary.holidayTime / 60).toFixed(2),
                    key: 'holidayTime',
                    align: alignment
                };
                sumRow.paidVacationTime = {
                    label: (summary.paidVacationTime / 24 / 60).toFixed(2),
                    key: 'paidVacationTime',
                    align: alignment
                };
                sumRow.vacationTime = {
                    label: (summary.vacationTime / 24 / 60).toFixed(2),
                    key: 'vacationTime',
                    align: alignment
                };

                sumRow.sickTime = {label: (summary.sickTime / 24 / 60).toFixed(2), key: 'sickTime', align: alignment};
                sumRow.nursingVacationTime = {
                    label: (summary.nursingVacationTime / 24 / 60).toFixed(2),
                    key: 'nursingVacationTime',
                    align: alignment
                };
                sumRow.educationTime = {
                    label: (summary.educationTime / 24 / 60).toFixed(2),
                    key: 'educationTime',
                    align: alignment
                };
                sumRow.wageContinuationTime = {
                    label: (summary.wageContinuationTime / 24 / 60).toFixed(2),
                    key: 'wageContinuationTime',
                    align: alignment
                };
                sumRow.paidWorkTime = {
                    label: (summary.paidWorkTime / 60).toFixed(2),
                    key: 'paidWorkTime',
                    align: alignment
                };

                sumRow.sickWorkTime = {
                    label: (summary.sickWorkTime / 60).toFixed(2),
                    key: 'sickWorkTime',
                    align: alignment
                };
                sumRow.vacationWorkTime = {
                    label: (summary.vacationWorkTime / 60).toFixed(2),
                    key: 'vacationWorkTime',
                    align: alignment
                };
                sumRow.nursingVacationWorkTime = {
                    label: (summary.nursingVacationWorkTime / 60).toFixed(2),
                    key: 'nursingVacationWorkTime',
                    align: alignment
                };
                sumRow.educationWorkTime = {
                    label: (summary.educationWorkTime / 60).toFixed(2),
                    key: 'educationWorkTime',
                    align: alignment
                };
                sumRow.wageContinuationWorkTime = {
                    label: (summary.wageContinuationWorkTime / 60).toFixed(2),
                    key: 'wageContinuationWorkTime',
                    align: alignment
                };
                sumRow.miscWorkTime = {
                    label: (summary.miscWorkTime / 24 / 60).toFixed(2),
                    key: 'miscWorkTime',
                    align: alignment
                };
                sumRow.accountingPeriodBalance = {
                    label: (summary.accountingPeriodBalance / 60).toFixed(2),
                    key: 'accountingPeriodBalance',
                    align: alignment
                };

                sumRow.paidHolidayTime = {
                    label: (summary.paidHolidayTime / 60).toFixed(2),
                    key: 'paidHolidayTime',
                    align: alignment
                };

                sumRow.prevMonthNightWorkTime = {
                    label: (summary.prevMonthNightWorkTime / 60).toFixed(2),
                    key: 'prevMonthNightWorkTime',
                    align: alignment
                };
                sumRow.paidNightWorkTime = {
                    label: (summary.paidNightWorkTime / 60).toFixed(2),
                    key: 'paidNightWorkTime',
                    align: alignment
                };
                sumRow.nightWorkTimeBalance = {
                    label: (summary.nightWorkTimeBalance / 60).toFixed(2),
                    key: 'nightWorkTimeBalance',
                    align: alignment
                };
                sumRow.nightWorkTime = {
                    label: (summary.nightWorkTime / 60).toFixed(2),
                    key: 'nightWorkTime',
                    align: alignment
                };
                sumRow.nightWorkCount = {
                    label: (summary.nightWorkCount).toFixed(0),
                    key: 'nightWorkCount',
                    align: alignment
                };

                sumRow.prevMonthOverTime = {
                    label: (summary.prevMonthOverTime / 60).toFixed(2),
                    key: 'prevMonthOverTime',
                    align: alignment
                };
                sumRow.paidOverTime = {
                    label: (summary.paidOverTime / 60).toFixed(2),
                    key: 'paidOverTime',
                    align: alignment
                };
                sumRow.overTimeBalance = {
                    label: (summary.overTimeBalance / 60).toFixed(2),
                    key: 'overTimeBalance',
                    align: alignment
                };
                sumRow.overTime = {label: (summary.overTime / 60).toFixed(2), key: 'overTime', align: alignment};
                sumRow.overTimeCount = {
                    label: (summary.overTimeCount).toFixed(0),
                    key: 'overTimeCount',
                    align: alignment
                };

                sumRow.prevMonthMoreTime = {
                    label: (summary.prevMonthMoreTime / 60).toFixed(2),
                    key: 'prevMonthMoreTime',
                    align: alignment
                };
                sumRow.paidMoreTime = {
                    label: (summary.paidMoreTime / 60).toFixed(2),
                    key: 'paidMoreTime',
                    align: alignment
                };
                sumRow.moreTime = {label: (summary.moreTime / 60).toFixed(2), key: 'moreTime', align: alignment};
                sumRow.moreTimeBalance = {
                    label: (summary.moreTimeBalance / 60).toFixed(2),
                    key: 'moreTime',
                    align: alignment
                };
                sumRow.moreTimeCount = {
                    label: (summary.moreTimeCount).toFixed(0),
                    key: 'moreTimeCount',
                    align: alignment
                };

                sumRow.prevMonthBonusTime = {
                    label: (summary.prevMonthBonusTime / 60).toFixed(2),
                    key: 'prevMonthBonusTime',
                    align: alignment
                };
                sumRow.paidBonusTime = {
                    label: (summary.paidBonusTime / 60).toFixed(2),
                    key: 'paidBonusTime',
                    align: alignment
                };
                sumRow.bonusTime = {label: (summary.bonusTime / 60).toFixed(2), key: 'bonusTime', align: alignment};
                sumRow.bonusTimeBalance = {
                    label: (summary.bonusTimeBalance / 60).toFixed(2),
                    key: 'bonusTime',
                    align: alignment
                };
                sumRow.bonusTimeCount = {
                    label: (summary.bonusTimeCount).toFixed(0),
                    key: 'bonusTimeCount',
                    align: alignment
                };


            }

            return sumRow;

        },
        monthTimeRegular() {
            return Math.round(this.employeeType.weekTimeRegular * 4.325);
        },
        currentMonthFrom() {
            let rFrom = new Date(this.rosterFromTo.from);
            let rTo = new Date(this.rosterFromTo.to);
            let diffTime = Math.abs(rTo - rFrom);
            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let diffDaysHalf = Math.abs(diffDays / 2);
            rFrom.setDate(rFrom.getDate() + diffDaysHalf);
            let from = this.$helpers.getMomentFromValuesUTC(rFrom.getFullYear(), rFrom.getMonth(), 1);
            return from;
        },
        currentMonthFromTZ() {

            let from = this.$helpers.getMomentFromValuesTZ(this.currentMonthFrom.year(), this.currentMonthFrom.month(), 1);
            return from;
        },
        currentMonthTo() {
            if (this.currentMonthFrom) {
                let to = this.currentMonthFrom.clone().add(1, 'month');
                return to;
            } else {
                return null;
            }

        },
        currentMonthToTZ() {
            if (this.currentMonthFromTZ) {
                let to = this.currentMonthFromTZ.clone().add(1, 'month');
                return to;
            } else {
                return null;
            }

        },
        monthDisplay: function () {
            if (this.timeFrameStart != null) {
                return this.timeFrameStart.format('MMM YYYY');
            } else {
                return '-';
            }
        },
        employeeDateActualShiftMap() {
            let map = {};
            Object.values(this.actualShiftMap).forEach(entry => {
                if (!map[entry.employeeId]) {
                    map[entry.employeeId] = {};
                }
                let employeeEntry = map[entry.employeeId];
                let dateKey = this.$helpers.getMomentFromStringTZ(entry.from).format("YYYY-MM-DD");
                if (!employeeEntry[dateKey]) {
                    employeeEntry[dateKey] = [];
                }
                employeeEntry[dateKey].push(entry);
            })
            return map;
        },
        employeeDateActualShiftMarkedMap() {
            let map = {};
            Object.values(this.actualShiftMap).forEach(entry => {
                //if(!entry.endMissing){
                if (!map[entry.employeeId]) {
                    map[entry.employeeId] = {};
                }
                let employeeEntry = map[entry.employeeId];
                let dateKey;
                if (entry.planFrom) {
                    dateKey = this.$helpers.getMomentFromStringTZ(entry.planFrom).format("YYYY-MM-DD");

                } else {
                    dateKey = this.$helpers.getMomentFromStringTZ(entry.from).format("YYYY-MM-DD");
                }

                employeeEntry[dateKey] = true;
                //}


            })
            return map;
        },
        currentMonthUTC() {
            if (this.currentMonthFrom != null) {
                return this.currentMonthFrom;
            } else {
                return null;
            }
        },
        actualShiftBreakMap() {
            let map = {};
            Object.values(this.actualBreakMap).filter(entry => this.actualShiftMap[entry.shiftId] != null).forEach(entry => {
                if (!map[entry.shiftId]) {
                    map[entry.shiftId] = [];
                }
                map[entry.shiftId].push(entry);
            });
            return map;
        },
        validEmployeeOptions() {
            let result = [];
            const employeeMap = this.employeeMap;
            const validEmployeeMap = this.validEmployeeMap;
            this.employeeOptions.forEach(id => {
                if (validEmployeeMap[id] && employeeMap[id]) {
                    result.push(employeeMap[id]);
                }
            });
            return result;
        },
    },
    watch: {
        rosterFromTo(newVal, oldVal) {
            if (newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
                console.log("CALLING REFRESH FROM ROSTERFROMTO")
                this.refresh(true, true, false);
            }
        },
        storeId(newVal, oldVal) {
            if (newVal != oldVal) {
                console.log("Changed storeId: " + newVal);
                console.log("CALLING REFRESH FROM STOREID")
                this.refresh(true, true, false);
                this.readyFlag = false;
            }
        }


    },
    // methods that implement data logic.
    methods: {
        GetLabelIconColor(data) {
            return '#6d8d23';
        },
        GetEmployeeIconColor(data) {
            let color = data.confirmed ? "#99af65" : data.valid ? "#1e9e9a" : "yellow"
            return {boxShadow: 'inset 0 0 0 1px white', background: color}
        },
        refresh: function (force = false, calculateInvalid = false, calculateForMZConfirm = false, finishedCallback = null) {

            if (this.currentMonthFrom && this.currentMonthTo && !this.loading) {
                let view = this;
                this.loading = true;
                view.$store.commit("setAllowContentSwitch", {allowContentSwitch: false});
                let employeePayload = {
                    ids: []
                };
                let employeeRemoteIds = [];
                return view.$helpers.GetUiDataMap()
                    .then(response => {
                        return view.$helpers.GetBonusPaymentSettingsMap(force);
                    })
                    .then(response => {
                        return view.$helpers.GetExportSettingsMap(force);
                    }).then(response => {
                        return view.$helpers.GetAccountingPeriodSettingsMap(force);
                    }).then(response => {
                        return view.$helpers.GetContractExitSettingMap(force);
                    }).then(response => {
                        return view.$helpers.GetSpotMap(force);
                    }).then(response => {
                        view.LoadFilterDropdown();
                        return view.loadEarliestUnconfirmed()
                    }).then(response => {
                        view.updateEarliestUnconfirmed(response.data);
                        return view.loadNextValidEmployeeWorkBalanceDates();
                    }).then(response => {
                        view.updateNextValidEmployeeWorkBalanceDates(response.data);
                        return view.loadActiveAtEmployees()
                    }).then(response => {
                        view.updateEmployees(response.data);

                        for (let i = 0; i < response.data.length; i++) {
                            let employee = response.data[i];
                            employeePayload.ids.push(employee.id);
                            if (employee.remoteId != null) {
                                employeeRemoteIds.push(employee.remoteId);
                            }

                        }
                        view.$helpers.GetEmploymentModelMap(force);
                        return view.loadEmployeeWorkBalances(employeePayload)

                    }).then(response => {
                        view.updateEmployeeWorkBalances(response.data);
                        if (view.storeSettings.useAvgWorkTimeForPrefs) {
                            return view.$helpers.GetAvgEmployeeWorktimeMap(employeeRemoteIds, force);
                        } else {
                            return new Promise((resolve, reject) => {
                                resolve(true);
                            });
                        }
                    }).then(response => {

                        return view.init(force);
                    }).then(response => {

                        view.$store.commit("setAllowContentSwitch", {allowContentSwitch: true});
                        view.loading = false;
                        if (finishedCallback != null) finishedCallback();
                        if (calculateForMZConfirm) {
                            view.OpenMZRecalculateModal();
                        } else if (calculateInvalid) {
                            view.calculateInvalidWorkBalances(false);
                        }
                    }).catch(function (error) {
                        view.loading = false;
                        view.$store.commit("setAllowContentSwitch", {allowContentSwitch: true});
                        console.log(error)
                    });
            }
        },
        init: function (force = false) {
            this.initMonthly();
            if (this.readyFlag && !force) {
                return new Promise((resolve, reject) => {
                    resolve(true);
                });
            } else {
                if (this.currentMonthFrom && this.currentMonthTo) {
                    let view = this;
                    return view.loadActualShifts()
                        .then(result => {
                            view.updateActualShifts(result);
                            return view.loadActualBreaks();
                        }).then(result => {
                            view.updateActualBreaks(result);
                            return view.loadHolidays();
                        }).then(response => {
                            view.updateHolidays(response.data);
                            return view.loadValidEmployeeWorkBalanceEmployees();
                        }).then(response => {
                            view.updateValidEmployeeWorkBalanceEmployees(response.data);
                            return view.loadActiveAtEmployees();
                        }).then(response => {
                            let employeePayload = {ids: []};
                            for (let i = 0; i < response.data.length; i++) {
                                employeePayload.ids.push(response.data[i].id);
                            }
                            view.updateEmployees(response.data);

                            return view.loadPlanShifts().then(result => {
                                view.updateEmployeePlanShifts(result);
                                return view.loadEmployeePreferences(employeePayload);
                            }).then(response => {
                                view.updateEmployeePreferences(response.data);
                                return view.$helpers.GetAllowedContractMap(force);
                            }).then(response => {

                                return view.$helpers.GetCollectiveContractMap(force);
                            }).then(response => {
                                return view.loadEmployeeContracts(employeePayload, view.currentMonthFromTZ, view.currentMonthToTZ);
                            }).then(response => {
                                view.updateEmployeeContracts(response.data);
                                return view.loadNextMonthEmployeeContracts(employeePayload);
                            }).then(response => {
                                view.updateNextMonthEmployeeContracts(response.data);
                                return view.loadPreviousMonthEmployeeWorkBalances(employeePayload);
                            }).then(response => {
                                view.updatePreviousMonthEmployeeWorkBalances(response.data);
                                return view.loadLatestEmployeeWorkBalancesWithAccountingPeriodApplied();

                            }).then(response => {
                                view.updateLatestEmployeeAccPeriod(response.data);
                                view.readyFlag = true;
                                return new Promise((resolve, reject) => {
                                    resolve(true);
                                });
                            });
                        })
                        .catch(function (error) {
                            console.log(error);
                            return new Promise((resolve, reject) => {
                                reject("Error loading data necessary to create employeeworkbalances");
                            })
                        });
                } else {
                    return new Promise((resolve, reject) => {
                        reject("Not ready to create workbalances");
                    })
                }
            }


        },
        SwitchTableDetailState(state) {
            this.tableDetailState = this.tableDetailState == 0 ? state : 0;
        },
        calculateAvailableMonths() {
            let m = {};
            let maxPriority = 3;
            let minPriority = 1;
            for (let i = minPriority; i <= maxPriority; i++) {
                m[i] = [];
                let forbidden = Object.values(this.accountingPeriodSettingsMap).filter(aps => aps.priority == i).map(aps => aps.month);
                this.months.forEach(r => {
                    if (!forbidden.includes(r.value)) {
                        m[i].push(Object.assign({}, r));
                    }
                })
            }

            return m;
        },
        AddAccountingPeriodSetting(priority = null) {
            let view = this;

            let dataFillState = view.$helpers.GetAccountingPeriodSettingState(null, null, priority, this.calculateAvailableMonths(), this.contractTypes, this.employeeCategories, this.employmentTypes, this.employeeLevels, this.storeSettings, false, null, (item) => {
                let temp = Object.assign({}, item);
                delete temp.months;
                let items = [];
                item.months.forEach(m => {
                    let r = Object.assign({}, temp);
                    r.month = m;
                    items.push(r);
                })
                view.createMultiAccountingPeriodSetting(items);

            });

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: dataFillState,
                header: this.$t('workBalance.payroll.addNewConfig'),
                width: "900px",
                expanded: true,
                centered: true
            });
        },
        createMultiAccountingPeriodSetting: function (items) {
            let view = this;
            let url = '/api/sec/accountingperiodsetting/multi';

            let params = {
                storeId: this.$store.state.storeId,
            };

            let payload = {requests: []}
            items.forEach(item => {
                let req = {
                    minWeekTimeRegular: item.minWeekTimeRegular,
                    maxWeekTimeRegular: item.maxWeekTimeRegular,
                    month: item.month,
                    useContractTypes: item.useContractTypes,
                    contractTypes: item.contractTypes,
                    employeeCategories: item.employeeCategories,
                    employmentTypes: item.employmentTypes,
                    employeeLevels: item.employeeLevels,
                    useWorkTimeFactor: item.useWorkTimeFactor,
                    compensatePositiveWorkTime: item.compensatePositiveWorkTime,
                    compensateNegativeWorkTime: item.compensateNegativeWorkTime,
                    compensateToContract: item.compensateToContract,
                    useHolidayFactor: item.useHolidayFactor,
                    useHolidayFactorForPositive: item.useHolidayFactorForPositive,
                    useHolidayFactorForNegative: item.useHolidayFactorForNegative,
                    compensatePositiveHolidays: item.compensatePositiveHolidays,
                    compensateNegativeHolidays: item.compensateNegativeHolidays,
                    compensateNightWorkTime: item.compensateNightWorkTime,
                    overTimeMode: item.overTimeMode,
                    useOvertimeFactorForPositive: item.useOvertimeFactorForPositive,
                    useOvertimeFactorForNegative: item.useOvertimeFactorForNegative,
                    useDeltaOvertimeFactor: item.useDeltaOvertimeFactor,
                    compensateWorkTimeWithOvertime: item.compensateWorkTimeWithOvertime,
                    compensateNegativeWorkTimeWithOvertime: item.compensateNegativeWorkTimeWithOvertime,
                    applyToUnderage: item.applyToUnderage,
                    conditionJoin: item.conditionJoin,
                    compensateMoreTime: item.compensateMoreTime,
                    compensateBonusTime: item.compensateBonusTime,
                    roundUpVacationTime: item.roundUpVacationTime,
                    compensateVacationTime: item.compensateVacationTime,
                    priority: item.priority,
                    workTimeFactor: item.workTimeFactor,
                    moreTimeFactor: item.moreTimeFactor,
                    endsAccountingPeriod: item.endsAccountingPeriod,
                    contractTypeFactorExemption1: item.contractTypeFactorExemption1,
                    contractTypeFactorExemption2: item.contractTypeFactorExemption2,
                    contractTypeFactorExemption3: item.contractTypeFactorExemption3,
                }
                payload.requests.push(req);
            })

            if (payload.requests.length > 0) {
                this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    let recalc = false;
                    if (response.data.length > 0) {
                        response.data.forEach(r => {
                            if (r.month == view.currentMonthFrom.month()) {
                                recalc = true;
                            }
                            view.$set(view.accountingPeriodSettingsMap, '' + r.id, r);
                        })
                        view.$store.commit("setAccountingPeriodSettingsMap", {accountingPeriodSettingsMap: view.accountingPeriodSettingsMap});
                    }
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('workBalance.payroll.addedNewConfig'));
                    if (recalc) {
                        let employeeIds = Object.values(view.workBalanceMap).filter(wb => !wb.confirmed).map(wb => wb.employeeId);
                        let mode = view.mzConfirmed ? 2 : 1;

                        view.doMultiCreate(employeeIds, false, mode, false, null);
                    }


                }).catch(function (error) {

                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.configError'));
                })
            }


        },
        EditAccountingPeriodSetting(setting) {
            let view = this;

            let dataFillState = view.$helpers.GetAccountingPeriodSettingState(setting, setting.month, setting.priority, this.calculateAvailableMonths(), this.contractTypes, this.employeeCategories, this.employmentTypes, this.employeeLevels, this.storeSettings, false, null, (item) => {
                view.updateAccountingPeriodSetting(item);
            });
            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: dataFillState,
                header: this.$t('store.settings.editConfig'),
                width: "900px",
                expanded: true,
                centered: true
            });
        },
        updateAccountingPeriodSetting(item) {
            let view = this;
            let url = '/api/sec/accountingperiodsetting';

            let params = {
                storeId: this.$store.state.storeId,
            };
            let payload = {
                id: item.id,
                minWeekTimeRegular: item.minWeekTimeRegular,
                maxWeekTimeRegular: item.maxWeekTimeRegular,
                useContractTypes: item.useContractTypes,
                contractTypes: item.contractTypes,
                employeeCategories: item.employeeCategories,
                employmentTypes: item.employmentTypes,
                employeeLevels: item.employeeLevels,
                useWorkTimeFactor: item.useWorkTimeFactor,
                compensatePositiveWorkTime: item.compensatePositiveWorkTime,
                compensateNegativeWorkTime: item.compensateNegativeWorkTime,
                compensateToContract: item.compensateToContract,

                useHolidayFactor: item.useHolidayFactor,
                useHolidayFactorForPositive: item.useHolidayFactorForPositive,
                useHolidayFactorForNegative: item.useHolidayFactorForNegative,
                compensatePositiveHolidays: item.compensatePositiveHolidays,
                compensateNegativeHolidays: item.compensateNegativeHolidays,
                compensateNightWorkTime: item.compensateNightWorkTime,
                overTimeMode: item.overTimeMode,
                useOvertimeFactorForPositive: item.useOvertimeFactorForPositive,
                useOvertimeFactorForNegative: item.useOvertimeFactorForNegative,
                useDeltaOvertimeFactor: item.useDeltaOvertimeFactor,

                compensateWorkTimeWithOvertime: item.compensateWorkTimeWithOvertime,
                compensateNegativeWorkTimeWithOvertime: item.compensateNegativeWorkTimeWithOvertime,
                applyToUnderage: item.applyToUnderage,
                conditionJoin: item.conditionJoin,
                compensateMoreTime: item.compensateMoreTime,
                compensateBonusTime: item.compensateBonusTime,
                roundUpVacationTime: item.roundUpVacationTime,
                compensateVacationTime: item.compensateVacationTime,
                priority: item.priority,
                workTimeFactor: item.workTimeFactor,
                moreTimeFactor: item.moreTimeFactor,
                endsAccountingPeriod: item.endsAccountingPeriod,
                contractTypeFactorExemption1: item.contractTypeFactorExemption1,
                contractTypeFactorExemption2: item.contractTypeFactorExemption2,
                contractTypeFactorExemption3: item.contractTypeFactorExemption3,
                updateFields: ["minWeekTimeRegular", "maxWeekTimeRegular", "useContractTypes", "employeeCategories", "employmentTypes", "employeeLevels",
                    "contractTypes", "useWorkTimeFactor",
                    "compensatePositiveWorkTime", "compensateNegativeWorkTime", "compensateToContract", "compensatePositiveHolidays",
                    "compensateNegativeHolidays", "compensateNightWorkTime", "overTimeMode", "useOvertimeFactorForPositive",
                    "useOvertimeFactorForNegative", "useHolidayFactor", "useHolidayFactorForPositive",
                    "useHolidayFactorForNegative", "compensateWorkTimeWithOvertime", "applyToUnderage", "conditionJoin",
                    "compensateMoreTime", "compensateBonusTime", "compensateNegativeWorkTimeWithOvertime", "priority",
                    "roundUpVacationTime", "compensateVacationTime", "useDeltaOvertimeFactor", "workTimeFactor", "moreTimeFactor",
                    "endsAccountingPeriod",
                    "contractTypeFactorExemption1", "contractTypeFactorExemption2", "contractTypeFactorExemption3"
                ]
            }

            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$store.commit("setAccountingPeriodSettingsMapEntry", item);

                view.$helpers.success(view.$t('global.notifications.success'), view.$t('workBalance.payroll.editedConfig'));
                if (item.month == view.currentMonthFrom.month()) {
                    let employeeIds = Object.values(view.workBalanceMap).filter(wb => !wb.confirmed).map(wb => wb.employeeId);
                    let mode = view.mzConfirmed ? 2 : 1;
                    view.doMultiCreate(employeeIds, false, mode, false, null);
                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.editError'));
            })
        },
        DeleteAccountingPeriodSetting(data) {
            let view = this;
            let month = this.$helpers.getMomentTZ().month(data.month).format("MMMM")
            view.$helpers.OpenAlert({
                header: this.$t('workBalance.payroll.deleteConfig'),
                description: this.$t('workBalance.payroll.deleteQuery') + month + '?',
                callbackAccept: (alert) => {
                    alert.hidden = true;
                    view.deleteAccountingPeriodSetting(data);
                }
            });
        },
        deleteAccountingPeriodSetting: function (data) {

            let view = this;
            let url = '/api/sec/accountingperiodsetting';

            let params = {
                storeId: this.$store.state.storeId,
                id: data.id
            };


            this.axios({
                method: 'delete',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.$store.commit("deleteAccountingPeriodSettingsMapEntry", {id: data.id});
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.notifications.settingDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deleteFailed'));
            })

        },
        OpenFilterDropdown($event) {
            var view = this;
            let target;
            if ($event != undefined) target = $event.currentTarget;


            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'list',
                componentState: {
                    entries: view.filterDropdownOptions,
                },
                remainAfterSelect: true,
                pointerDirection: -1,
                iconsLeft: true,
                selectCallback: function ($event, item, dropdown) {
                    item.toggled = !item.toggled;

                    if (item.all) {
                        view.filterDropdownOptions.forEach(option => {
                            option.toggled = item.toggled;
                        })
                    }
                    if (item.isMain && item.toggled) {
                        view.filterDropdownOptions.filter(option => option.unitId == item.unitId).forEach(option => {
                            option.toggled = item.toggled;
                        })
                    }
                    view.filterDropdownOptions = view.filterDropdownOptions.slice();
                },
            });
        },
        LoadFilterDropdown() {

            let filterDropdownOptions = [];
            Object.values(this.spotMap).sort((a, b) => {
                let aMainSpot = Object.values(this.spotMap).find(spot => spot.unitId == a.unitId && spot.isMain);
                let bMainSpot = Object.values(this.spotMap).find(spot => spot.unitId == b.unitId && spot.isMain);
                if (aMainSpot.id == bMainSpot.id) {
                    if (a.isMain && !b.isMain) {
                        return -1;
                    } else if (!a.isMain && b.isMain) {
                        return 1;
                    } else {
                        return a.priority - b.priority;
                    }
                } else {
                    return aMainSpot.priority - bMainSpot.priority
                }

            }).forEach(function (spot) {
                let option = {
                    label: spot.name,
                    toggled: true,
                    color: spot.color,
                    id: spot.id,
                    isMain: spot.isMain,
                    unitId: spot.unitId,
                    bold: spot.isMain
                };
                filterDropdownOptions.push(option);
            });
            filterDropdownOptions.push({
                label: this.$t('global.ui.unassigned'),
                toggled: true,
                color: "#eeeeee",
                id: null
            });
            filterDropdownOptions.push({
                label: this.$t('global.ui.all'),
                toggled: true,
                all: true,
                color: "#eeeeee",
                id: -1
            });
            this.filterDropdownOptions = filterDropdownOptions;
        },
        OpenMenuDetails($event, state) {
            let view = this;

            this.$helpers.OpenPopup({
                type: 'burgermenu',
                componentState: state,
                listStyle: true,
                noScroll: true,
                pointerDirection: 0,
                elRelative: $event.currentTarget,
                pointerOffset: -15,
            });
        },
        headerMapMinutesToHoursValueEntry(key, label, editable = false, tooltip = null, bgcolor = null) {
            let changeFunc = undefined;
            if (editable) {
                changeFunc = ($event, rowData, headerMap) => {
                    this.dataUpdatedByUser($event, rowData, headerMap, 60)
                };
            }
            return this.headerMapEntry(key, label, (i) => {
                return (i[key] / 60).toFixed(2)
            }, false, 'right', 'left', changeFunc, tooltip, bgcolor);
        },
        headerMapMinutesToDaysValueEntry(key, label, editable = false, tooltip = null, bgcolor = null) {
            let changeFunc = undefined;
            if (editable) {
                changeFunc = ($event, rowData, headerMap) => {
                    this.dataUpdatedByUser($event, rowData, headerMap, 1440)
                };
            }
            return this.headerMapEntry(key, label, (i) => {
                return (i[key] / 24 / 60).toFixed(2)
            }, false, 'right', 'left', changeFunc, tooltip, bgcolor);
        },
        headerMapIntValueEntry(key, label, editable = false, tooltip = null, bgcolor = null) {
            let changeFunc = undefined;
            if (editable) {
                changeFunc = ($event, rowData, headerMap) => {
                    this.dataUpdatedByUser($event, rowData, headerMap)
                };
            }
            return this.headerMapEntry(key, label, (i) => {
                return (i[key]).toFixed(0)
            }, false, 'right', 'left', changeFunc, tooltip, bgcolor);
        },
        headerMapFloatValueEntry(key, label, editable = false, tooltip = null, divider, fixed, bgcolor = null) {
            let changeFunc = undefined;
            if (editable) {
                changeFunc = ($event, rowData, headerMap) => {
                    this.dataUpdatedByUser($event, rowData, headerMap)
                };
            }
            return this.headerMapEntry(key, label, (i) => {
                return ((i[key]) / divider).toFixed(fixed)
            }, false, 'right', 'left', changeFunc, tooltip, bgcolor);
        },
        headerMapEntry(key, label, mapFunc, sort = false, align = 'left', alignHeaderLabel = 'left', changeFunc, tooltip = null, bgcolor = null) {
            return {
                'key': key,
                'label': label,
                'sort': sort,
                'align': align,
                'alignHeaderLabel': alignHeaderLabel,
                bgcolor: bgcolor,
                tooltip: tooltip,
                DisplayLabel: mapFunc,
                OnChange: changeFunc
            };
        },
        initMonthly() {
            this.timeFrameStart = this.dateSelectionStart.clone().startOf('month');
        },
        OpenAutoCompensationModal() {
            let view = this;
            let description = this.$t('workBalance.payroll.compensationQuery') + "<br/>";

            let noContractConstant = -2;
            let mainContracts = Array.from(new Set(Object.values(view.getEmployeeMainContractMap()).map(c => c ? c.weekTimeRegular : noContractConstant))).sort((a, b) => a - b);
            let employees = Object.values(view.workBalanceMap).filter(i => view.employeeMap[i.employeeId] != null).map(i => {
                return {
                    label: view.employeeMap[i.employeeId].lastName.toUpperCase() + " " + view.employeeMap[i.employeeId].firstName,
                    value: i.employeeId
                }
            });
            employees.sort((a, b) => {
                if (a.label.toUpperCase() < b.label.toUpperCase()) {
                    return -1;
                } else if (a.label.toUpperCase() < b.label.toUpperCase()) {
                    return 1;
                }
                return 0;
            })
            let dataEntries = [];
            let filterState = {contractId: mainContracts};
            dataEntries.push({
                label: this.$t('global.ui.selectEmployee'),
                key: 'employeeFlag',
                hidden: false,
                type: 'bool',
                value: false
            });
            dataEntries.push({
                label: this.$t('workBalance.payroll.hourModel'), key: 'contracts', type: 'dropdownsearch',
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: mainContracts.map(c => {
                        return {
                            label: c != -2 ? (c / 60).toFixed(2) + 'h' : this.$t('workBalance.payroll.noContract'),
                            value: c,
                            iconLeft: {
                                icon: 'fa-circle',
                                type: 'small',
                                styleButton: {'margin-left': '-9px', 'margin-top': '1px'},
                                styleIcon: {
                                    color: '#ffffff !important',
                                    'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'
                                }
                            },
                            selected: filterState.contractId.find(v => v === c)
                        }
                    }),
                },
                filterCheck: (data) => {
                    return filterState.contractId.length === 0 || filterState.contractId.find(v => v === data.contractId)
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                    if (employeeFlag) {
                        entryBeforeUpdate.hidden = true;
                    } else {
                        entryBeforeUpdate.hidden = false;
                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({
                label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: employees.map(e => {
                        return {
                            label: e.label,
                            value: e.value,
                            selected: false
                        }
                    }),
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                    if (employeeFlag) {
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({divider: true});
            dataEntries.push({
                label: this.$t('workBalance.payroll.reconcileWorkTimeBalance'),
                key: 'compensateWorkTime',
                hidden: false,
                type: 'bool',
                value: true
            })
            dataEntries.push({divider: true});
            dataEntries.push({
                label: this.$t('workBalance.payroll.reconcileHolidayBalance'),
                key: 'compensateHolidays',
                hidden: false,
                type: 'bool',
                value: true
            })
            dataEntries.push({divider: true});
            dataEntries.push({
                label: this.$t('workBalance.payroll.reconcileNightWorkBalance'),
                key: 'compensateNightWorkTime',
                hidden: false,
                type: 'bool',
                value: true
            })
            dataEntries.push({divider: true});
            dataEntries.push({
                label: this.$t('workBalance.payroll.reconcileOvertimeBalance'),
                key: 'compensateOvertime',
                hidden: false,
                type: 'bool',
                value: true
            })
            dataEntries.push({
                label: this.$t('workBalance.payroll.overtimePositiveWorkTime'),
                key: 'compensateWorkTimeWithOvertime',
                hidden: false,
                type: 'bool',
                value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let compensateOvertime = datafill.entries.find(i => i.key == 'compensateOvertime').value;

                    if (!compensateOvertime) {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({
                label: this.$t('workBalance.payroll.overtimeNegativeWorkTime'),
                key: 'compensateNegativeWorkTimeWithOvertime',
                hidden: false,
                type: 'bool',
                value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let compensateOvertime = datafill.entries.find(i => i.key == 'compensateOvertime').value;

                    if (!compensateOvertime) {
                        entryBeforeUpdate.hidden = true;
                        entryBeforeUpdate.value = false;

                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({divider: true});
            dataEntries.push({
                label: this.$t('workBalance.payroll.reconcileMoreTimeBalance'),
                key: 'compensateMoreTime',
                hidden: false,
                type: 'bool',
                value: true
            })
            dataEntries.push({divider: true});
            dataEntries.push({
                label: this.$t('workBalance.payroll.reconcileBonusHoursBalance'),
                key: 'compensateBonusTime',
                hidden: false,
                type: 'bool',
                value: true
            })
            dataEntries.push({divider: true});
            dataEntries.push({
                label: this.$t('workBalance.payroll.reconcilePositiveValues'),
                key: 'compensatePositive',
                hidden: false,
                type: 'bool',
                value: true
            })
            dataEntries.push({
                label: this.$t('workBalance.payroll.reconcileNegativeValues'),
                key: 'compensateNegative',
                hidden: false,
                type: 'bool',
                value: true
            })
            dataEntries.push({
                label: this.$t('workBalance.payroll.reconcileContractDebit'),
                key: 'compensateToContract',
                hidden: false,
                type: 'bool',
                value: false
            })


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    selectCallback: function (data) {
                        let workbalances = [];
                        if (data.employeeFlag) {
                            let employees = data.employees;
                            Object.values(view.workBalanceMap).filter(wb => !wb.confirmed).forEach(wb => {
                                if (employees.includes(wb.employeeId)) {
                                    workbalances.push(wb);
                                }
                            })
                        } else {
                            let contracts = data.contracts;
                            Object.values(view.workBalanceMap).filter(wb => !wb.confirmed).forEach(wb => {

                                let contract = view.getMainContractForEmployee(wb.employeeId);
                                if (contract) {
                                    if (contracts.includes(contract.weekTimeRegular)) {
                                        workbalances.push(wb);
                                    }
                                } else if (contracts.includes(noContractConstant)) {
                                    workbalances.push(wb);
                                }
                            })
                        }


                        view.performAutoCompensation(workbalances, data.compensateWorkTime, data.compensateHolidays, data.compensateNightWorkTime,
                            data.compensateOvertime, data.compensateWorkTimeWithOvertime, data.compensateNegativeWorkTimeWithOvertime, data.compensateMoreTime, data.compensateBonusTime,
                            data.compensateToContract, data.compensatePositive, data.compensateNegative);
                    }
                },
                header: this.$t('workBalance.payroll.balanceBalance'),
                width: "1000px",
                expanded: true,
                centered: true
            });
        },
        performAutoCompensation(workbalances, compensateWorkTime = true, compensateHolidays = true, compensateNightWorkTime = true, compensateOvertime = true,
                                compensateWorkTimeWithOvertime = false, compensateNegativeWorkTimeWithOvertime = false, compensateMoreTime = true, compensateBonusTime = true,
                                compensateToContract = false, compensatePositive = true, compensateNegative = true) {
            let view = this;

            workbalances.filter(wb => !wb.confirmed).forEach((wb) => {
                if (!wb.appliedAccountingPeriod) {
                    if (compensateWorkTime) {
                        let wtGoal = (wb.workTimeRegular - wb.prevMonthTime)
                        if (compensateToContract) {
                            wtGoal = wb.workTimeRegular;
                        }

                        let wtBalance = Math.round((wb.workTime + wb.unproductiveWorkTime - (wb.workTimeRegular - wb.prevMonthTime)) * (wb.multiplier / 100)) - wb.paidWorkTime;
                        let wtCompensation = Math.round((wb.workTime + wb.unproductiveWorkTime - wtGoal) * (wb.multiplier / 100));


                        if ((wtBalance < 0 && compensateNegative) || (wtBalance > 0 && compensatePositive)) {
                            view.dataUpdatedByUser(wtBalance.toString(), wb, 'workTimeBalance');
                            view.dataUpdatedByUser(wtCompensation.toString(), wb, 'paidWorkTime');
                        }
                    }


                    if (compensateHolidays) {
                        let prevHtBalance = wb.holidayTimeBalance - wb.holidayTime + wb.holidayAdjustmentTime + wb.paidHolidayTime;
                        let htBalance = prevHtBalance + wb.holidayTime - wb.holidayAdjustmentTime - wb.paidHolidayTime;
                        let htCompensation = prevHtBalance + wb.holidayTime - wb.holidayAdjustmentTime;
                        if ((htBalance < 0 && compensateNegative) || (htBalance > 0 && compensatePositive)) {
                            view.dataUpdatedByUser(htBalance.toString(), wb, 'holidayTimeBalance');
                            view.dataUpdatedByUser(htCompensation.toString(), wb, 'paidHolidayTime');
                        }

                    }

                    if (compensateNightWorkTime) {
                        let prevNtBalance = wb.nightWorkTimeBalance - wb.nightWorkTime + wb.paidNightWorkTime;
                        let ntBalance = prevNtBalance + wb.nightWorkTime - wb.paidNightWorkTime;
                        let ntCompensation = prevNtBalance + wb.nightWorkTime;
                        if ((ntBalance < 0 && compensateNegative) || (ntBalance > 0 && compensatePositive)) {
                            view.dataUpdatedByUser(ntBalance.toString(), wb, 'nightWorkTimeBalance');
                            view.dataUpdatedByUser(ntCompensation.toString(), wb, 'paidNightWorkTime');
                        }

                    }

                    if (compensateMoreTime) {
                        let prevMtBalance = wb.moreTimeBalance - wb.moreTime + wb.paidMoreTime;
                        let mtBalance = prevMtBalance + wb.moreTime - wb.paidMoreTime;
                        let mtCompensation = prevMtBalance + wb.moreTime;
                        if ((mtBalance < 0 && compensateNegative) || (mtBalance > 0 && compensatePositive)) {
                            view.dataUpdatedByUser(mtBalance.toString(), wb, 'moreTimeBalance');
                            view.dataUpdatedByUser(mtCompensation.toString(), wb, 'paidMoreTime');
                        }

                    }

                    if (compensateBonusTime) {
                        let prevBtBalance = wb.bonusTimeBalance - wb.bonusTime + wb.paidBonusTime;
                        let btBalance = prevBtBalance + wb.bonusTime - wb.paidBonusTime;
                        let btCompensation = prevBtBalance + wb.bonusTime;
                        if ((btBalance < 0 && compensateNegative) || (btBalance > 0 && compensatePositive)) {
                            view.dataUpdatedByUser(btBalance.toString(), wb, 'bonusTimeBalance');
                            view.dataUpdatedByUser(btCompensation.toString(), wb, 'paidBonusTime');
                        }

                    }

                    if (compensateOvertime) {
                        let prevOtBalance = wb.overTimeBalance - wb.overTime + wb.paidOverTime;
                        let otBalance = prevOtBalance + wb.overTime - wb.paidOverTime;
                        let otCompensation = prevOtBalance + wb.overTime;
                        if ((otBalance < 0 && compensateNegative) || (otBalance > 0 && compensatePositive)) {
                            view.dataUpdatedByUser(otBalance.toString(), wb, 'overTimeBalance');
                            view.dataUpdatedByUser(otCompensation.toString(), wb, 'paidOverTime');

                            let currentMonthWtBalance = ((wb.workTime + wb.unproductiveWorkTime) - wb.workTimeRegular);
                            if (compensateWorkTimeWithOvertime && compensateNegativeWorkTimeWithOvertime && wb.overTime > 0) {
                                let paidWorkTime = Math.round(wb.paidWorkTime + wb.overTime);
                                let ewb = Math.round(wb.workTimeBalance - wb.overTime);
                                //view.dataUpdatedByUser(ewb.toString(), wb, 'workTimeBalance');
                                view.dataUpdatedByUser(paidWorkTime.toString(), wb, 'paidWorkTime');

                            } else if (compensateNegativeWorkTimeWithOvertime && wb.overTime > 0 && currentMonthWtBalance <= 0) {
                                let paidWorkTime = Math.round(wb.paidWorkTime + wb.overTime);
                                let ewb = Math.round(wb.workTimeBalance - wb.overTime);
                                //view.dataUpdatedByUser(ewb.toString(), wb, 'workTimeBalance');
                                view.dataUpdatedByUser(paidWorkTime.toString(), wb, 'paidWorkTime');

                            } else if (compensateWorkTimeWithOvertime && wb.overTime > 0 && currentMonthWtBalance > 0) {
                                let currentCompensation = wb.paidWorkTime;
                                let maxCompensation = Math.min(currentMonthWtBalance, wb.overTime);

                                let compensationDiff = maxCompensation - currentCompensation;
                                if (compensationDiff > 0) {
                                    let paidWorkTime = Math.round(wb.paidWorkTime + compensationDiff);
                                    let ewb = Math.round(wb.workTimeBalance - compensationDiff);
                                    //view.dataUpdatedByUser(ewb.toString(), wb, 'workTimeBalance');
                                    view.dataUpdatedByUser(paidWorkTime.toString(), wb, 'paidWorkTime');
                                }

                            }
                        }

                    }

                }
            });
        },
        OpenApplyWorkBalanceMultiplierModal() {
            let view = this;
            let description = "Welche Stunden Modelle oder Mitarbeiter sollen mit dem Durchrechnungs Multiplikator berechnet werden?<br/>";

            let noContractConstant = -2;
            let mainContracts = Array.from(new Set(Object.values(view.getEmployeeMainContractMap()).map(c => c ? c.weekTimeRegular : noContractConstant))).sort((a, b) => a - b);
            let employees = Object.values(view.workBalanceMap).filter(i => view.employeeMap[i.employeeId] != null).map(i => {

                return {
                    label: view.employeeMap[i.employeeId].lastName.toUpperCase() + " " + view.employeeMap[i.employeeId].firstName,
                    value: i.employeeId
                }
            });
            employees.sort((a, b) => {
                if (a.label.toUpperCase() < b.label.toUpperCase()) {
                    return -1;
                } else if (a.label.toUpperCase() < b.label.toUpperCase()) {
                    return 1;
                }
                return 0;
            })
            let dataEntries = [];
            let filterState = {contractId: mainContracts};
            dataEntries.push({
                label: this.$t('global.ui.selectEmployee'),
                key: 'employeeFlag',
                hidden: false,
                type: 'bool',
                value: false
            });
            dataEntries.push({
                label: this.$t('workBalance.payroll.hourModel'), key: 'contracts', type: 'dropdownsearch',
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: mainContracts.map(c => {
                        return {
                            label: c != -2 ? (c / 60).toFixed(2) + 'h' : this.$t('workBalance.payroll.noContract'),
                            value: c,
                            iconLeft: {
                                icon: 'fa-circle',
                                type: 'small',
                                styleButton: {'margin-left': '-9px', 'margin-top': '1px'},
                                styleIcon: {
                                    color: '#ffffff !important',
                                    'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'
                                }
                            },
                            selected: filterState.contractId.find(v => v === c)
                        }
                    }),
                },
                filterCheck: (data) => {
                    return filterState.contractId.length === 0 || filterState.contractId.find(v => v === data.contractId)
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                    if (employeeFlag) {
                        entryBeforeUpdate.hidden = true;
                    } else {
                        entryBeforeUpdate.hidden = false;
                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({
                label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: employees.map(e => {
                        return {
                            label: e.label,
                            value: e.value,
                            selected: false
                        }
                    }),
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                    if (employeeFlag) {
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                    }

                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({
                label: "Bei positiven Arbeitszeit Saldo ÜS Zuschlag addieren",
                key: 'compensatePositiveOverTime',
                hidden: false,
                type: 'bool',
                value: false
            })
            dataEntries.push({
                label: "Bei negativen Arbeitszeit Saldo ÜS Zuschlag addieren",
                key: 'compensateNegativeOverTime',
                hidden: false,
                type: 'bool',
                value: false
            })

            dataEntries.push({
                label: "Bei positiven Arbeitszeit Saldo FT Zuschlag addieren",
                key: 'compensatePositiveHoliday',
                hidden: false,
                type: 'bool',
                value: false
            })
            dataEntries.push({
                label: "Bei negativen Arbeitszeit Saldo FT Zuschlag addieren",
                key: 'compensateNegativeHoliday',
                hidden: false,
                type: 'bool',
                value: false
            })

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    selectCallback: function (data) {
                        let workbalances = [];
                        if (data.employeeFlag) {
                            let employees = data.employees;
                            Object.values(view.workBalanceMap).filter(wb => !wb.confirmed).forEach(wb => {
                                if (employees.includes(wb.employeeId)) {
                                    workbalances.push(wb);
                                }
                            })
                        } else {
                            let contracts = data.contracts;
                            Object.values(view.workBalanceMap).filter(wb => !wb.confirmed).forEach(wb => {

                                let contract = view.getMainContractForEmployee(wb.employeeId);
                                if (contract) {
                                    if (contracts.includes(contract.weekTimeRegular)) {
                                        workbalances.push(wb);
                                    }
                                } else if (contracts.includes(noContractConstant)) {
                                    workbalances.push(wb);
                                }
                            })
                        }

                        view.applyWorkBalanceMultiplier(workbalances, data.compensatePositiveOverTime, data.compensateNegativeOverTime, data.compensatePositiveHoliday, data.compensateNegativeHoliday);
                    }
                },
                header: 'DR Multiplikator',
                expanded: true,
                centered: true
            });
        },

        applyWorkBalanceMultiplier(workbalances, compensatePositiveOverTime = false, compensateNegativeOverTime = false, compensatePositiveHoliday = false, compensateNegativeHoliday = false) {
            let view = this;
            let multiplier = this.storeSettings.workBalanceMultiplier;
            workbalances.filter(wb => !wb.confirmed).forEach((wb) => {
                if (!wb.appliedAccountingPeriod) {
                    let effectiveWb = wb.workTimeBalance - wb.accountingPeriodBalance;
                    let oldWb = wb.workTimeBalance;
                    let newWb = wb.workTimeBalance;
                    if (effectiveWb > 0) {
                        view.dataUpdatedByUser(multiplier.toString(), wb, 'multiplier');
                        newWb = Math.round(effectiveWb * (multiplier / 100) + wb.accountingPeriodBalance);

                    }

                    if ((compensatePositiveOverTime && oldWb >= 0) || (compensateNegativeOverTime && oldWb < 0)) {
                        let compensation = Math.round(wb.overTimeBalance * 0.5);
                        if (compensation > 0) {
                            view.dataUpdatedByUser((0).toString(), wb, 'overTimeBalance');
                            newWb += compensation;
                        }

                    }
                    if ((compensatePositiveHoliday && oldWb >= 0) || (compensateNegativeHoliday && oldWb < 0)) {
                        let compensation = Math.round(wb.holidayTimeBalance);
                        if (compensation > 0) {
                            view.dataUpdatedByUser((0).toString(), wb, 'holidayTimeBalance');
                            newWb += compensation;
                        }

                    }
                    view.dataUpdatedByUser((newWb).toString(), wb, 'workTimeBalance');
                    view.dataUpdatedByUser((newWb).toString(), wb, 'accountingPeriodBalance');
                    view.dataUpdatedByUser(true, wb, 'appliedAccountingPeriod');
                }

            });
        },

        OpenToggleAccountingPeriodModal() {
            let view = this;
            let description = "Soll der Status der Durchrechnung umgeschaltet werden?<br/>"
                + "<ul>"
                + "<li>Bei Mitarbeitern wo die Durchrechnung beendet wurde, wird der Monatsabschluss neuberechnet so als ob die Durchrechnung noch nicht beendet wird</li>"
                + "<li>Bei Mitarbeitern wo die Durchrechnung noch nicht beendet wurde, wird diese beendet und der aktuelle Arbeitszeit Saldo wird in die nächste Durchrechnunsgperiode übernommen</li>"
                + "</ul>";

            let employees = Object.values(view.workBalanceMap).filter(i => view.employeeMap[i.employeeId] != null).map(i => {
                return {
                    label: view.employeeMap[i.employeeId].lastName.toUpperCase() + " " + view.employeeMap[i.employeeId].firstName,
                    value: i.employeeId
                }
            });
            employees.sort((a, b) => {
                if (a.label.toUpperCase() < b.label.toUpperCase()) {
                    return -1;
                } else if (a.label.toUpperCase() < b.label.toUpperCase()) {
                    return 1;
                }
                return 0;
            })
            let modusItems = [
                {label: "Nicht-beendete Durchrechnung umschalten", value: 1},
                {label: "Beendete Durchrechnung umschalten", value: 2},

            ];
            let dataEntries = [];

            dataEntries.push({
                label: this.$t('global.ui.selectEmployee'),
                key: 'employeeFlag',
                hidden: false,
                type: 'bool',
                value: false
            });

            dataEntries.push({
                label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: employees.map(e => {
                        return {
                            label: e.label,
                            value: e.value,
                            selected: false
                        }
                    }),
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                    if (employeeFlag) {
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                    }
                    return entryBeforeUpdate;
                }
            });
            dataEntries.push({
                label: 'Modus', key: 'modus', type: 'dropdownsearch', hidden: false,
                dropdownSearchState: {
                    selectMultiple: false,
                    selectFirst: true,
                    styleLight: true,
                    items: modusItems,
                }
            });


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    selectCallback: function (data) {
                        let workbalances = [];
                        if (data.employeeFlag) {
                            let employees = data.employees;
                            Object.values(view.workBalanceMap).filter(wb => !wb.confirmed).forEach(wb => {
                                if (employees.includes(wb.employeeId)) {
                                    workbalances.push(wb);
                                }
                            })
                        } else {
                            Object.values(view.workBalanceMap).forEach(wb => {
                                workbalances.push(wb);
                            });
                        }
                        if (data.modus == 1) {
                            workbalances = workbalances.filter(wb => !wb.appliedAccountingPeriod);
                        } else if (data.modus == 2) {
                            workbalances = workbalances.filter(wb => wb.appliedAccountingPeriod);
                        } else {
                            workbalances = [];
                        }

                        view.toggleAccountingPeriod(workbalances);
                    }
                },
                header: 'DR Umschalten',
                expanded: true,
                centered: true
            });
        },
        toggleAccountingPeriod(workbalances) {
            let result = [];
            workbalances.forEach(wb => {
                if (wb.appliedAccountingPeriod && !wb.confirmed) {
                    let employee = this.employeeMap[wb.employeeId];
                    if (employee) {
                        let balance = this.convertToPayloadUnits(this.calculateEWB(employee, this.storeHasMZ ? 2 : 1, false, true));
                        balance.valid = true;
                        result.push(balance);
                    }

                } else if (!wb.appliedAccountingPeriod && !wb.confirmed) {
                    let balance = Object.assign({}, wb);
                    balance.appliedAccountingPeriod = true;
                    balance.accountingPeriodBalance = balance.workTimeBalance;
                    balance.valid = true;
                    result.push(balance);
                }

            });
            this.multiCreateWithToggle(result, false, false, true);
        },
        openCommentPopup(event, ewb) {
            let view = this;

            let dataEntries = [
                {
                    label: this.$t('global.general.comment') + ': ',
                    key: 'comment',
                    hidden: false,
                    type: 'text',
                    value: ewb.comment ? ewb.comment : '',
                    length: 512,
                    styles: {'width': '350px'}
                },
                {flexDivider: true, styles: {'margin-bottom': '23px'}},
            ];

            let emp = this.employeeMap[ewb.employeeId];
            let popupHeader = emp.lastName + ' ' + emp.firstName;

            this.$helpers.OpenPopup({
                elRelative: event.currentTarget,
                type: 'datafill',
                pointerDirection: 0,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (data) {
                        view.updateComment(ewb, data.comment);
                    }
                },
                header: popupHeader,
                remainAfterSelect: false,
                expanded: true,
            });
        },
        updateComment(ewb, comment) {
            let view = this;
            let req = {id: ewb.id, storeId: this.storeId, comment: comment, updateFields: ["comment"]};
            this.doMultiUpdate([req], false, () => {
                let id = ewb.id;
                let data = view.workBalanceMap[id];
                data.comment = comment;
                view.$set(view.workBalanceMap, id, data);
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 2));
            });
        },
        dataUpdatedByUser(value, rowData, headerKey, multiplier = 1) {

            let val = value;
            let oldVal = rowData[headerKey];
            if (typeof val !== "boolean") {
                val = Math.round(parseFloat(value.replace(",", ".") * multiplier));
                if (isNaN(val)) {
                    val = oldVal;
                }
            }

            let diff = val - oldVal;

            let wbId = rowData.id;
            let balance = Object.assign({}, this.workBalanceMap[wbId]);
            let appliedAccountingPeriod = balance.appliedAccountingPeriod;
            balance[headerKey] = val;

            if (headerKey == 'workTime') {
                let wtBalance = balance.workTimeBalance;

                wtBalance += diff;
                balance.workTimeBalance = wtBalance;
                if (appliedAccountingPeriod) {
                    balance.accountingPeriodBalance = wtBalance;
                }
            } else if (headerKey == 'workTimeBalance') {

                let paidWorkTime = balance.paidWorkTime;

                paidWorkTime -= diff;
                balance.paidWorkTime = paidWorkTime;
                if (appliedAccountingPeriod) {
                    balance.accountingPeriodBalance = balance.workTimeBalance;
                }
            } else if (headerKey == 'paidWorkTime') {
                let wtBalance = balance.workTimeBalance;

                wtBalance -= diff;
                balance.workTimeBalance = wtBalance;
                if (appliedAccountingPeriod) {
                    balance.accountingPeriodBalance = wtBalance;
                }
            } else if (headerKey == 'moreTimeBalance') {

                let paidMoreTime = balance.paidMoreTime;

                paidMoreTime -= diff;
                balance.paidMoreTime = paidMoreTime;

            } else if (headerKey == 'paidMoreTime') {
                let mtBalance = balance.moreTimeBalance;
                mtBalance -= diff;
                balance.moreTimeBalance = mtBalance;
            } else if (headerKey == 'holidayTimeBalance') {

                let paidHolidayTime = balance.paidHolidayTime;

                paidHolidayTime -= diff;
                balance.paidHolidayTime = paidHolidayTime;

            } else if (headerKey == 'paidHolidayTime') {
                let htBalance = balance.holidayTimeBalance;
                htBalance -= diff;
                balance.holidayTimeBalance = htBalance;
            } else if (headerKey == 'vacationTimeBalance') {

                let paidVacationTime = balance.paidVacationTime;

                paidVacationTime -= diff;
                balance.paidVacationTime = paidVacationTime;

            } else if (headerKey == 'paidVacationTime') {
                let vtBalance = balance.vacationTimeBalance;
                vtBalance -= diff;
                balance.vacationTimeBalance = vtBalance;
            } else if (headerKey == 'nightWorkTimeBalance') {

                let paidNightWorkTime = balance.paidNightWorkTime;

                paidNightWorkTime -= diff;
                balance.paidNightWorkTime = paidNightWorkTime;

            } else if (headerKey == 'paidNightWorkTime') {
                let ntBalance = balance.nightWorkTimeBalance;
                ntBalance -= diff;
                balance.nightWorkTimeBalance = ntBalance;
            } else if (headerKey == 'overTimeBalance') {

                let paidOverTime = balance.paidOverTime;

                paidOverTime -= diff;
                balance.paidOverTime = paidOverTime;

            } else if (headerKey == 'paidOverTime') {
                let otBalance = balance.overTimeBalance;
                otBalance -= diff;
                balance.overTimeBalance = otBalance;
            } else if (headerKey == 'bonusTimeBalance') {

                let paidBonusTime = balance.paidBonusTime;

                paidBonusTime -= diff;
                balance.paidBonusTime = paidBonusTime;

            } else if (headerKey == 'paidBonusTime') {
                let btBalance = balance.bonusTimeBalance;
                btBalance -= diff;
                balance.bonusTimeBalance = btBalance;
            }

            balance.valid = false;
            this.$set(this.workBalanceMap, wbId, balance);
        },
        loadActiveAtEmployees: function () {
            let url = '/api/sec/employee';
            let params = {
                storeId: this.$store.state.storeId,
                activeAtFrom: this.currentMonthFrom.clone().add(-1, 'month').format(),
                activeAtTo: this.currentMonthTo.clone().add(1, 'month').format(),
                ewbDate: this.$helpers.getMomentFromValuesUTC(this.currentMonthFrom.year(), this.currentMonthFrom.month(), 1).format(),
                bridgeFutureContract: true //this optional flag is only necessary here to load employees which have contracts in the future, in case an ewb can be created for the current month because the employee worked in the store before
            };


            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })

        },
        loadEmployeeWorkBalances: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({
                        data: []
                    });
                })
            } else {
                let view = this;
                let url = '/api/sec/employeeworkbalance/any/employee';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$helpers.getMomentFromValuesUTC(this.currentMonthFrom.year(), this.currentMonthFrom.month(), 1).format(),
                    to: this.$helpers.getMomentFromValuesUTC(this.currentMonthFrom.year(), this.currentMonthFrom.month(), 2).format(),
                };

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                })
            }

        },

        createEmployeeWorkBalance: function (employeeWorkBalance, convertTimeValues = true) {
            this.balanceerror = false;
            let view = this;
            let url = '/api/sec/employeeworkbalance';
            let params = {
                storeId: this.$store.state.storeId
            };
            let payload = {
                employeeId: employeeWorkBalance.employeeId,
                year: this.currentMonthFrom.year(),
                month: this.currentMonthFrom.month() + 1,
                workTimeBalance: !convertTimeValues ? employeeWorkBalance.workTimeBalance : Math.round(employeeWorkBalance.workTimeBalance * 60),
                vacationTimeBalance: !convertTimeValues ? employeeWorkBalance.vacationTimeBalance : Math.round(employeeWorkBalance.vacationTimeBalance * 24 * 60),
                holidayTimeBalance: !convertTimeValues ? employeeWorkBalance.holidayTimeBalance : Math.round(employeeWorkBalance.holidayTimeBalance * 60),
                workTimeRegular: !convertTimeValues ? employeeWorkBalance.workTimeRegular : Math.round(employeeWorkBalance.workTimeRegular * 60),
                workTime: !convertTimeValues ? employeeWorkBalance.workTime : Math.round(employeeWorkBalance.workTime * 60),
                unproductiveWorkTime: !convertTimeValues ? employeeWorkBalance.unproductiveWorkTime : Math.round(employeeWorkBalance.unproductiveWorkTime * 60),
                educationTime: !convertTimeValues ? employeeWorkBalance.educationTime : Math.round(employeeWorkBalance.educationTime * 60),
                vacationTime: !convertTimeValues ? employeeWorkBalance.vacationTime : Math.round(employeeWorkBalance.vacationTime * 24 * 60),
                paidVacationTime: !convertTimeValues ? employeeWorkBalance.paidVacationTime : Math.round(employeeWorkBalance.paidVacationTime * 24 * 60),
                nursingVacationTime: !convertTimeValues ? employeeWorkBalance.nursingVacationTime : Math.round(employeeWorkBalance.nursingVacationTime * 24 * 60),
                holidayTime: !convertTimeValues ? employeeWorkBalance.holidayTime : Math.round(employeeWorkBalance.holidayTime * 60),
                holidayAdjustmentTime: !convertTimeValues ? employeeWorkBalance.holidayAdjustmentTime : Math.round(employeeWorkBalance.holidayAdjustmentTime * 60),
                sickTime: !convertTimeValues ? employeeWorkBalance.sickTime : Math.round(employeeWorkBalance.sickTime * 60),
                wageContinuationTime: !convertTimeValues ? employeeWorkBalance.wageContinuationTime : Math.round(employeeWorkBalance.wageContinuationTime * 60),
                miscTime: !convertTimeValues ? employeeWorkBalance.miscTime : Math.round(employeeWorkBalance.miscTime * 60),
                miscWorkTime: !convertTimeValues ? employeeWorkBalance.miscWorkTime : Math.round(employeeWorkBalance.miscWorkTime * 60),
                paidWorkTime: !convertTimeValues ? employeeWorkBalance.paidWorkTime : Math.round(employeeWorkBalance.paidWorkTime * 60),
                paidHolidayTime: !convertTimeValues ? employeeWorkBalance.paidHolidayTime : Math.round(employeeWorkBalance.paidHolidayTime * 60),


                prevMonthTime: !convertTimeValues ? employeeWorkBalance.prevMonthTime : Math.round(employeeWorkBalance.prevMonthTime * 60),
                multiplier: employeeWorkBalance.multiplier,
                accountingPeriodBalance: !convertTimeValues ? employeeWorkBalance.accountingPeriodBalance : Math.round(employeeWorkBalance.accountingPeriodBalance * 60),
                comment: employeeWorkBalance.comment,

                vacationWorkTime: !convertTimeValues ? employeeWorkBalance.vacationWorkTime : Math.round(employeeWorkBalance.vacationWorkTime * 60),
                nursingVacationWorkTime: !convertTimeValues ? employeeWorkBalance.nursingVacationWorkTime : Math.round(employeeWorkBalance.nursingVacationWorkTime * 60),
                sickWorkTime: !convertTimeValues ? employeeWorkBalance.sickWorkTime : Math.round(employeeWorkBalance.sickWorkTime * 60),
                holidayAdjustmentWorkTime: !convertTimeValues ? employeeWorkBalance.holidayAdjustmentWorkTime : Math.round(employeeWorkBalance.holidayAdjustmentWorkTime * 60),
                educationWorkTime: !convertTimeValues ? employeeWorkBalance.educationWorkTime : Math.round(employeeWorkBalance.educationWorkTime * 60),
                wageContinuationWorkTime: !convertTimeValues ? employeeWorkBalance.wageContinuationWorkTime : Math.round(employeeWorkBalance.wageContinuationWorkTime * 60),

                prevMonthNightWorkTime: !convertTimeValues ? employeeWorkBalance.prevMonthNightWorkTime : Math.round(employeeWorkBalance.prevMonthNightWorkTime * 60),
                nightWorkTimeBalance: !convertTimeValues ? employeeWorkBalance.nightWorkTimeBalance : Math.round(employeeWorkBalance.nightWorkTimeBalance * 60),
                paidNightWorkTime: !convertTimeValues ? employeeWorkBalance.paidNightWorkTime : Math.round(employeeWorkBalance.paidNightWorkTime * 60),
                nightWorkTime: !convertTimeValues ? employeeWorkBalance.nightWorkTime : Math.round(employeeWorkBalance.nightWorkTime * 60),

                prevMonthOverTime: !convertTimeValues ? employeeWorkBalance.prevMonthOverTime : Math.round(employeeWorkBalance.prevMonthOverTime * 60),
                overTimeBalance: !convertTimeValues ? employeeWorkBalance.overTimeBalance : Math.round(employeeWorkBalance.overTimeBalance * 60),
                paidOverTime: !convertTimeValues ? employeeWorkBalance.paidOverTime : Math.round(employeeWorkBalance.paidOverTime * 60),
                overTime: !convertTimeValues ? employeeWorkBalance.overTime : Math.round(employeeWorkBalance.overTime * 60),

                prevMonthMoreTime: !convertTimeValues ? employeeWorkBalance.prevMonthMoreTime : Math.round(employeeWorkBalance.prevMonthMoreTime * 60),
                moreTimeBalance: !convertTimeValues ? employeeWorkBalance.moreTimeBalance : Math.round(employeeWorkBalance.moreTimeBalance * 60),
                paidMoreTime: !convertTimeValues ? employeeWorkBalance.paidMoreTime : Math.round(employeeWorkBalance.paidMoreTime * 60),
                moreTime: !convertTimeValues ? employeeWorkBalance.moreTime : Math.round(employeeWorkBalance.moreTime * 60),

                dailyOverTime: !convertTimeValues ? employeeWorkBalance.dailyOverTime : Math.round(employeeWorkBalance.dailyOverTime * 60),
                weeklyOverTime: !convertTimeValues ? employeeWorkBalance.weeklyOverTime : Math.round(employeeWorkBalance.weeklyOverTime * 60),
                workDayOverTime: !convertTimeValues ? employeeWorkBalance.workDayOverTime : Math.round(employeeWorkBalance.workDayOverTime * 60),

                prevMonthBonusTime: !convertTimeValues ? employeeWorkBalance.prevMonthBonusTime : Math.round(employeeWorkBalance.prevMonthBonusTime * 60),
                bonusTimeBalance: !convertTimeValues ? employeeWorkBalance.bonusTimeBalance : Math.round(employeeWorkBalance.bonusTimeBalance * 60),
                paidBonusTime: !convertTimeValues ? employeeWorkBalance.paidBonusTime : Math.round(employeeWorkBalance.paidBonusTime * 60),
                bonusTime: !convertTimeValues ? employeeWorkBalance.bonusTime : Math.round(employeeWorkBalance.bonusTime * 60),

                workTimeMod: !convertTimeValues ? employeeWorkBalance.workTimeMod : Math.round(employeeWorkBalance.workTimeMod * 60),
                moreTimeMod: !convertTimeValues ? employeeWorkBalance.moreTimeMod : Math.round(employeeWorkBalance.moreTimeMod * 60),
                overTimeToWorkTime: !convertTimeValues ? employeeWorkBalance.overTimeToWorkTime : Math.round(employeeWorkBalance.overTimeToWorkTime * 60),
                holidayTimeToWorkTime: !convertTimeValues ? employeeWorkBalance.holidayTimeToWorkTime : Math.round(employeeWorkBalance.holidayTimeToWorkTime * 60),

                nightWorkCount: employeeWorkBalance.nightWorkCount,
                overTimeCount: employeeWorkBalance.overTimeCount,
                moreTimeCount: employeeWorkBalance.moreTimeCount,
                bonusTimeCount: employeeWorkBalance.bonusTimeCount,

                holidayCount: employeeWorkBalance.holidayCount,
                workCount: employeeWorkBalance.workCount,
                educationCount: employeeWorkBalance.educationCount,
                vacationCount: employeeWorkBalance.vacationCount,
                wageContinuationCount: employeeWorkBalance.wageContinuationCount,
                nursingVacationCount: employeeWorkBalance.nursingVacationCount,
                miscCount: employeeWorkBalance.miscCount,
                sickCount: employeeWorkBalance.sickCount,
                holidayAdjustmentCount: employeeWorkBalance.holidayAdjustmentCount,

                autoCalc: employeeWorkBalance.autoCalc,
                autoEqualize: employeeWorkBalance.autoEqualize,
                appliedAccountingPeriod: employeeWorkBalance.appliedAccountingPeriod,
                valid: true,
                confirmed: false
            };

            this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$tc('workBalance.payroll.workBalanceUpdated', 1))
                view.refresh();
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.ui.createFailed'), view.$tc('workBalance.payroll.errorWorkBalanceUpdate', 1))
                view.balanceerror = true;
                console.log(error)
            })

        },
        convertToPayloadUnits(employeeWorkBalance) {
            let result = {
                employeeId: employeeWorkBalance.employeeId,

                workTimeBalance: Math.round(employeeWorkBalance.workTimeBalance * 60),
                vacationTimeBalance: Math.round(employeeWorkBalance.vacationTimeBalance * 24 * 60),
                holidayTimeBalance: Math.round(employeeWorkBalance.holidayTimeBalance * 60),
                workTimeRegular: Math.round(employeeWorkBalance.workTimeRegular * 60),
                workTime: Math.round(employeeWorkBalance.workTime * 60),
                unproductiveWorkTime: Math.round(employeeWorkBalance.unproductiveWorkTime * 60),
                educationTime: Math.round(employeeWorkBalance.educationTime * 60),
                vacationTime: Math.round(employeeWorkBalance.vacationTime * 24 * 60),
                paidVacationTime: Math.round(employeeWorkBalance.paidVacationTime * 24 * 60),
                nursingVacationTime: Math.round(employeeWorkBalance.nursingVacationTime * 24 * 60),
                holidayTime: Math.round(employeeWorkBalance.holidayTime * 60),
                holidayAdjustmentTime: Math.round(employeeWorkBalance.holidayAdjustmentTime * 60),
                sickTime: Math.round(employeeWorkBalance.sickTime * 60),
                wageContinuationTime: Math.round(employeeWorkBalance.wageContinuationTime * 60),
                miscTime: Math.round(employeeWorkBalance.miscTime * 60),
                miscWorkTime: Math.round(employeeWorkBalance.miscWorkTime * 60),
                paidWorkTime: Math.round(employeeWorkBalance.paidWorkTime * 60),
                paidHolidayTime: Math.round(employeeWorkBalance.paidHolidayTime * 60),
                prevMonthTime: Math.round(employeeWorkBalance.prevMonthTime * 60),
                multiplier: employeeWorkBalance.multiplier,
                accountingPeriodBalance: Math.round(employeeWorkBalance.accountingPeriodBalance * 60),
                comment: employeeWorkBalance.comment,

                vacationWorkTime: Math.round(employeeWorkBalance.vacationWorkTime * 60),
                nursingVacationWorkTime: Math.round(employeeWorkBalance.nursingVacationWorkTime * 60),
                sickWorkTime: Math.round(employeeWorkBalance.sickWorkTime * 60),
                holidayAdjustmentWorkTime: Math.round(employeeWorkBalance.holidayAdjustmentWorkTime * 60),
                educationWorkTime: Math.round(employeeWorkBalance.educationWorkTime * 60),
                wageContinuationWorkTime: Math.round(employeeWorkBalance.wageContinuationWorkTime * 60),

                prevMonthNightWorkTime: Math.round(employeeWorkBalance.prevMonthNightWorkTime * 60),
                nightWorkTimeBalance: Math.round(employeeWorkBalance.nightWorkTimeBalance * 60),
                paidNightWorkTime: Math.round(employeeWorkBalance.paidNightWorkTime * 60),
                nightWorkTime: Math.round(employeeWorkBalance.nightWorkTime * 60),

                prevMonthOverTime: Math.round(employeeWorkBalance.prevMonthOverTime * 60),
                overTimeBalance: Math.round(employeeWorkBalance.overTimeBalance * 60),
                paidOverTime: Math.round(employeeWorkBalance.paidOverTime * 60),
                overTime: Math.round(employeeWorkBalance.overTime * 60),

                prevMonthMoreTime: Math.round(employeeWorkBalance.prevMonthMoreTime * 60),
                moreTimeBalance: Math.round(employeeWorkBalance.moreTimeBalance * 60),
                paidMoreTime: Math.round(employeeWorkBalance.paidMoreTime * 60),
                moreTime: Math.round(employeeWorkBalance.moreTime * 60),

                dailyOverTime: Math.round(employeeWorkBalance.dailyOverTime * 60),
                weeklyOverTime: Math.round(employeeWorkBalance.weeklyOverTime * 60),
                workDayOverTime: Math.round(employeeWorkBalance.workDayOverTime * 60),

                prevMonthBonusTime: Math.round(employeeWorkBalance.prevMonthBonusTime * 60),
                bonusTimeBalance: Math.round(employeeWorkBalance.bonusTimeBalance * 60),
                paidBonusTime: Math.round(employeeWorkBalance.paidBonusTime * 60),
                bonusTime: Math.round(employeeWorkBalance.bonusTime * 60),

                workTimeMod: Math.round(employeeWorkBalance.workTimeMod * 60),
                moreTimeMod: Math.round(employeeWorkBalance.moreTimeMod * 60),
                overTimeToWorkTime: Math.round(employeeWorkBalance.overTimeToWorkTime * 60),
                holidayTimeToWorkTime: Math.round(employeeWorkBalance.holidayTimeToWorkTime * 60),

                nightWorkCount: employeeWorkBalance.nightWorkCount,
                overTimeCount: employeeWorkBalance.overTimeCount,
                moreTimeCount: employeeWorkBalance.moreTimeCount,
                bonusTimeCount: employeeWorkBalance.bonusTimeCount,

                holidayCount: employeeWorkBalance.holidayCount,
                workCount: employeeWorkBalance.workCount,
                educationCount: employeeWorkBalance.educationCount,
                vacationCount: employeeWorkBalance.vacationCount,
                wageContinuationCount: employeeWorkBalance.wageContinuationCount,
                nursingVacationCount: employeeWorkBalance.nursingVacationCount,
                miscCount: employeeWorkBalance.miscCount,
                sickCount: employeeWorkBalance.sickCount,
                holidayAdjustmentCount: employeeWorkBalance.holidayAdjustmentCount,

                autoCalc: employeeWorkBalance.autoCalc,
                autoEqualize: employeeWorkBalance.autoEqualize,
                appliedAccountingPeriod: employeeWorkBalance.appliedAccountingPeriod,
                valid: employeeWorkBalance.valid,
                confirmed: employeeWorkBalance.confirmed
            };
            return result;
        },
        buildRequestPayload(employeeWorkBalance, convertTimeValues = true) {
            let request = null;
            if (convertTimeValues) {
                request = this.convertToPayloadUnits(employeeWorkBalance);
            } else {
                request = Object.assign({}, employeeWorkBalance);
            }
            request.year = this.currentMonthFrom.year();
            request.month = this.currentMonthFrom.month() + 1;
            request.valid = true;
            request.confirmed = false;

            return request;
        },
        createMultiEmployeeWorkBalance: function (convertTimeValues = true, returnPromise = false, toast = false) {
            let view = this;
            if (Object.values(this.multiCreateMap).length > 0) {
                this.balanceerror = false;

                let url = '/api/sec/employeeworkbalance/multi';
                let params = {
                    storeId: this.$store.state.storeId
                };
                let payload = {requests: []}
                Object.values(this.multiCreateMap).forEach(employeeWorkBalance => {
                    let request = this.buildRequestPayload(employeeWorkBalance, convertTimeValues)
                    payload.requests.push(request);
                });

                if (returnPromise) {
                    return this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    });
                } else {
                    this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        if (toast) {
                            view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 2));
                        }
                        view.$store.commit("invalidateState", {states: ['employeeWorkbalanceMapState']});

                        console.log("TRIGGERING REFRESH IN MULTI CREATE")
                        view.refresh();

                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$tc('workBalance.payroll.errorWorkBalanceUpdate', 2))
                        view.balanceerror = true;
                        console.log(error)
                    })
                }
            } else {
                if (returnPromise) {
                    return new Promise((accept, reject) => {
                        accept();
                    })
                } else {
                    if (toast) {
                        view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 2));
                    }
                }
            }


        },
        multiCreateWithToggle: function (workbalances, convertTimeValues = true, returnPromise = false, toast = false) {
            let view = this;
            if (workbalances.length > 0) {
                this.balanceerror = false;
                let url = '/api/sec/employeeworkbalance/multi/accountingperiodtoggle';
                let params = {
                    storeId: this.$store.state.storeId
                };
                let payload = {requests: []}
                workbalances.forEach(employeeWorkBalance => {
                    let request = this.buildRequestPayload(employeeWorkBalance, convertTimeValues)
                    payload.requests.push(request);
                });

                if (returnPromise) {
                    return this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    });
                } else {
                    this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        if (toast) {
                            view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 2));
                        }
                        view.$store.commit("invalidateState", {states: ['employeeWorkbalanceMapState']});

                        console.log("TRIGGERING REFRESH IN MULTI CREATE")
                        view.refresh();

                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$tc('workBalance.payroll.errorWorkBalanceUpdate', 2))
                        view.balanceerror = true;
                        console.log(error)
                    })
                }
            } else {
                // TODO: popup info nothing to create
                if (returnPromise) {
                    return new Promise((accept, reject) => {
                        accept();
                    })
                } else {
                    if (toast) {
                        view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 2));
                    }
                }
            }


        },
        OpenUnconfirmPopup() {
            let view = this;
            let description = this.$t('workBalance.payroll.undoBalanceQuery1') + '<br/><b>' + this.$t('global.ui.warning') +
                ':</b>' + this.$t('workBalance.payroll.undoBalanceQuery2') + '<b>' + this.$t('global.ui.all').toLowerCase() +
                '</b>' + this.$t('workBalance.payroll.undoBalanceQuery3');

            let employees = Object.values(view.workBalanceMap).filter(i => view.employeeMap[i.employeeId] != null).map(i => {
                return {
                    label: view.employeeMap[i.employeeId].lastName.toUpperCase() + " " + view.employeeMap[i.employeeId].firstName,
                    value: i.employeeId
                }
            });
            employees.sort((a, b) => {
                if (a.label.toUpperCase() < b.label.toUpperCase()) {
                    return -1;
                } else if (a.label.toUpperCase() < b.label.toUpperCase()) {
                    return 1;
                }
                return 0;
            })
            let dataEntries = [];

            dataEntries.push({
                label: this.$t('global.ui.selectEmployee'),
                key: 'employeeFlag',
                hidden: false,
                type: 'bool',
                value: false
            });

            dataEntries.push({
                label: this.$tc('global.general.employee'), key: 'employees', type: 'dropdownsearch', hidden: true,
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    items: employees.map(e => {
                        return {
                            label: e.label,
                            value: e.value,
                            selected: false
                        }
                    }),
                },
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let employeeFlag = datafill.entries.find(i => i.key == 'employeeFlag').value;
                    if (employeeFlag) {
                        entryBeforeUpdate.hidden = false;
                    } else {
                        entryBeforeUpdate.hidden = true;
                    }

                    return entryBeforeUpdate;
                }
            });

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    selectCallback: function (data) {
                        let workbalances = [];
                        if (data.employeeFlag) {
                            let employees = data.employees;
                            Object.values(view.workBalanceMap).filter(wb => wb.confirmed).forEach(wb => {
                                if (employees.includes(wb.employeeId)) {
                                    workbalances.push(wb);
                                }
                            })
                            view.UnconfirmMultipleWorkBalances(workbalances);
                        } else {
                            view.UnconfirmFutureWorkBalances();
                        }
                    }
                },
                header: this.$t('workBalance.payroll.undoBalance'),
                expanded: true,
                centered: true
            });

        },
        UnconfirmFutureWorkBalances() {
            let view = this;

            let url = '/api/sec/employeeworkbalance/unconfirm/future';
            let params = {
                storeId: this.$store.state.storeId
            };

            let payload = {
                year: this.currentMonthFrom.year(),
                month: this.currentMonthFrom.month() + 1
            }

            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 2));
                view.$store.commit("invalidateState", {states: ['employeeWorkbalanceMapState', 'employeePreferenceMapState', 'planShiftMapState', 'actualShiftMapState']});
                view.refresh(true);
                view.sendNotificationToML("unconfirm");
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$tc('workBalance.payroll.errorWorkBalanceUpdate', 2))
                view.balanceerror = true;
                console.log(error)
            })
        },
        UnconfirmMultipleWorkBalances(workBalances) {
            let view = this;

            let url = '/api/sec/employeeworkbalance/unconfirm';
            let params = {
                storeId: this.$store.state.storeId,
                date: this.currentMonthFrom.format()
            };

            let payload = {
                ids: workBalances.map(i => i.employeeId),
            }

            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 2));
                view.$store.commit("invalidateState", {states: ['employeeWorkbalanceMapState', 'employeePreferenceMapState', 'planShiftMapState', 'actualShiftMapState']});
                view.refresh(true);
                view.sendNotificationToML("unconfirm");
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$tc('workBalance.payroll.errorWorkBalanceUpdate', 2))
                view.balanceerror = true;
                console.log(error)
            })
        },
        openNotificationPopup() {
            let view = this;
            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: [],
                    description: 'Soll eine Benachrichtigung zu Meine Lohnabrechnug über diesen Monatsabschluss geschickt werden?',
                    positiveButtonLabel: this.$t('global.ui.approve'),
                    negativeButtonLabel: this.$t('global.ui.cancel'),
                    selectCallback: function (data) {
                        view.sendNotificationToML("confirm");
                    },
                    deleteCallback: function () {
                    }
                },
                header: '<div class="label" style="font-size: 22px;font-weight:200;">MEINE</div><div class="label" style="font-size: 22px;font-family: DistrictProBold;font-weight:800;">LOHNABRECHNUNG</div><div class="label" style="font-size: 22px;font-weight:300;">&nbsp;benachrichtigen</div>',
                expanded: true,

                width: "700px",
                centered: true
            });

        },
        sendNotificationToML(type) {
            let view = this;
            let url = '/api/sec/employeeworkbalance/notification';
            let params = {
                storeId: view.$store.state.storeId
            };

            let payload = {
                year: view.currentMonthFrom.year(),
                month: view.currentMonthFrom.month() + 1,
                type: type
            }

            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                //view.$helpers.success('Benachrichtigung erfolgreich', '');
            }).catch(function (error) {
                //view.$helpers.error('Benachrichtigung fehlgeschlagen', '')
                console.log(error)
            })
        },

        GenerateAutoEqualizeEmployeeList() {
            let list = [];
            let selectedList = [];
            let selectedItems = [];

            Object.values(this.employeeMap)
                .sort((a, b) => {

                    if (a != undefined && b != undefined) {
                        if (a.lastName < b.lastName) return -1;
                        if (a.lastName > b.lastName) return 1;
                        if (a.lastName == b.lastName && a.firstName < b.firstName) return -1;
                        if (a.lastName == b.lastName && a.firstName > b.firstName) return 1;
                    }
                    return 0;
                }).forEach(emp => {
                if (this.employeeEmployeeWorkBalanceMap[emp.id]) {
                    let selected = this.employeeEmployeeWorkBalanceMap[emp.id] && this.employeeEmployeeWorkBalanceMap[emp.id].autoEqualize;
                    let item = {label: emp.lastName + " " + emp.firstName, value: emp.id, selected: selected};
                    list.push(item);
                    if (selected) {
                        selectedList.push(item.value);
                        selectedItems.push(item.value);
                    }
                }
            });
            return {
                items: list,
                selectedEmployeeIds: selectedList,
                selectedItems: selectedItems
            };
        },

        OpenSelectAutoEqualizeEmployeesPopup() {
            let view = this;

            let employeeitems = this.GenerateAutoEqualizeEmployeeList();
            let dataEntries = [
                {divider: true},
                {
                    label: this.$tc('global.general.employee'),
                    key: 'employeeIds',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: null,
                    selectMultiple: false,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: employeeitems.items,
                        selectMultiple: true,
                        selectedItems: [],
                        selectedItem: {},
                        onceSelected: function ($event, item, searchbar) {
                            item.selected = true;
                        },
                        styleLight: true,
                        placeholder: this.$tc('global.general.employee')
                    },
                    styles: {width: '100%'}
                },
            ];


            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (item) {
                        let employeeIds = item.employeeIds;
                        console.log('Employee IDs enabled for auto equalize:');
                        console.log(employeeIds);
                        view.UpdateAutoEqualizeMultiEmployees(employeeIds);
                    },
                    description: this.$t('workBalance.payroll.overwriteAutoReconcile')
                },
                header: this.$t('global.ui.selectEmployee'),
                remainAfterSelect: false,
                expanded: true,
                maxw50: true, // new property, defines max-width: 50% as this looks a lot nicer with long descriptions in datafill state
                centered: true
            });
        },

        GenerateStarterEmployeeList() {
            let list = [];

            Object.values(this.employeeMap)
                .sort((a, b) => {

                    if (a != undefined && b != undefined) {
                        if (a.lastName < b.lastName) return -1;
                        if (a.lastName > b.lastName) return 1;
                        if (a.lastName == b.lastName && a.firstName < b.firstName) return -1;
                        if (a.lastName == b.lastName && a.firstName > b.firstName) return 1;
                    }
                    return 0;
                }).forEach(emp => {

                if (this.employeeEmployeeWorkBalanceMap[emp.id] && !this.employeePrevMonthEmployeeWorkBalanceMap[emp.id]) {
                    let item = {label: emp.lastName + " " + emp.firstName, value: emp.id};
                    list.push(item);
                }
            });
            return list;
        },
        OpenRecalculatePopup() {
            let view = this;


            let items = [
                {label: this.$t('workBalance.payroll.allShifts'), value: 1},
                {label: this.$t('workBalance.payroll.actualShiftsOnly'), value: 2},
                {label: this.$t('workBalance.payroll.targetShiftsOnly'), value: 3},
            ]
            let dataEntries = [
                {
                    label: this.$t('store.settings.shifts'),
                    key: 'creationMode',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: null,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: items,
                        selectMultiple: false,
                        selectFirst: true,
                        selectedItems: [],
                        selectedItem: {},
                        onceSelected: function ($event, item, searchbar) {

                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.shifts'),
                    },
                    styles: {width: '342px'}
                },
                {
                    label: this.$t('workBalance.payroll.removeMods'),
                    key: 'erasePayment',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: true
                },

            ];


            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (item) {
                        view.calculateUnconfirmedWorkBalances(true, true, item.creationMode, item.erasePayment);


                    },
                },
                header: this.$tc('workBalance.payroll.recalculateWorkBalance', 2),
                remainAfterSelect: false,
                expanded: true,
                centered: true
            });
        },

        OpenChangeStartValuesPopup() {
            let view = this;

            let employeeitems = this.GenerateStarterEmployeeList();

            let dataEntries = [
                {
                    label: this.$tc('global.general.employee'),
                    key: 'employeeId',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: null,
                    selectMultiple: false,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: employeeitems,
                        selectMultiple: false,
                        selectedItems: [],
                        selectedItem: {},
                        onceSelected: function ($event, item, searchbar) {
                            let ewb = view.employeeEmployeeWorkBalanceMap[item.value];
                            let vacationTimeBalance = searchbar.$parent.entries.find(i => i.key == 'vacationTimeBalance');
                            vacationTimeBalance.value = ewb.vacationTimeBalance / (24 * 60);
                        },
                        styleLight: true,
                        placeholder: this.$tc('global.general.employee'),
                    },
                    styles: {width: '342px'}
                },
                {
                    label: this.$t('workBalance.payroll.autoVacationEntitlement'),
                    key: 'autoVacationTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: false
                },
                {
                    label: this.$t('pages.employeeContract.vacationEntitlement'),
                    key: 'vacationTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'numeric',
                    value: 0
                },
            ];


            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (item) {
                        let ewb = view.employeeEmployeeWorkBalanceMap[item.employeeId];
                        let newVacationTimeBalance;
                        if (item.autoVacationTimeBalance) {
                            let employee = view.employeeMap[item.employeeId];
                            newVacationTimeBalance = view.$helpers.CalculateVacationTimeBalance(employee, view.previousMonthWorkBalanceMap, view.workBalanceMap, view.employeeContractMap, view.nextMonthEmployeeContractMap, view.currentMonthFromTZ, view.currentMonthToTZ, view.currentMonthFrom, view.storeSettings);
                        } else {
                            newVacationTimeBalance = Math.round(item.vacationTimeBalance * 24 * 60);
                        }

                        let delta = newVacationTimeBalance - ewb.vacationTimeBalance;

                        view.UpdateEmployeeWorkbalanceDelta(item.employeeId, delta);
                    },
                },
                header: this.$t('workBalance.payroll.editStartingValues'),
                remainAfterSelect: false,
                expanded: true,
                centered: true
            });
        },
        UpdateEmployeeWorkbalanceDelta(employeeId, vacationTimeBalanceDelta) {
            let view = this;

            let url = '/api/sec/employeeworkbalance/delta';
            let params = {
                storeId: this.$store.state.storeId
            };

            let payload = {
                employeeId: employeeId,
                vacationTimeBalanceDelta: vacationTimeBalanceDelta,
                month: this.currentMonthFrom.month() + 1,
                year: this.currentMonthFrom.year()
            }

            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let entry = view.employeeEmployeeWorkBalanceMap[employeeId];
                entry.vacationTimeBalance = entry.vacationTimeBalance + vacationTimeBalanceDelta;
                view.$store.commit("setEmployeeWorkbalanceMapEntry", entry);
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 1));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$tc('workBalance.payroll.errorWorkBalanceUpdate', 1))
                view.balanceerror = true;
                console.log(error)
            })
        },
        ToggleAutoCalc(employeeWorkBalanceId, value) {
            let view = this;

            let url = '/api/sec/employeeworkbalance';
            let params = {
                storeId: this.$store.state.storeId
            };

            let payload = {
                id: employeeWorkBalanceId,
                autoCalc: value,
                updateFields: ["autoCalc"]
            }

            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let entry = view.workBalanceMap[employeeWorkBalanceId];
                entry.autoCalc = value;
                view.$set(view.workBalanceMap, employeeWorkBalanceId, entry);
                view.$store.commit("setEmployeeWorkbalanceMapEntry", entry);
                view.$helpers.success(view.$t('global.notifications.updateMessage'), '');
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('global.notifications.updateFailedMessage'))
                view.balanceerror = true;
                console.log(error)
            })

        },

        ToggleAutoCalcMulti() {
            let requests = []
            Object.values(this.workBalanceMap).filter(ewb => !ewb.confirmed).forEach(ewb => {
                let req = {id: ewb.id, storeId: this.storeId, autoCalc: !ewb.autoCalc, updateFields: ["autoCalc"]};
                requests.push(req);
            })
            if (requests.length > 0) {
                this.doMultiUpdate(requests);
            }

        },
        UpdateAutoCalcMulti(enabled) {
            let requests = []
            Object.values(this.workBalanceMap).filter(ewb => !ewb.confirmed).forEach(ewb => {
                if (enabled && !ewb.autoCalc || !enabled && ewb.autoCalc) {
                    let req = {id: ewb.id, storeId: this.storeId, autoCalc: enabled, updateFields: ["autoCalc"]};
                    requests.push(req);
                }
            })
            if (requests.length > 0) {
                this.doMultiUpdate(requests);
            }
        },
        ToggleAutoEqualize(employeeWorkBalanceId, value) {
            let view = this;

            let url = '/api/sec/employeeworkbalance';
            let params = {
                storeId: this.$store.state.storeId
            };

            let payload = {
                id: employeeWorkBalanceId,
                autoEqualize: value,
                updateFields: ["autoEqualize"]
            }

            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let entry = view.workBalanceMap[employeeWorkBalanceId];
                entry.autoEqualize = value;
                view.$store.commit("setEmployeeWorkbalanceMapEntry", entry);
                if (value) {
                    view.refresh(false, false, false, () => {
                        console.log('Finished callback for refresh - calculateUnconfirmedWorkBalances');
                        view.calculateUnconfirmedWorkBalances(true, true, 1, true);
                    });
                }
                view.$helpers.success(view.$t('global.notifications.updateMessage'), '');
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('global.notifications.updateFailedMessage'))
                view.balanceerror = true;
                console.log(error)
            })

        },

        ToggleAutoEqualizeMulti() {
            let requests = []
            let recalculate = false;
            Object.values(this.workBalanceMap).filter(ewb => !ewb.confirmed).forEach(ewb => {
                let req = {
                    id: ewb.id,
                    storeId: this.storeId,
                    autoEqualize: !ewb.autoEqualize,
                    updateFields: ["autoEqualize"]
                };
                if (!ewb.autoEqualize) recalculate = true;
                requests.push(req);
            })
            if (requests.length > 0) {
                this.doMultiUpdate(requests, recalculate);
            }

        },
        UpdateAutoEqualizeMulti(enabled) {
            let requests = []
            Object.values(this.workBalanceMap).filter(ewb => !ewb.confirmed).forEach(ewb => {
                if (enabled && !ewb.autoEqualize || !enabled && ewb.autoEqualize) {
                    let req = {
                        id: ewb.id,
                        storeId: this.storeId,
                        autoEqualize: enabled,
                        updateFields: ["autoEqualize"]
                    };
                    requests.push(req);
                }
            })
            if (requests.length > 0) {
                this.doMultiUpdate(requests, enabled);
            }
        },
        UpdateAutoEqualizeMultiEmployees(enabledEmployeeIds) {
            let requests = []
            let calculate = false;
            let updatedEnabled = 0;
            let updatedDisabled = 0;
            Object.values(this.workBalanceMap).filter(ewb => !ewb.confirmed).forEach(ewb => {
                let ewbEmplId = ewb.employeeId;
                let enabled = enabledEmployeeIds.includes(ewbEmplId);
                if (enabled && !ewb.autoEqualize || !enabled && ewb.autoEqualize) {
                    let req = {
                        id: ewb.id,
                        storeId: this.storeId,
                        autoEqualize: enabled,
                        updateFields: ["autoEqualize"]
                    };
                    calculate = true;
                    requests.push(req);
                    if (enabled) updatedEnabled++;
                    else updatedDisabled++
                }
            })
            if (requests.length > 0) {
                console.log('Updating autoEqualize for ' + requests.length + ' employees');
                console.log('Enabled: ' + updatedEnabled + ' :: Disabled: ' + updatedDisabled);
                this.doMultiUpdate(requests, calculate);
            }
        },
        resetPaidColumns() {
            let view = this;
            Object.values(this.workBalanceMap).filter(ewb => !ewb.confirmed).forEach(ewb => {
                let paidHolidayTime = ewb.paidHolidayTime;
                let paidVacationTime = ewb.paidVacationTime;
                let paidWorkTime = ewb.paidWorkTime;
                let zero = "0";
                if (paidHolidayTime != 0) {
                    view.dataUpdatedByUser(zero, {'paidHolidayTime': paidHolidayTime, 'id': ewb.id}, 'paidHolidayTime');
                }
                if (paidVacationTime != 0) {
                    view.dataUpdatedByUser(zero, {
                        'paidVacationTime': paidVacationTime,
                        'id': ewb.id
                    }, 'paidVacationTime');
                }
                if (paidWorkTime != 0) {
                    view.dataUpdatedByUser(zero, {'paidWorkTime': paidWorkTime, 'id': ewb.id}, 'paidWorkTime');
                }
            });

        },
        doMultiUpdate(requests, recalculate = false, callbackSuccess) {
            let view = this;
            let url = '/api/sec/employeeworkbalance/multi';
            let params = {
                storeId: this.$store.state.storeId
            };

            let payload = {
                requests: requests
            }

            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                if (callbackSuccess) {
                    callbackSuccess();
                } else {
                    view.$store.commit("invalidateState", {states: ['employeeWorkbalanceMapState']});
                    console.log("CALLING REFRESH FROM MULTIUPDATE")
                    if (recalculate) {
                        view.refresh(false, false, false, () => {
                            console.log('Finished callback for refresh - calculateUnconfirmedWorkBalances');
                            view.calculateUnconfirmedWorkBalances(true, true, 1, true);
                        });
                    } else {
                        view.refresh();
                    }
                    view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 2));
                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$tc('workBalance.payroll.errorWorkBalanceUpdate', 2))

                console.log(error)
            })
        },

        calculateInvalidWorkBalances(toast = false, forced = false, creationMode = 1, erasePayment = false) {

            console.log("CALCULATING INVALIDWORKBALANCES, FORCE: " + forced + " MODE: " + creationMode)
            let exclEmplIds = [];
            let employeeIds = [];
            Object.values(this.workBalanceMap).forEach((wb) => {
                if ((wb.valid && !forced) || (!wb.autoCalc && !forced) || wb.confirmed || (this.preUsageStartDateMonth && !forced)) exclEmplIds.push(wb.employeeId);
            });
            Object.values(this.employeeMap).forEach((empl) => {
                if (!exclEmplIds.includes(empl.id)) employeeIds.push(empl.id);
            });
            this.doMultiCreate(employeeIds, toast, creationMode, erasePayment);
        },
        calculateUnconfirmedWorkBalances(toast = false, forced = false, creationMode = 1, erasePayment = false) {
            let exclEmplIds = [];
            let employeeIds = [];
            Object.values(this.workBalanceMap).forEach((wb) => {
                if (wb.confirmed || (this.preUsageStartDateMonth && !forced)) exclEmplIds.push(wb.employeeId);
            });
            Object.values(this.employeeMap).forEach((empl) => {
                if (!exclEmplIds.includes(empl.id)) {
                    employeeIds.push(empl.id);
                    console.log("Recalculating unconfirmed wb for " + empl.lastName + " " + empl.firstName);
                }
            });
            console.log('Calculate unconfirmed work balances for ' + employeeIds.length + ' employees');
            this.doMultiCreate(employeeIds, toast, creationMode, erasePayment);
        },
        doMultiCreate(employeeIds, toast = false, creationMode = 1, erasePayment = false, accPeriodSetting = null, confirm = false) {
            //create workbalances without user supervision
            this.employeeOptions = employeeIds;

            let view = this;
            this.init(false)
                .then(result => {
                    view.calculateMultiEmployeeWorkBalance(this.validEmployeeOptions.map(employee => employee.id), creationMode, erasePayment, accPeriodSetting);
                    if (confirm) {
                        view.createMultiEmployeeWorkBalance(true, true, toast)
                            .then(res => {
                                return view.confirmEmployeeWorkBalances(this.validEmployeeOptions.map(employee => employee.id));
                            }).then(res => {
                            view.$store.commit("invalidateState", {states: ['employeeWorkbalanceMapState', 'planShiftMapState', 'employeePreferenceMapState']});
                            view.$helpers.success(view.$t('global.notifications.confirmSuccessful'), view.$t('workBalance.payroll.workBalanceConfirmed'))
                            view.sendNotificationToML("confirm");
                            view.refresh();
                        }).catch(error => {
                            console.log(error);
                            view.$helpers.error(view.$t('global.notifications.error'), view.$tc('workBalance.payroll.errorWorkBalanceUpdate', 2));
                        })
                    } else {
                        view.createMultiEmployeeWorkBalance(true, false, toast);
                    }

                }).catch(error => {
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.loadingWorkBalanceError'));
            })

        },
        calculateMultiEmployeeWorkBalance(employeeIds, creationMode = 1, erasePayment = false, accPeriodSetting = null) {
            let view = this;
            let multiCreateMap = {};
            Object.values(this.employeeMap).filter(employee => employeeIds.includes(employee.id)).forEach(employee => {
                let balance = this.calculateEWB(employee, creationMode, erasePayment, false, accPeriodSetting);
                multiCreateMap[employee.id] = balance;

            });

            this.multiCreateMap = multiCreateMap;

        },
        getEmployeeMainContractMap() {
            let view = this;
            let map = {};
            Object.values(this.employeeMap).forEach(e => {
                map[e.id] = view.getMainContractForEmployee(e.id);
            });
            return map;
        },
        getMainContractForEmployee(employeeId) {
            let mainContract = null
            if (this.employeeContractMap[employeeId]) {
                let contracts = this.employeeContractMap[employeeId];
                contracts.forEach(contract => {

                    let contractFrom = this.$helpers.getMomentFromStringTZ(contract.from);
                    let contractTo = contract.to == null ? this.currentMonthTo : this.$helpers.getMomentFromStringTZ(contract.to);
                    if (contractFrom < this.currentMonthFromTZ) {
                        contractFrom = this.currentMonthFromTZ;
                    }
                    if (contractTo > this.currentMonthToTZ) {
                        contractTo = this.currentMonthToTZ;
                    }

                    if (!mainContract) {
                        mainContract = contract;
                    } else {
                        let mainContractFrom = this.$helpers.getMomentFromStringTZ(mainContract.from);
                        if (contractFrom > mainContractFrom) {
                            mainContract = contract;
                        }
                    }
                });
            }
            return mainContract;
        },
        getMainContractForEmployeeForCurrentMonth(employeeId) {
            let mainContract = null
            if (this.employeeContractMap[employeeId]) {
                let contracts = this.employeeContractMap[employeeId];
                if (contracts != null) {
                    let overlappingContracts = this.$helpers.GetContractsOverlappingMonth(contracts, this.currentMonthFromTZ.clone().startOf('week').subtract(1, 'days'), this.currentMonthToTZ);
                    overlappingContracts.forEach(contract => {

                        let contractFrom = this.$helpers.getMomentFromStringTZ(contract.from);

                        if (!mainContract) {
                            mainContract = contract;
                        } else {
                            let mainContractFrom = this.$helpers.getMomentFromStringTZ(mainContract.from);
                            if (contractFrom > mainContractFrom) {
                                mainContract = contract;
                            }
                        }
                    });
                }

            }
            return mainContract;
        },
        getMainContractForEmployeeForNextMonth(employeeId, futureContracts) {
            let mainContract = null
            if (this.employeeContractMap[employeeId]) {
                let contracts = futureContracts[employeeId];
                if (contracts != null) {
                    let overlappingContracts = this.$helpers.GetContractsOverlappingMonth(contracts, this.currentMonthFromTZ.clone().add(1, 'month'), this.currentMonthToTZ.clone().add(1, 'month'));
                    overlappingContracts.forEach(contract => {

                        let contractFrom = this.$helpers.getMomentFromStringTZ(contract.from);

                        if (!mainContract) {
                            mainContract = contract;
                        } else {
                            let mainContractFrom = this.$helpers.getMomentFromStringTZ(mainContract.from);
                            if (contractFrom > mainContractFrom) {
                                mainContract = contract;
                            }
                        }
                    });
                }

            }
            return mainContract;
        },

        calculateEWB(employee, workTimeBalanceCreationMode = 1, erasePayment = false, disableAccountingPeriodSetting = false, accPeriodSetting = null) {
            let accountingPeriodSettings = accPeriodSetting == null ? Object.values(this.accountingPeriodSettingsMap).filter(i => i.month == this.currentMonthFrom.month()) : [accPeriodSetting];
            let contractExitSettings = Object.values(this.contractExitSettingMap).length > 0 ? Object.values(this.contractExitSettingMap) : [];
            return this.$helpers.calculateEmployeeWorkBalance(employee, this.previousMonthWorkBalanceMap,
                this.employeeContractMap, this.nextMonthEmployeeContractMap, this.allowedContractMap, this.collectiveContractMap,
                this.employeePlanShiftMap, this.employeeDateActualShiftMap, this.employeeDateActualShiftMarkedMap, this.holidayMap, this.actualShiftBreakMap,
                this.employeePreferenceMap, this.workBalanceMap, this.spotMap, this.storeSettings, this.currentMonthFrom, this.currentMonthTo, this.currentMonthFromTZ, this.currentMonthToTZ,
                workTimeBalanceCreationMode, erasePayment, accountingPeriodSettings, contractExitSettings,
                disableAccountingPeriodSetting, this.exitReasonReverseIdMap, this.bonusPaymentSettingsMap, this.employeeAvgWorktimeMap);

        },
        calculateRegularEmployeeBonusPayments(employeeId, mode = 1) {


            return this.$helpers.calculateRegularBonusPayments(employeeId, this.employeeContractMap, this.allowedContractMap, this.collectiveContractMap,
                this.employeePlanShiftMap, this.employeeDateActualShiftMap, this.employeeDateActualShiftMarkedMap, this.actualShiftBreakMap,
                this.currentMonthFrom, this.currentMonthTo, this.currentMonthFromTZ, this.currentMonthToTZ, this.storeSettings,
                mode
            );

        },
        calculateCustomEmployeeBonusPayments(employeeId, bonusPaymentSettingsMap, mode = 1) {

            return this.$helpers.calculateCustomBonusPayments(this.employeeMap[employeeId], this.employeeContractMap,
                this.employeePlanShiftMap, this.employeeDateActualShiftMap, this.employeeDateActualShiftMarkedMap, this.actualShiftBreakMap,
                this.currentMonthFrom, this.currentMonthTo, this.currentMonthFromTZ, this.currentMonthToTZ,
                this.allowedContractMap, this.spotMap, bonusPaymentSettingsMap, this.holidayMap, mode);

        },
        loadPreviousMonthEmployeeWorkBalances: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let view = this;
                let url = '/api/sec/employeeworkbalance/any/employee';
                let from = this.currentMonthFrom.clone().subtract(1, 'months').startOf('month');

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 1).format(),
                    to: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 2).format(),
                };

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                })
            }

        },
        loadLatestEmployeeWorkBalancesWithAccountingPeriodApplied() {
            let view = this;
            let url = '/api/sec/employeeworkbalance/latestaccountingperiod';
            let from = this.currentMonthFrom.clone().subtract(1, 'months').startOf('month');

            let params = {
                storeId: this.$store.state.storeId,
                to: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 2).format(),
            };

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
            })
        },
        updateLatestEmployeeAccPeriod(data) {
            let map = {};
            data.forEach(ewb => {
                map[ewb.employeeId] = ewb;
            })
            this.latestEmployeeAccPeriodMap = map;
        },
        getMoment: function (str) {

            return this.$helpers.getMomentFromStringTZ(str);
        },

        loadPlanShifts: function (payload) {
            let url = '/api/sec/planshift';
            let params = {
                from: this.currentMonthFromTZ.clone().startOf('week').subtract(1, 'days').format(),
                to: this.currentMonthToTZ.clone().endOf('week').add(1, 'days').startOf('day').format(),
            };


            return this.$helpers.RecursiveGETPaged(url, [], params, 1, 3);

        },
        loadActualShifts: function (payload) {
            let url = '/api/sec/actualshift';
            let params = {
                from: this.currentMonthFromTZ.clone().startOf('week').subtract(1, 'days').format(),
                to: this.currentMonthToTZ.clone().endOf('week').add(1, 'days').startOf('day').format(),
            };
            return this.$helpers.RecursiveGETPaged(url, [], params, 1, 3);


        },
        loadActualBreaks: function (payload) {
            let url = '/api/sec/actualbreak';
            let params = {
                from: this.currentMonthFromTZ.clone().startOf('week').subtract(1, 'days').format(),
                to: this.currentMonthToTZ.clone().endOf('week').add(1, 'days').startOf('day').format(),
            };
            return this.$helpers.RecursiveGETPaged(url, [], params, 1, 3);


        },
        loadEmployeePreferences: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/employeepreference/any/employee';
                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.currentMonthFromTZ.clone().startOf('week').subtract(1, 'days').format(),
                    to: this.currentMonthToTZ.clone().endOf('week').add(1, 'days').startOf('day').format(),
                    approved: true
                }


                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                })
            }
        },
        loadEmployeeContracts: function (payload, from, to) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/employeecontract/any/employee';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: from.clone().startOf('week').subtract(1, 'days').format(),
                    to: to.clone().endOf('week').add(1, 'days').startOf('day').format(),
                    overlapping: true
                };

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                });
            }

        },
        loadNextMonthEmployeeContracts: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({data: []});
                })
            } else {
                let url = '/api/sec/employeecontract/any/employee';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.currentMonthFromTZ.clone().add(1, 'month').format(),
                    to: this.currentMonthToTZ.clone().add(1, 'month').format(),
                    overlapping: true
                };

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                });
            }

        },
        updateNextMonthEmployeeContracts: function (data) {
            let employeeContractMap = {};
            for (let i = 0; i < data.length; i++) {
                if (employeeContractMap[data[i].employeeId]) {
                    let prevStart = this.$helpers.getMomentFromStringTZ(employeeContractMap[data[i].employeeId]);
                    let start = this.$helpers.getMomentFromStringTZ(data[i].from);
                    if (start < prevStart) {
                        employeeContractMap[data[i].employeeId] = data[i];
                    }
                } else {
                    employeeContractMap[data[i].employeeId] = data[i];
                }
            }
            this.nextMonthEmployeeContractMap = employeeContractMap;
        },
        loadHolidays: function () {

            let url = '/api/sec/storeevent';
            let params = {
                storeId: this.$store.state.storeId,
                from: this.currentMonthFromTZ.format(),
                to: this.currentMonthToTZ.format(),
                active: true,
            };
            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })
        },
        loadValidEmployeeWorkBalanceEmployees: function () {
            let url = '/api/sec/employeeworkbalance/valid/employee';
            let params = {
                storeId: this.$store.state.storeId,
                date: this.currentMonthUTC.format(),
            };
            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })
        },
        loadNextValidEmployeeWorkBalanceDates() {
            let url = '/api/sec/employeeworkbalance/valid/date';
            let params = {
                storeId: this.$store.state.storeId,
            };


            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })
        },
        updateNextValidEmployeeWorkBalanceDates: function (data) {

            let map = {}

            for (let i = 0; i < data.length; i++) {
                map[data[i].employeeId] = this.$helpers.getMomentFromStringUTC(data[i].date);
            }
            this.employeeNextValidDateMap = map;
        },
        loadEarliestUnconfirmed: function () {
            let url = '/api/sec/employeeworkbalance/earliest/unconfirmed';
            let params = {
                storeId: this.$store.state.storeId,
                date: this.currentMonthUTC.format(),
            };

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })
        },
        updateEarliestUnconfirmed: function (data) {
            let map = {}
            data.forEach(item => {
                map[item.employeeId] = this.$helpers.getMomentFromStringUTC(item.date);
            })
            this.earliestUnconfirmedMap = map;
        },
        updateValidEmployeeWorkBalanceEmployees: function (data) {
            let map = {}
            let view = this;
            data.forEach(item => {
                map[item.employeeId] = true;
            })
            this.validEmployeeMap = map;
        },
        updateHolidays: function (data) {

            let tholidays = {}
            for (let i = 0; i < data.length; i++) {

                let holiday = data[i];
                if (holiday.federalHoliday || holiday.bankHoliday || holiday.contractHoliday) {
                    holiday.fromMoment = this.$helpers.getMomentFromStringTZ(holiday.from);
                    holiday.toMoment = this.$helpers.getMomentFromStringTZ(holiday.to);
                    tholidays[data[i].id] = holiday;
                }


            }

            this.holidayMap = tholidays;
        },
        updateActualShifts: function (data) {

            let actualShiftMap = {}

            for (let i = 0; i < data.length; i++) {
                actualShiftMap[data[i].id] = data[i];
            }

            this.actualShiftMap = actualShiftMap;
        },
        updateActualBreaks: function (data) {

            let actualBreakMap = {}

            for (let i = 0; i < data.length; i++) {
                actualBreakMap[data[i].id] = data[i];
            }

            this.actualBreakMap = actualBreakMap;
        },
        updateEmployees: function (data) {

            let employeeMap = {}

            for (let i = 0; i < data.length; i++) {
                employeeMap[data[i].id] = data[i];
            }

            this.employeeMap = employeeMap;
        },
        updateEmployeeWorkBalances: function (data) {
            let workBalanceMap = {};
            for (let i = 0; i < data.length; i++) {
                workBalanceMap[data[i].id] = data[i];
            }

            this.workBalanceMap = workBalanceMap;
        },
        updatePreviousMonthEmployeeWorkBalances: function (data) {
            let previousMonthWorkBalanceMap = {};
            for (let i = 0; i < data.length; i++) {
                previousMonthWorkBalanceMap[data[i].employeeId] = data[i];
            }
            this.previousMonthWorkBalanceMap = previousMonthWorkBalanceMap;
        },
        updateEmployeePlanShifts: function (data) {
            let employeePlanShiftMap = {};
            for (let i = 0; i < data.length; i++) {
                if (data[i].employeeId) {
                    if (!employeePlanShiftMap[data[i].employeeId]) {
                        employeePlanShiftMap[data[i].employeeId] = [];
                    }
                    employeePlanShiftMap[data[i].employeeId].push(data[i]);
                }

            }
            this.employeePlanShiftMap = employeePlanShiftMap;
        },
        updateEmployeePreferences: function (data) {
            let employeePreferenceMap = {};
            for (let i = 0; i < data.length; i++) {
                if (!employeePreferenceMap[data[i].employeeId]) {
                    employeePreferenceMap[data[i].employeeId] = [];
                }
                employeePreferenceMap[data[i].employeeId].push(data[i]);
            }
            this.employeePreferenceMap = employeePreferenceMap;
        },
        updateEmployeeContracts: function (data) {
            let employeeContractMap = {};
            for (let i = 0; i < data.length; i++) {
                if (!employeeContractMap[data[i].employeeId]) {
                    employeeContractMap[data[i].employeeId] = [];
                }
                employeeContractMap[data[i].employeeId].push(data[i]);
            }
            this.employeeContractMap = employeeContractMap;
        },
        setDateSelection(date) {
            let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
            this.dateSelectionStart = fixedDate;

            this.currentDate = fixedDate.date();
            this.currentMonth = fixedDate.month();
            this.currentYear = fixedDate.year();

            //update vuex store with calculated from to => triggers reload of data via refresh
            let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
            this.$store.commit('setRosterFromTo', {
                rosterFromTo: rosterFromTo
            });
            this.mzConfirmed = false;
            this.$forceUpdate();
        },
        PreviousDate() {
            let timeframe = 'month';
            let before = this.timeFrameStart.clone();

            this.timeFrameStart = this.timeFrameStart.add(-1, timeframe).clone();
            this.currentDate = this.timeFrameStart.date();
            this.currentMonth = this.timeFrameStart.month();
            this.currentYear = this.timeFrameStart.year();

            let rosterDate = this.timeFrameStart.clone().startOf('month');
            this.setDateSelection(rosterDate);

            this.$forceUpdate();
        },
        NextDate() {
            let timeframe = 'month';
            let before = this.timeFrameStart.clone();

            this.timeFrameStart = this.timeFrameStart.add(1, timeframe).clone();
            this.currentDate = this.timeFrameStart.date();
            this.currentMonth = this.timeFrameStart.month();
            this.currentYear = this.timeFrameStart.year();

            let rosterDate = this.timeFrameStart.clone().startOf('month');
            this.setDateSelection(rosterDate);

            this.$forceUpdate();
        },
        SetDateToCurrentDay() {
            this.timeFrameStart = this.$helpers.getMomentTZ().startOf('month');
            this.currentDate = this.timeFrameStart.date();
            this.currentMonth = this.timeFrameStart.month();
            this.currentYear = this.timeFrameStart.year();
            this.setDateSelection(this.timeFrameStart);
        },
        toggleDatePicker($event) {
            let view = this;
            let date = this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear);
            this.$helpers.OpenDatepickerPopup(
                {viewsEnabled: ['M'], date: date},
                {
                    OnDateSelect: (date) => {
                        view.onDatePicked(date)
                    },
                },
                {elRelative: $event ? $event.currentTarget : null});
        },
        onDatePicked(date) {
            let before = this.timeFrameStart.clone();
            this.timeFrameStart = date.clone();
            let rosterDate = this.timeFrameStart.clone().startOf('month');
            this.setDateSelection(rosterDate);
        },
        validateAllWorkBalances() {
            let ids = [];
            let multiMap = {};
            Object.values(this.workBalanceMap).forEach((w) => {
                if (!w.valid) multiMap[w.employeeId] = w;
            });
            this.multiCreateMap = multiMap;
            this.createMultiEmployeeWorkBalance(false, false, true);
        },
        validateEmployeeWorkBalances: function (balanceIds) {
            let view = this;
            let url = '/api/sec/employeeworkbalance/validate';

            let params = {
                storeId: this.$store.state.storeId
            };

            let payload = {
                ids: balanceIds
            }

            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload,
            }).then(response => {
                if (response.data.data && response.data.data.length > 0) {
                    response.data.data.forEach(id => {
                        let entity = view.workBalanceMap[id];
                        entity.valid = true;
                        view.$set(view.workBalanceMap, id, entity);
                    })
                    view.$helpers.success(view.$t('global.notifications.updateMessage'), 'Gültig erklären wurde erfolgreich abgeschlossen')
                } else {
                    view.$helpers.error(view.$t('global.notifications.updateFailed'), 'Fehler beim Gültig erklären der Monatsabschlüsse');
                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), 'Fehler beim Gültig erklären des Monatsabschlüsse');
                console.log(error)
            })
        },


        checkConfirmShouldProceed() {
            let result = false;
            if (this.confirmEmployeeWorkBalanceState.confirmTodoDates.length > 0) {
                this.$helpers.error(this.$t('global.notifications.error'), this.$t('workBalance.payroll.previousMonthClosingError'))
            } else if (this.confirmEmployeeWorkBalanceState.confirmableEmployees.length == 0) {
                this.$helpers.success(this.$t('workBalance.payroll.monthClosingConfirmed'), this.$t('workBalance.payroll.monthClosingConfirmedMessage'))
                result = false;
            } else {
                result = true;
            }
            return result;
        },
        startConfirmProcessMD() {
            if (this.storeSettings.useAvgWorkTimeForPrefs && this.employeesWithoutAvgWorktime.length > 0) {
                this.OpenAvgWorktimeMissingModal();
            } else if (this.checkConfirmShouldProceed) {
                //this.showModal('modal-confirmworkbalance');
                this.OpenConfirmWorkBalanceModal();
            }

        },
        OpenConfirmWorkBalanceModal() {
            let view = this;
            let description = "";
            if (view.confirmEmployeeWorkBalanceState.confirmTodoDates.length == 0) {
                description = "<p>" + this.$t('workBalance.payroll.monthClosingQuery1') + "</p>";
                description += "<p>" + this.$t('workBalance.payroll.monthClosingWarning');

            } else {
                description += "<p><b>" + this.$t('global.ui.warning') + "!</b></p>"
                description += this.$t('workBalance.payroll.monthClosingsMissingError')
                description += "<ul>";
                view.confirmEmployeeWorkBalanceState.confirmTodoDates.forEach(date => {
                    description += "<li>" + date.format("MMMM YYYY") + "</li>";
                })
                description += "</ul>";
            }


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: [],
                    description: description,
                    positiveButtonLabel: this.$t('global.ui.approve'),
                    negativeButtonLabel: this.$t('global.ui.cancel'),
                    selectCallback: function (data) {
                        view.continueConfirmProcessMD();
                    },
                    deleteCallback: function () {
                    }
                },
                header: '<div class="label" style="font-size: 22px;font-weight:300;">' + this.$t('workBalance.payroll.executeMonthClosing') + '</div>',
                expanded: true,
                width: "700px",
                centered: true
            });
        },
        continueConfirmProcessMD() {
            let view = this;
            this.confirmEmployeeWorkBalances(this.confirmEmployeeWorkBalanceState.confirmableEmployees)
                .then(result => {
                    view.$store.commit("invalidateState", {states: ['employeeWorkbalanceMapState', 'planShiftMapState', 'employeePreferenceMapState']});
                    view.$helpers.success(view.$t('global.notifications.confirmSuccessful'), view.$t('workBalance.payroll.workBalanceConfirmed'))
                    view.sendNotificationToML("confirm");
                    view.refresh();
                }).catch(error => {
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.monthClosingConfirmError'));
            });

            //Why recalculate workbalances? Shouldn't be done because final values would be out of users hand
            //this.performMultiCreateAndConfirm(this.confirmEmployeeWorkBalanceState.confirmableEmployees);
        },
        startConfirmProcessMZ() {
            if (this.storeSettings.useAvgWorkTimeForPrefs && this.employeesWithoutAvgWorktime.length > 0) {
                this.OpenAvgWorktimeMissingModal();
            } else if (this.checkConfirmShouldProceed) {
                //this.showModal('modal-mzconfirm');
                this.OpenConfirmMZModal();
            }
        },
        OpenAvgWorktimeMissingModal() {
            let view = this;
            let description = "";

            description += "<p><b>" + this.$t('global.ui.warning') + "</b></p>"
            description += this.$t('workBalance.payroll.monthClosingEmployeeError')
            description += "<ul>";
            this.employeesWithoutAvgWorktime.sort((a, b) => (a.lastName + ' ' + a.firstName).localeCompare(b.lastName + ' ' + b.firstName)).forEach(e => {
                description += "<li><b>" + e.lastName + "</b> " + e.firstName + "</li>";
            })
            description += "</ul>";


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: [],
                    description: description,
                    positiveButtonLabel: this.$t('global.ui.approve'),

                    selectCallback: function (data) {

                    },

                },
                header: '<div class="label" style="font-size: 22px;font-weight:300;">' + this.$t('workBalance.payroll.executeMonthClosing') + '</div>',
                expanded: true,

                width: "700px",
                centered: true
            });
        },
        OpenConfirmMZModal() {
            let view = this;
            let description = "";
            if (view.confirmEmployeeWorkBalanceState.confirmTodoDates.length == 0) {
                description = "<p>" + this.$t('workBalance.payroll.checkConfirmPunchTimes') + "</p>";
                description += "<p>" + this.$t('workBalance.payroll.checkConfirmPunchTimesWarn') + "</p>";

            } else {
                description += "<p><b>" + this.$t('global.ui.warning') + "</b></p>"
                description += "<p>" + this.$t('workBalance.payroll.monthClosingEmployeesConfirmError') + "</p>"
                description += "<ul>";
                view.confirmEmployeeWorkBalanceState.confirmTodoDates.forEach(date => {
                    description += "<li>" + date.format("MMMM YYYY") + "</li>";
                })
                description += "</ul>";
            }


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: [],
                    description: description,
                    positiveButtonLabel: this.$t('global.ui.approve'),
                    negativeButtonLabel: this.$t('global.ui.cancel'),
                    selectCallback: function (data) {
                        view.continueConfirmProcessMZ();
                    },
                    deleteCallback: function () {
                    }
                },
                header: '<div class="label" style="font-size: 22px;font-weight:300;">' + this.$t('globabl.MZ') + '</div>',
                expanded: true,

                width: "700px",
                centered: true
            });
        },
        continueConfirmProcessMZ() {
            let view = this;
            this.loading = true;
            view.loadingText = this.$t('workBalance.payroll.closingMZ')
            this.confirmMZ().then(response => {
                view.loading = false;

                view.loadingText = view.$t('workBalance.payroll.loadingMonthlyData');
                view.refresh(true, false, true);

            }).catch(error => {
                view.loading = false;
                view.loadingText = this.$t('workBalance.payroll.loadingMonthlyData');
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.closingMzError'));
            })
        },
        OpenMZRecalculateModal() {
            let view = this;
            let description = "<p>" + this.$t('workBalance.payroll.recalcBeforeClosing') + "</p>"
            description += "<p>" + this.$t('workBalance.payroll.recalcClosingQuery') + "</p>"


            this.loading = true;
            view.loadingText = this.$t('workBalance.payroll.recalculating')
            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: [],
                    description: description,
                    positiveButtonLabel: this.$t('workBalance.payroll.recalculatingWithChanges'),
                    negativeButtonLabel: this.$t('workBalance.payroll.recalculatingWithoutChanges'),
                    selectCallback: function (data) {
                        view.loading = false;
                        view.loadingText = this.$t('workBalance.payroll.loadingMonthlyData');

                        view.calculateInvalidWorkBalances(false, true, 2, false);
                        view.mzConfirmed = true;
                        view.OpenMZIsConfirmedModal();
                    },
                    deleteCallback: function (data) {
                        view.loading = false;
                        view.loadingText = this.$t('workBalance.payroll.loadingMonthlyData');

                        view.calculateInvalidWorkBalances(false, true, 2, true);
                        view.mzConfirmed = true;
                        view.OpenMZIsConfirmedModal();
                    }
                },
                header: this.$tc('workBalance.payroll.recalculateWorkBalance', 1),
                expanded: true,
                width: "700px",
                centered: true,
                disableCloseIcon: true,
                locked: true
            });
        },
        OpenMZIsConfirmedModal() {
            let view = this;
            let description = "<p>" + this.$t('workBalance.payroll.closingMzSuccess') + "</p>";
            description += "<p>" + this.$t('workBalance.payroll.closingMzSuccessHelp') + "</p>"


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: [],
                    description: description,
                    selectCallback: function (data) {

                    }
                },
                header: '<div class="label" style="font-size: 22px;font-weight:300;">' + this.$t('workBalance.payroll.closedMZ') + '</div>',
                expanded: true,
                width: "700px",
                centered: true
            });
        },
        OpenUpdateVacationTimeBalancePopup() {
            let view = this;
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

            let balances = Object.values(this.workBalanceMap).filter(wb => visibleSpots.includes(view.employeeMap[wb.employeeId].spotId));
            let balancesMapped = balances.map(ewb => {
                return {
                    label: this.employeeMap[ewb.employeeId].lastName + " " + this.employeeMap[ewb.employeeId].firstName,
                    value: ewb, selected: false
                }
            }).sort((a, b) => a.label.localeCompare(b.label));


            let dataEntries = [];
            dataEntries.push({
                label: this.$t('global.ui.allEmployees'),
                key: 'selectAll',
                hidden: false,
                disabled: false,
                type: 'bool',
                value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let baldd = datafill.entries.find(i => i.key == 'balances');

                    if (entryBeforeUpdate.value == true) {

                        balancesMapped.forEach(bal => bal.selected = true);
                        baldd.dropdownSearchState = {
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: balancesMapped,
                            selectMultiple: true,
                            selectedItems: balancesMapped.filter(item => item.selected),
                            selectedItem: {},
                            onceSelected: function ($event, item, searchbar) {

                            },
                            styleLight: true,
                            placeholder: this.$t('global.ui.selectEmployee'),
                        }


                    }

                    return entryBeforeUpdate;
                }
            })
            dataEntries.push({
                label: this.$tc('global.general.employee'),
                key: 'balances',
                hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectAll'),
                type: 'dropdownsearch',
                value: null,
                selectMultiple: true,
                flexGroup: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: balancesMapped,
                    selectMultiple: true,
                    selectedItems: balancesMapped.filter(item => item.selected),
                    selectedItem: {},
                    onceSelected: function ($event, item, searchbar) {

                    },
                    styleLight: true,
                    placeholder: this.$t('global.ui.selectEmployee'),
                },
            });


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: '',
                    selectCallback: function (data) {
                        if (data.selectAll) {
                            data.balances = balancesMapped.map(e => e.value);
                        }
                        if (data.balances.length > 0) {
                            let nextMonthFrom = view.currentMonthFromTZ.clone().add(1, 'month');
                            let nextMonthTo = view.currentMonthToTZ.clone().add(1, 'month');
                            view.loadEmployeeContracts({ids: data.balances.map(b => b.employeeId)}, nextMonthFrom, nextMonthTo)
                                .then(response => {
                                    let futureContracts = {};
                                    response.data.forEach(c => {
                                        if (!futureContracts[c.employeeId]) {
                                            futureContracts[c.employeeId] = [];
                                        }
                                        futureContracts[c.employeeId].push(c);
                                    })

                                    data.balances.forEach(b => {
                                        view.updateVacationBalance(b, futureContracts);
                                    })
                                    view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('workBalance.payroll.vacationBalanceUpdated'))
                                }).catch(error => {
                                console.log(error);
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.vacationBalanceUpdateError'));
                            });
                        }


                    }
                },
                header: this.$t('workBalance.payroll.updateVacationBalance'),
                expanded: true,
                width: "700px",
                centered: true
            });
        },
        updateVacationBalance(balance, futureContracts) {
            let employeeId = balance.employeeId;
            let currentContract = this.getMainContractForEmployeeForCurrentMonth(employeeId);
            let nextContract = this.getMainContractForEmployeeForNextMonth(employeeId, futureContracts);
            if (currentContract != null && nextContract != null && currentContract.vacationTime != nextContract.vacationTime && currentContract.vacationTime > 0) {
                let ratio = nextContract.vacationTime / currentContract.vacationTime;
                balance.vacationTimeBalance = Math.round(balance.vacationTimeBalance * ratio);
                balance.valid = false;
                this.$set(this.workBalanceMap, balance.id, balance);

            }

        },

        openPaidCsvExportPopup() {
            let view = this;
            let dataEntries = [];
            let exportEntries = [];
            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledWorkTime'),
                value: {key: 'paidWorkTime', label: this.$t('workBalance.payroll.reconciledWorkTime')},
                id: 'paidWorkTime'
            });
            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledWorkTimeWithoutOvertime'),
                value: {
                    key: 'paidWorkTimeWithoutPaidOverTime',
                    label: this.$t('workBalance.payroll.reconciledWorkTimeWithoutOvertime')
                },
                id: 'paidWorkTimeWithoutPaidOverTime'
            });
            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledWorkTimeWithoutExtraHours'),
                value: {
                    key: 'paidWorkTimeWithoutPaidMoreTime',
                    label: this.$t('workBalance.payroll.reconciledWorkTimeWithoutExtraHours')
                },
                id: 'paidWorkTimeWithoutPaidMoreTime'
            });
            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledWorkTimeWithoutOtEh'),
                value: {
                    key: 'paidWorkTimeWithoutPaidMoreTimeAndOverTime',
                    label: this.$t('workBalance.payroll.reconciledWorkTimeWithoutOtEh')
                },
                id: 'paidWorkTimeWithoutPaidMoreTimeAndOverTime'
            });


            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledHolidays'),
                value: {key: 'paidHolidayTime', label: this.$t('workBalance.payroll.reconciledHolidays')},
                id: 'paidHolidayTime'
            });
            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledOvertime'),
                value: {key: 'paidOverTime', label: this.$t('workBalance.payroll.reconciledOvertime')},
                id: 'paidOverTime'
            });

            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledMoreTime'),
                value: {key: 'paidMoreTime', label: this.$t('workBalance.payroll.reconciledMoreTime')},
                id: 'paidMoreTime'
            });
            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledMoreTimeWithoutCompensation'),
                value: {
                    key: 'paidMoreTimeWithoutAutoEqual',
                    label: this.$t('workBalance.payroll.reconciledMoreTimeWithoutCompensation')
                },
                id: 'paidMoreTimeWithoutAutoEqual'
            });

            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledBonusHours'),
                value: {key: 'paidBonusTime', label: this.$t('workBalance.payroll.reconciledBonusHours')},
                id: 'paidBonusTime'
            });
            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledNightWork'),
                value: {key: 'paidNightWorkTime', label: this.$t('workBalance.payroll.reconciledNightWork')},
                id: 'paidNightWorkTime'
            });
            exportEntries.push({
                label: this.$t('workBalance.payroll.reconciledVacation'),
                value: {key: 'paidVacationTime', label: this.$t('workBalance.payroll.reconciledVacation')},
                id: 'paidVacationTime'
            });
            exportEntries.push({
                label: this.$t('workBalance.payroll.nightShiftCount'),
                value: {key: 'nightWorkCount', label: this.$t('workBalance.payroll.nightShiftCount')},
                id: 'nightWorkCount'
            });
            exportEntries.push({
                label: this.$t('workBalance.payroll.monthOvertime'),
                value: {key: 'overTime', label: this.$t('workBalance.payroll.monthOvertime')},
                id: 'overTime'
            });

            dataEntries.push({
                label: this.$t('global.ui.company'),
                key: "bmdCompany",
                hidden: false,
                type: 'text',
                value: ''
            });
            dataEntries.push({
                label: this.$t('global.ui.wageType'),
                key: "bmdWageType",
                hidden: false,
                type: 'text',
                value: ''
            });
            dataEntries.push({
                label: this.$t('global.ui.selectValue'),
                key: 'exportKey',
                hidden: false,
                type: 'dropdownsearch',
                value: null,
                selectMultiple: false,
                flexGroup: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: exportEntries,
                    selectMultiple: false,
                    selectedItems: [],
                    selectedItem: {},
                    onceSelected: function ($event, item, searchbar) {

                    },
                    styleLight: true,
                    placeholder: this.$t('global.ui.selectHours'),
                },
            });
            dataEntries.push({
                label: this.$t('workBalance.payroll.onlyGreaterZero'),
                key: "positiveOnly",
                hidden: false,
                type: 'bool',
                value: false
            });

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: '',
                    selectCallback: function (data) {
                        console.log(data);
                        let ek = data.exportKey;
                        view.exportCustomCSV({
                            'Firma': data.bmdCompany,
                            'Lohnart': data.bmdWageType
                        }, ek, data.positiveOnly);
                    }
                },
                header: this.$t('workBalance.payroll.exportCsvLv'),
                expanded: true,
                width: "700px",
                centered: true
            });
        },
        exportCustomCSV(customColumns, column, positiveOnly = false) {
            var date = new Date();
            let ts = (date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2(date.getDate()) + this.$helpers.pad2(date.getHours()) + this.$helpers.pad2(date.getMinutes()) + this.$helpers.pad2(date.getSeconds()));

            let view = this;
            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";
            let headers = ['Vorname', 'Nachname', 'Mitarbeiternummer'];
            Object.keys(customColumns).forEach((customKey) => {
                headers.push(customKey);
            });
            headers.push(column['label']);
            let prefix = this.isBeforeCurrentIRLMonth ? "" : "Entwurf "
            let filename = prefix + 'Monatsabschluss_Auszahlung_' + this.currentMonthFrom.format('YYYY-MM') + '_' + this.storeSettings.name + '_' + ts + '.csv';

            csv += headers.join(";");
            csv += "\n";

            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

            let balances = Object.values(this.workBalanceMap).filter(wb => visibleSpots.includes(view.employeeMap[wb.employeeId].spotId));
            balances.sort(function (a, b) {
                let ea = view.employeeMap[a.employeeId];
                let eb = view.employeeMap[b.employeeId];
                if (view.sortByName) {
                    if (ea != undefined && eb != undefined) {
                        if (ea.lastName < eb.lastName) return -1;
                        if (ea.lastName > eb.lastName) return 1;
                        if (ea.lastName == eb.lastName && ea.firstName < eb.firstName) return -1;
                        if (ea.lastName == eb.lastName && ea.firstName > eb.firstName) return 1;
                    }
                } else {
                    if (ea != undefined && eb != undefined) {
                        let eaNum = ea.personnelId;
                        let ebNum = eb.personnelId;
                        if (eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null) {
                            eaNum = parseInt(eaNum);
                            ebNum = parseInt(ebNum);
                            if (eaNum < ebNum) return -1;
                            if (eaNum > ebNum) return 1;
                        } else if (eaNum == null || eaNum == undefined) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                }
                return 0;
            });
            let hmap = this.dataTableState.headerMap;

            for (let i = 0; i < balances.length; i++) {
                let bal = balances[i];
                let preBal = this.previousMonthWorkBalanceMap[bal.employeeId];


                let mainContract = this.getMainContractForEmployee(bal.employeeId);
                let curEmpl = view.employeeMap[bal.employeeId];
                let cur = [
                    curEmpl.firstName,
                    curEmpl.lastName,
                    curEmpl.personnelId
                ];
                Object.keys(customColumns).forEach((customKey) => {
                    cur.push(customColumns[customKey]);
                });
                let key = column['key'];
                let val = '';
                if (key == "paidWorkTimeWithoutPaidOverTime") {
                    let paidOt = (bal.paidOverTime != null && bal.paidOverTime != undefined ? bal.paidOverTime : 0)
                    let paidWt = (bal.paidWorkTime != null && bal.paidWorkTime != undefined ? bal.paidWorkTime : 0)
                    val = (paidWt - (paidOt > 0 ? paidOt : 0)) / 60

                } else if (key == "paidWorkTimeWithoutPaidMoreTime") {
                    let paidMt = (bal.paidMoreTime != null && bal.paidMoreTime != undefined ? bal.paidMoreTime : 0)
                    let autoEqual = (bal.workTime + bal.unproductiveWorkTime) - bal.workTimeRegular

                    if (bal.prevMonthWorkBalance < 0) {
                        autoEqual += bal.prevMonthWorkBalance;
                    }
                    if (autoEqual < 0) {
                        let toEqual = bal.prevMonthMoreTime + bal.moreTime;
                        if (toEqual > 0) {
                            autoEqual = Math.min(autoEqual * -1, toEqual);
                        } else {
                            autoEqual = 0;
                        }
                    } else {
                        autoEqual = 0;
                    }
                    paidMt = (paidMt - (autoEqual > 0 ? autoEqual : 0))

                    let paidWt = (bal.paidWorkTime != null && bal.paidWorkTime != undefined ? bal.paidWorkTime : 0)
                    val = (paidWt - (paidMt > 0 ? paidMt : 0)) / 60
                } else if (key == "paidWorkTimeWithoutPaidMoreTimeAndOverTime") {

                    let paidMt = (bal.paidMoreTime != null && bal.paidMoreTime != undefined ? bal.paidMoreTime : 0)
                    let autoEqual = (bal.workTime + bal.unproductiveWorkTime) - bal.workTimeRegular

                    if (bal.prevMonthWorkBalance < 0) {
                        autoEqual += bal.prevMonthWorkBalance;
                    }
                    if (autoEqual < 0) {
                        let toEqual = bal.prevMonthMoreTime + bal.moreTime;
                        if (toEqual > 0) {
                            autoEqual = Math.min(autoEqual * -1, toEqual);
                        } else {
                            autoEqual = 0;
                        }
                    } else {
                        autoEqual = 0;
                    }
                    paidMt = (paidMt - (autoEqual > 0 ? autoEqual : 0))

                    let paidOt = (bal.paidOverTime != null && bal.paidOverTime != undefined ? bal.paidOverTime : 0)
                    let paidWt = (bal.paidWorkTime != null && bal.paidWorkTime != undefined ? bal.paidWorkTime : 0)
                    val = (paidWt - (paidMt > 0 ? paidMt : 0) - (paidOt > 0 ? paidOt : 0)) / 60
                } else if (key == "paidMoreTimeWithoutAutoEqual") {
                    let paidMt = (bal.paidMoreTime != null && bal.paidMoreTime != undefined ? bal.paidMoreTime : 0)
                    let autoEqual = (bal.workTime + bal.unproductiveWorkTime) - bal.workTimeRegular

                    if (bal.prevMonthWorkBalance < 0) {
                        autoEqual += bal.prevMonthWorkBalance;
                    }
                    if (autoEqual < 0) {
                        let toEqual = bal.prevMonthMoreTime + bal.moreTime;
                        if (toEqual > 0) {
                            autoEqual = Math.min(autoEqual * -1, toEqual);
                        } else {
                            autoEqual = 0;
                        }
                    } else {
                        autoEqual = 0;
                    }

                    val = (paidMt - (autoEqual > 0 ? autoEqual : 0)) / 60
                } else {
                    val = (bal[key] != null && bal[key] != undefined ? bal[key] : '');
                    if (key == 'paidVacationTime') {
                        val = val / 60 / 24;
                    } else if (key != 'nightWorkCount') {
                        val = val / 60;
                    }
                }
                if (positiveOnly && val > 0 || !positiveOnly) {
                    cur.push(val.toFixed(2));
                    let line = cur.join(";");
                    csv += line;
                    csv += "\n";
                }


            }

            let s = csv.split(".");
            csv = s.join(",");
            let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
        },
        confirmEmployeeWorkBalances: function (employeeIds) {

            if (employeeIds.length == 0) {
                return new Promise((resolve, reject) => {
                    resolve(true);
                });
            } else {
                let view = this;
                let url = '/api/sec/employeeworkbalance/confirm';

                let params = {
                    storeId: this.$store.state.storeId
                };

                let payload = {
                    ids: employeeIds,
                    year: this.currentMonthUTC.year(),
                    month: this.currentMonthUTC.month() + 1,
                }

                return this.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload,
                }).then(response => {
                    return new Promise((resolve, reject) => {
                        resolve(true);
                    });
                }).catch(function (error) {
                    return new Promise((resolve, reject) => {

                        reject(error);
                    });
                });
            }
        },
        confirmMZ: function () {
            let view = this;
            let url = '/api/sec/actualshift/finalize';

            let params = {
                storeId: this.$store.state.storeId,
                from: this.currentMonthUTC.clone().startOf('month').format(),
                to: this.currentMonthUTC.clone().endOf('month').format(),
            };

            return this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
            }).then(response => {
                return new Promise((resolve, reject) => {
                    resolve(true);
                });
            }).catch(function (error) {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            })
        },
        switchToInvalidDate(date) {
            this.selectedInvalidBalances = [];
            this.setDateSelection(date, true);
        },
        openExportSelection(save = true, csv = false) {
            let view = this;
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

            let balances = Object.values(this.workBalanceMap).filter(wb => visibleSpots.includes(view.employeeMap[wb.employeeId].spotId));
            let balancesMapped = balances.map(ewb => {
                return {
                    label: this.employeeMap[ewb.employeeId].lastName + " " + this.employeeMap[ewb.employeeId].firstName,
                    value: ewb, selected: false
                }
            }).sort((a, b) => a.label.localeCompare(b.label));
            let settings = Object.values(this.exportSettingsMap)
                .filter(s => s.type == 1)
                .map(s => {
                    return {label: s.name, value: s}
                })
                .sort((a, b) => a.label.localeCompare(b.label));

            let newSetting = {label: this.$t('workBalance.payroll.addNewConfig'), value: null}

            settings.push(newSetting);


            let dataEntries = [];
            dataEntries.push({
                label: this.$t('global.ui.allEmployees'),
                key: 'selectAll',
                hidden: false,
                disabled: false,
                type: 'bool',
                value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let baldd = datafill.entries.find(i => i.key == 'balances');

                    if (entryBeforeUpdate.value == true) {

                        balancesMapped.forEach(bal => bal.selected = true);
                        baldd.dropdownSearchState = {
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: balancesMapped,
                            selectMultiple: true,
                            selectedItems: balancesMapped.filter(item => item.selected),
                            selectedItem: {},
                            onceSelected: function ($event, item, searchbar) {

                            },
                            styleLight: true,
                            placeholder: this.$t('global.ui.selectEmployee'),
                        }


                    }

                    return entryBeforeUpdate;
                }
            })
            dataEntries.push({
                label: this.$tc('global.general.employee'),
                key: 'balances',
                hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectAll'),
                type: 'dropdownsearch',
                value: null,
                selectMultiple: true,
                flexGroup: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: balancesMapped,
                    selectMultiple: true,
                    selectedItems: balancesMapped.filter(item => item.selected),
                    selectedItem: {},
                    onceSelected: function ($event, item, searchbar) {

                    },
                    styleLight: true,
                    placeholder: this.$t('global.ui.selectEmployee'),
                },
            });


            dataEntries.push({
                label: this.$t('workBalance.payroll.ignoreWorkless'),
                key: 'ignoreNullRows',
                hidden: false,
                disabled: false,
                type: 'bool',
                value: false
            })

            dataEntries.push({
                label: this.$t('global.ui.exportConfig'),
                key: 'setting',
                hidden: false,
                type: 'dropdownsearch',
                selectMultiple: false,
                flexGroup: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: settings,
                    selectMultiple: false,
                    selectFirst: false,
                    styleLight: true,
                    placeholder: this.$t('store.settings.selectSettings'),
                },
            });
            dataEntries.push({
                label: this.$t('global.ui.editConfig'),
                key: 'editSetting',
                hidden: true,
                disabled: false,
                type: 'bool',
                value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let setting = datafill.entries.find(i => i.key == 'setting').value;

                    if (setting == null) {
                        entryBeforeUpdate.value = false;
                        entryBeforeUpdate.hidden = true;
                    } else {
                        entryBeforeUpdate.hidden = false;
                    }
                    return entryBeforeUpdate;
                }
            })

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: '',
                    selectCallback: function (data) {
                        if (data.selectAll) {
                            data.balances = balancesMapped.map(e => e.value);
                        }
                        if (data.ignoreNullRows) {
                            data.balances = data.balances.filter(b => b.workTime + b.unproductiveWorkTime > 0);
                        }
                        if (data.setting == null) {
                            let newSetting = {
                                id: null, name: null, type: 1,
                                setting: {
                                    workTimeRegular: true,
                                    prevMonthTime: true,
                                    workTime: true,
                                    unproductiveWorkTime: true,
                                    workTimeBalance: true,
                                    vacationTime: true,
                                    vacationTimeBalance: true,
                                    holidayTime: true,
                                    holidayAdjustmentWorkTime: true,
                                    holidayTimeBalance: true,
                                }
                            }

                            view.openExportSetting(newSetting, data.balances, save, csv);
                        } else if (data.editSetting) {
                            view.openExportSetting(data.setting, data.balances, save, csv);
                        } else {
                            let transformedExportSetting = Object.assign({}, data.setting.setting);
                            transformedExportSetting.balances = data.balances;
                            transformedExportSetting.name = data.setting.name;

                            view.generateReportProxy(transformedExportSetting, save, csv);
                        }

                    }
                },
                header: csv ? this.$t('global.ui.csvExport') : this.$t('global.ui.pdfExport'),
                expanded: true,
                width: "700px",
                centered: true
            });
        },
        openExportSetting(exportSetting, balances, save = true, csv = false) {
            let view = this;


            let settings = exportSetting.setting;

            let dataEntries = [];

            let exportOptions = [
                {label: "Id", key: 'id', hidden: true, disabled: false, type: 'text', value: exportSetting.id},
                {
                    label: this.$t('pages.employeeData.name'),
                    key: 'name',
                    hidden: false,
                    disabled: false,
                    type: 'text',
                    value: exportSetting.name
                },
                {
                    label: this.$t('pages.employeeCoreData.mainPosition'),
                    key: 'mainSpot',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.mainSpot ? settings.mainSpot : false
                },

                {
                    label: this.$t('pages.employeeCoreData.personnelNumber'),
                    key: 'personnelId',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.personnelId ? settings.personnelId : false
                },
                {
                    label: this.$t('global.ui.sortByPersonalNumber'),
                    key: 'sortByPersonnelId',
                    hidden: this.$helpers.CheckDatafillKeysForHidden('personnelId'),
                    disabled: false,
                    type: 'bool',
                    value: settings.sortByPersonnelId ? settings.sortByPersonnelId : false
                },

                {
                    label: this.$t('pages.employeeContract.employmentModel'),
                    key: 'employmentModel',
                    hidden: Object.values(this.employmentModelMap).length == 0,
                    disabled: false,
                    type: 'bool',
                    value: settings.employmentModel ? settings.employmentModel : false
                },
                {
                    label: this.$tc('pages.employeeContract.contractType'),
                    key: 'contractType',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.contractType ? settings.contractType : false
                },
                {
                    label: this.$t('store.settings.workTimeModel'),
                    key: 'weekTimeModel',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.weekTimeModel ? settings.weekTimeModel : false
                },
                {
                    label: this.$t('workBalance.payroll.workTimeTarget'),
                    key: 'workTimeRegular',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.workTimeRegular ? settings.workTimeRegular : false
                },
                {
                    label: this.$t('workBalance.payroll.carryOver'),
                    key: 'prevMonthTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.prevMonthTime ? settings.prevMonthTime : false
                },
                {
                    label: this.$t('workBalance.payroll.productiveWorkTime'),
                    key: 'workTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.workTime ? settings.workTime : false
                },
                {
                    label: this.$t('workBalance.payroll.unproductiveWorkTime'),
                    key: 'unproductiveWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.unproductiveWorkTime ? settings.unproductiveWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.totalWorkTime'),
                    key: 'totalWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.totalWorkTime ? settings.totalWorkTime : false
                },


                {
                    label: this.$t('workBalance.payroll.unproductiveQuota'),
                    key: 'unproductiveWorkPercentage',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.unproductiveWorkPercentagee ? settings.unproductiveWorkPercentage : false
                },

                {
                    label: this.$t('workBalance.payroll.workTimeSickDays'),
                    key: 'sickWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.sickWorkTime ? settings.sickWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.sickDaysQuota'),
                    key: 'sickWorkPercentage',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.sickWorkPercentage ? settings.sickWorkPercentage : false
                },

                {
                    label: this.$t('workBalance.payroll.workTimeSickPay'),
                    key: 'wageContinuationWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.wageContinuationWorkTime ? settings.wageContinuationWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.sickPayQuota'),
                    key: 'wageContinuationWorkPercentage',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.wageContinuationWorkPercentage ? settings.wageContinuationWorkPercentage : false
                },

                {
                    label: this.$t('workBalance.payroll.workTimeTrainee'),
                    key: 'educationWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.educationWorkTime ? settings.educationWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.traineeQuota'),
                    key: 'educationWorkPercentage',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.educationWorkPercentage ? settings.educationWorkPercentage : false
                },

                {
                    label: this.$t('workBalance.payroll.workTimeNursingLeave'),
                    key: 'nursingVacationWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.nursingVacationWorkTime ? settings.nursingVacationWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.nursingLeaveQuota'),
                    key: 'nursingVacationWorkPercentage',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.nursingVacationWorkPercentage ? settings.nursingVacationWorkPercentage : false
                },

                {
                    label: this.$t('workBalance.payroll.workTimeVacation'),
                    key: 'vacationWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.vacationWorkTime ? settings.vacationWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.vacationQuota'),
                    key: 'vacationWorkPercentage',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.vacationWorkPercentage ? settings.vacationWorkPercentage : false
                },

                {
                    label: this.$t('workBalance.payroll.workTimeOther'),
                    key: 'miscWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.miscWorkTime ? settings.miscWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.otherQuota'),
                    key: 'miscWorkPercentage',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.miscWorkPercentage ? settings.miscWorkPercentage : false
                },

                {
                    label: this.$t('workBalance.payroll.workTimeModified'),
                    key: 'paidWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.paidWorkTime ? settings.paidWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.workTimeBalance'),
                    key: 'workTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.workTimeBalance ? settings.workTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.workTimeBalanceWithoutPrevious'),
                    key: 'currentMonthWorkTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.currentMonthWorkTimeBalance ? settings.currentMonthWorkTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.unmodifiedWorkTimeBalance'),
                    key: 'unmodifiedWorkTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.unmodifiedWorkTimeBalance ? settings.unmodifiedWorkTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.workTimeBalanceLastAccountingPeriod'),
                    key: 'workTimeBalanceAccPeriod',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.workTimeBalanceAccPeriod ? settings.workTimeBalanceAccPeriod : false
                },

                {
                    label: this.$t('workBalance.payroll.usedVacation'),
                    key: 'vacationTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.vacationTime ? settings.vacationTime : false
                },
                {
                    label: this.$t('workBalance.payroll.usedVacationHours'),
                    key: 'vacationTimeHours',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.vacationTimeHours ? settings.vacationTimeHours : false
                },

                {
                    label: this.$t('workBalance.payroll.vacationModified'),
                    key: 'paidVacationTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.paidVacationTime ? settings.paidVacationTime : false
                },
                {
                    label: this.$t('workBalance.payroll.leaveBalance'),
                    key: 'vacationTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.vacationTimeBalance ? settings.vacationTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.unmodifiedVacationBalance'),
                    key: 'unmodifiedVacationTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.unmodifiedVacationTimeBalance ? settings.unmodifiedVacationTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.vacationBalanceLastAccountingPeriod'),
                    key: 'vacationTimeBalanceAccPeriod',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.vacationTimeBalanceAccPeriod ? settings.vacationTimeBalanceAccPeriod : false
                },

                {
                    label: this.$t('workBalance.payroll.holidayTime'),
                    key: 'holidayTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.holidayTime ? settings.holidayTime : false
                },
                {
                    label: this.$t('workBalance.payroll.paidHolidayTime'),
                    key: 'paidHolidayTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.paidHolidayTime ? settings.paidHolidayTime : false
                },

                {
                    label: this.$t('workBalance.payroll.holidayCompensation'),
                    key: 'holidayAdjustmentWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.holidayAdjustmentWorkTime ? settings.holidayAdjustmentWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.holidayTimeBalance'),
                    key: 'holidayTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.holidayTimeBalance ? settings.holidayTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.unmodifiedHolidayTimeBalance'),
                    key: 'unmodifiedHolidayTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.unmodifiedHolidayTimeBalance ? settings.unmodifiedHolidayTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.holidayTimeBalanceAccPeriod'),
                    key: 'holidayTimeBalanceAccPeriod',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.holidayTimeBalanceAccPeriod ? settings.holidayTimeBalanceAccPeriod : false
                },

                {
                    label: this.$t('workBalance.payroll.nightWorkTime'),
                    key: 'nightWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.nightWorkTime ? settings.nightWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.nightWorkCount'),
                    key: 'nightWorkCount',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.nightWorkCount ? settings.nightWorkCount : false
                },

                {
                    label: this.$t('workBalance.payroll.nightWorkPreviousMonth'),
                    key: 'prevMonthNightWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.prevMonthNightWorkTime ? settings.prevMonthNightWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.nightWorkModified'),
                    key: 'paidNightWorkTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.paidNightWorkTime ? settings.paidNightWorkTime : false
                },
                {
                    label: this.$t('workBalance.payroll.nightWorkBalance'),
                    key: 'nightWorkTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.nightWorkTimeBalance ? settings.nightWorkTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.unmodifiedNightWorkBalance'),
                    key: 'unmodifiedNightWorkTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.unmodifiedNightWorkTimeBalance ? settings.unmodifiedNightWorkTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.nightWorkTimeBalanceAccPeriod'),
                    key: 'nightWorkTimeBalanceAccPeriod',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.nightWorkTimeBalanceAccPeriod ? settings.nightWorkTimeBalanceAccPeriod : false
                },

                {
                    label: this.$t('workBalance.payroll.overNormalWorkTime'),
                    key: 'overTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.overTime ? settings.overTime : false
                },
                {
                    label: this.$t('workBalance.payroll.overTimePreviousMonth'),
                    key: 'prevMonthOverTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.prevMonthOverTime ? settings.prevMonthOverTime : false
                },
                {
                    label: this.$t('workBalance.payroll.overTimeModified'),
                    key: 'paidOverTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.paidOverTime ? settings.paidOverTime : false
                },
                {
                    label: this.$t('workBalance.payroll.overTimeBalance'),
                    key: 'overTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.overTimeBalance ? settings.overTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.unmodifiedOverTimeBalance'),
                    key: 'unmodifiedOverTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.unmodifiedOverTimeBalance ? settings.unmodifiedOverTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.overTimeBalanceAccPeriod'),
                    key: 'overTimeBalanceAccPeriod',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.overTimeBalanceAccPeriod ? settings.overTimeBalanceAccPeriod : false
                },


            ];
            if (this.storeSettings.country == 1) {
                exportOptions = exportOptions.concat([
                    {
                        label: this.$t('workBalance.payroll.moreTime'),
                        key: 'moreTime',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.moreTime ? settings.moreTime : false
                    },
                    {
                        label: this.$t('workBalance.payroll.moreTimePreviousMonth'),
                        key: 'prevMonthMoreTime',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.prevMonthMoreTime ? settings.prevMonthMoreTime : false
                    },
                    {
                        label: this.$t('workBalance.payroll.moreTimeModified'),
                        key: 'paidMoreTime',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.paidMoreTime ? settings.paidMoreTime : false
                    },
                    {
                        label: this.$t('workBalance.payroll.moreTimeBalance'),
                        key: 'moreTimeBalance',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.moreTimeBalance ? settings.moreTimeBalance : false
                    },
                    {
                        label: this.$t('workBalance.payroll.unmodifiedMoreTimeBalance'),
                        key: 'unmodifiedMoreTimeBalance',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.unmodifiedMoreTimeBalance ? settings.unmodifiedMoreTimeBalance : false
                    },
                    {
                        label: this.$t('workBalance.payroll.moreTimeBalanceAccPeriod'),
                        key: 'moreTimeBalanceAccPeriod',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.moreTimeBalanceAccPeriod ? settings.moreTimeBalanceAccPeriod : false
                    },
                ])
            }
            exportOptions = exportOptions.concat([
                {
                    label: "Arbeitszeit über Grenze",
                    key: 'workTimeAboveThreshold',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.workTimeAboveThreshold ? settings.workTimeAboveThreshold : false
                },
                {
                    label: 'Grenze',
                    key: 'workTimeThreshold',
                    hidden: this.$helpers.CheckDatafillKeysForHidden('workTimeAboveThreshold'),
                    type: 'slider',
                    value: settings.workTimeThreshold != null ? settings.workTimeThreshold : 169 * 60,
                    slider: {
                        min: 0 * 60,
                        max: 200 * 60,
                        hideMin: true,
                        hideMax: true,
                        value: settings.workTimeThreshold != null ? settings.workTimeThreshold : 169 * 60,
                        step: 15,
                        DisplayLabel: (val) => {
                            return (val / 60).toFixed(2);
                        }
                    },
                    /*computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let workTimeAboveThreshold = datafill.entries.find(i => i.key == 'workTimeAboveThreshold').value;


                        if(!workTimeAboveThreshold){

                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = 169*60;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }

                        return entryBeforeUpdate;
                    } */
                },
                {
                    label: this.$t('workBalance.payroll.bonusHours'),
                    key: 'bonusTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.bonusTime ? settings.bonusTime : false
                },
                {
                    label: this.$t('workBalance.payroll.bonusHoursPreviousMonth'),
                    key: 'prevMonthBonusTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.prevMonthBonusTime ? settings.prevMonthBonusTime : false
                },
                {
                    label: this.$t('workBalance.payroll.bonusHoursModified'),
                    key: 'paidBonusTime',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.paidBonusTime ? settings.paidBonusTime : false
                },
                {
                    label: this.$t('workBalance.payroll.bonusHoursBalance'),
                    key: 'bonusTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.bonusTimeBalance ? settings.bonusTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.unmodifiedBonusHoursBalance'),
                    key: 'unmodifiedBonusTimeBalance',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.unmodifiedBonusTimeBalance ? settings.unmodifiedBonusTimeBalance : false
                },
                {
                    label: this.$t('workBalance.payroll.bonusTimeBalanceAccPeriod'),
                    key: 'bonusTimeBalanceAccPeriod',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.bonusTimeBalanceAccPeriod ? settings.bonusTimeBalanceAccPeriod : false
                },

                {
                    label: this.$t('global.general.comment'),
                    key: 'comment',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.comment ? settings.comment : false
                },
            ])
            if (this.storeSettings.country == 1) {
                exportOptions = exportOptions.concat([
                    {
                        label: this.$t('workBalance.payroll.fiftyPercentPayout'),
                        key: 'fiftypercentpayout',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.fiftypercentpayout ? settings.fiftypercentpayout : false
                    },
                    {
                        label: this.$t('workBalance.payroll.paidFiftyPercentPayout'),
                        key: 'paidfiftypercentpayout',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.paidfiftypercentpayout ? settings.paidfiftypercentpayout : false
                    },

                    {
                        label: this.$t('workBalance.payroll.fiftyPercentPayoutWithoutAccPeriod'),
                        key: 'fiftypercentpayoutWithoutAccPeriod',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.fiftypercentpayoutWithoutAccPeriod ? settings.fiftypercentpayoutWithoutAccPeriod : false
                    },
                    {
                        label: this.$t('workBalance.payroll.twentyFivePercentPayout'),
                        key: 'twentyfivepercentpayout',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.twentyfivepercentpayout ? settings.twentyfivepercentpayout : false
                    },
                    {
                        label: this.$t('workBalance.payroll.paidTwentyFivePercentPayout'),
                        key: 'paidtwentyfivepercentpayout',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.paidtwentyfivepercentpayout ? settings.paidtwentyfivepercentpayout : false
                    },

                    {
                        label: this.$t('workBalance.payroll.twentyFivePercentPayoutWithoutAccPeriod'),
                        key: 'twentyfivepercentpayoutWithoutAccPeriod',
                        hidden: false,
                        disabled: false,
                        type: 'bool',
                        value: settings.twentyfivepercentpayoutWithoutAccPeriod ? settings.twentyfivepercentpayoutWithoutAccPeriod : false
                    },
                ])
            }
            exportOptions = exportOptions.concat([
                {
                    label: this.$t('workBalance.payroll.workDaysTarget'),
                    key: 'workDaysPlanned',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.workDaysPlanned ? settings.workDaysPlanned : false
                },
                {
                    label: this.$t('workBalance.payroll.workDaysActual'),
                    key: 'workDaysActual',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.workDaysActual ? settings.workDaysActual : false
                },
                {
                    label: this.$t('workBalance.payroll.sickDays'),
                    key: 'sickDays',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.sickDays ? settings.sickDays : false
                },
                {
                    label: this.$t('workBalance.payroll.fullSickDays'),
                    key: 'fullSickDays',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.fullSickDays ? settings.fullSickDays : false
                },

                {
                    label: this.$t('workBalance.payroll.holidayAdjustment'),
                    key: 'holidayAdjustmentDays',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.holidayAdjustmentDays ? settings.holidayAdjustmentDays : false
                },
                {
                    label: this.$t('workBalance.payroll.wageContinuationDays'),
                    key: 'wageContinuationDays',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.wageContinuationDays ? settings.wageContinuationDays : false
                },
                {
                    label: this.$t('workBalance.payroll.traineeDays'),
                    key: 'educationDays',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.educationDays ? settings.educationDays : false
                },
                {
                    label: this.$t('workBalance.payroll.nursingLeaveDays'),
                    key: 'nursingVacationDays',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.nursingVacationDays ? settings.nursingVacationDays : false
                },
                {
                    label: this.$t('workBalance.payroll.otherDays'),
                    key: 'miscDays',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.miscDays ? settings.miscDays : false
                },

                {
                    label: this.$t('workBalance.payroll.weekendWorkTarget'),
                    key: 'weekendWorkPlanned',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.weekendWorkPlanned ? settings.weekendWorkPlanned : false
                },
                {
                    label: this.$t('workBalance.payroll.weekendWorkActual'),
                    key: 'weekendWorkActual',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.weekendWorkActual ? settings.weekendWorkActual : false
                },
                {
                    label: this.$t('workBalance.payroll.weekendWorkCountTarget'),
                    key: 'weekendWorkCountPlanned',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.weekendWorkCountPlanned ? settings.weekendWorkCountPlanned : false
                },
                {
                    label: this.$t('workBalance.payroll.weekendWorkCountActual'),
                    key: 'weekendWorkCountActual',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.weekendWorkCountActual ? settings.weekendWorkCountActual : false
                },

                {
                    label: this.$t('workBalance.payroll.offWorkDaysTarget'),
                    key: 'offWorkDaysPlanned',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.offWorkDaysPlanned ? settings.offWorkDaysPlanned : false
                },
                {
                    label: this.$t('workBalance.payroll.offWorkDaysActual'),
                    key: 'offWorkDaysActual',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.offWorkDaysActual ? settings.offWorkDaysActual : false
                },
                {
                    label: this.$t('workBalance.payroll.offWorkWeekendDaysTarget'),
                    key: 'offWorkWeekendDaysPlanned',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.offWorkWeekendDaysPlanned ? settings.offWorkWeekendDaysPlanned : false
                },
                {
                    label: this.$t('workBalance.payroll.offWorkWeekendDaysActual'),
                    key: 'offWorkWeekendDaysActual',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.offWorkWeekendDaysActual ? settings.offWorkWeekendDaysActual : false
                },

                {
                    label: this.$t('workBalance.payroll.offWorkWeekendsPlanned'),
                    key: 'offWorkWeekendsPlanned',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.offWorkWeekendsPlanned ? settings.offWorkWeekendsPlanned : false
                },
                {
                    label: this.$t('workBalance.payroll.offWorkWeekendsActual'),
                    key: 'offWorkWeekendsActual',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.offWorkWeekendsActual ? settings.offWorkWeekendsActual : false
                },

                {
                    label: this.$t('workBalance.payroll.offSunDaysPerYearPlanned'),
                    key: 'offSunDaysPerYearPlanned',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.offSunDaysPerYearPlanned ? settings.offSunDaysPerYearPlanned : false
                },
                {
                    label: this.$t('workBalance.payroll.offSunDaysPerYearActual'),
                    key: 'offSunDaysPerYearActual',
                    hidden: false,
                    disabled: false,
                    type: 'bool',
                    value: settings.offSunDaysPerYearActual ? settings.offSunDaysPerYearActual : false
                },

            ])
            dataEntries = dataEntries.concat(exportOptions);

            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    errorCheck: [
                        (entries) => {
                            if (entries['name'] == null || entries['name'].length == 0) {
                                return {
                                    key: 'name',
                                    type: 'error',
                                    label: this.$t('pages.employeeData.name'),
                                    text: 'Bitte geben Sie einen Namen für die Export Einstellung an!'
                                }
                            } else {
                                return null
                            }
                        }
                    ],
                    description: '',
                    selectCallback: function (data) {
                        let transformedData = Object.assign({}, data);
                        delete transformedData.id;
                        delete transformedData.name;

                        let exportSetting = {id: data.id, name: data.name, setting: transformedData}
                        if (exportSetting.id == null) {
                            view.$helpers.CreateExportSetting(exportSetting, 1);
                        } else {
                            view.$helpers.UpdateExportSetting(exportSetting);
                        }

                        let exportData = Object.assign({}, transformedData);
                        exportData.balances = balances;
                        exportData.name = data.name;


                        view.generateReportProxy(exportData, save, csv);


                    }, deleteCallback: exportSetting.id != null ? function (data) {
                        if (exportSetting.id != null) {
                            view.$helpers.DeleteExportSetting(exportSetting);
                        }
                    } : null,
                    negativeButtonLabel: this.$t('workBalance.payroll.deleteConfig')
                },
                header: this.$t('global.ui.exportSelection'),
                expanded: true,
                width: "700px",
                centered: true
            });
        },

        openExtraExportSelection(type = 1, save = true) {
            let view = this;
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

            let balances = Object.values(this.workBalanceMap).filter(wb => visibleSpots.includes(view.employeeMap[wb.employeeId].spotId));
            let balancesMapped = balances.map(ewb => {
                return {
                    label: this.employeeMap[ewb.employeeId].lastName + " " + this.employeeMap[ewb.employeeId].firstName,
                    value: ewb, selected: false
                }
            }).sort((a, b) => a.label.localeCompare(b.label));
            let dataEntries = [];
            dataEntries.push({
                label: this.$t('global.ui.selectEmployee'),
                key: 'balances',
                hidden: false,
                type: 'dropdownsearch',
                value: null,
                selectMultiple: true,
                flexGroup: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: balancesMapped,
                    selectMultiple: true,
                    selectedItems: balancesMapped.filter(item => item.selected),
                    selectedItem: {},
                    onceSelected: function ($event, item, searchbar) {

                    },
                    styleLight: true,
                    placeholder: this.$t('global.ui.selectEmployee'),
                },
            });
            dataEntries.push({
                label: this.$t('global.ui.selectAll'),
                key: 'selectAll',
                hidden: false,
                disabled: false,
                type: 'bool',
                value: false,
                computed: (datafill, lastVal, entryBeforeUpdate) => {
                    let baldd = datafill.entries.find(i => i.key == 'balances');

                    if (entryBeforeUpdate.value == true) {

                        balancesMapped.forEach(bal => bal.selected = true);
                        baldd.dropdownSearchState = {
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: balancesMapped,
                            selectMultiple: true,
                            selectedItems: balancesMapped.filter(item => item.selected),
                            selectedItem: {},
                            onceSelected: function ($event, item, searchbar) {

                            },
                            styleLight: true,
                            placeholder: this.$t('global.ui.selectEmployee'),
                        }


                    }

                    return entryBeforeUpdate;
                }
            })
            if (type == 3 || type == 4 || type == 5) {
                let modeItems = [
                    {label: this.$t('workBalance.payroll.allShifts'), value: 1},
                    {label: this.$t('workBalance.payroll.actualShiftsOnly'), value: 2, selected: true},
                    {label: this.$t('workBalance.payroll.targetShiftsOnly'), value: 3},
                ]
                dataEntries.push({
                    label: this.$t('store.settings.shifts'),
                    key: 'mode',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: 2,
                    selectMultiple: false,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: modeItems,
                        selectMultiple: false,
                        selectedItems: modeItems.filter(item => item.selected),
                        selectedItem: modeItems[1],
                        onceSelected: function ($event, item, searchbar) {

                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.shifts'),
                    },
                });
            }
            if (type == 4 || type == 5) {
                let settingsMapped = Object.values(this.bonusPaymentSettingsMap).map(s => {
                    return {
                        label: s.name,
                        value: s, selected: true
                    }
                }).sort((a, b) => a.label.localeCompare(b.label));
                dataEntries.push({
                    label: this.$t('global.ui.selectBonusConfig'),
                    key: 'settings',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: null,
                    selectMultiple: true,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: settingsMapped,
                        selectMultiple: true,
                        selectedItems: settingsMapped.filter(item => item.selected),
                        selectedItem: {},
                        onceSelected: function ($event, item, searchbar) {

                        },
                        styleLight: true,
                        placeholder: this.$t('global.ui.selectBonusConfig'),
                    },
                });
            }
            if (type == 5) {
                dataEntries.push({
                    label: this.$t('workBalance.payroll.includeWorkTime'),
                    key: 'includeWorkTime',
                    hidden: false,
                    type: 'bool',
                    value: false
                });
            }
            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: '',
                    selectCallback: function (data) {
                        if (type == 1) {
                            view.exportCsv(data.balances)
                        } else if (type == 3) {
                            view.generateNightWorkTimeReport(data.balances, save, data.mode);
                        } else if (type == 4) {
                            let map = {};
                            data.settings.forEach(s => {
                                map[s.id] = s;
                            })
                            view.generateBonusPaymentSettingReport(data.balances, save, map, data.mode);
                        } else if (type == 5) {
                            let map = {};
                            data.settings.forEach(s => {
                                map[s.id] = s;
                            })
                            view.generateBonusPaymentSettingReportCSV(data.balances, data.includeWorkTime, map, data.mode);
                        }
                    }
                },
                header: this.$t('global.ui.exportSelection'),
                expanded: true,
                width: "700px",
                centered: true
            });
        },
        openSPSReisertExportSelection() {
            let view = this;


            let balances = Object.values(this.workBalanceMap);
            let balancesMapped = balances.map(ewb => {
                return {
                    label: this.employeeMap[ewb.employeeId].lastName + " " + this.employeeMap[ewb.employeeId].firstName,
                    value: ewb, selected: false
                }
            }).sort((a, b) => a.label.localeCompare(b.label));
            let dataEntries = [];
            dataEntries.push({
                label: this.$t('global.ui.allEmployees'),
                key: 'selectAll',
                hidden: false,
                disabled: false,
                type: 'bool',
                value: true
            });
            dataEntries.push({
                label: this.$t('global.ui.selectEmployee'),
                key: 'balances',
                hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('selectAll'),
                type: 'dropdownsearch',
                value: null,
                selectMultiple: true,
                flexGroup: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: balancesMapped,
                    selectMultiple: true,
                    selectedItems: balancesMapped.filter(item => item.selected),
                    selectedItem: {},
                    onceSelected: function ($event, item, searchbar) {

                    },
                    styleLight: true,
                    placeholder: this.$t('global.ui.selectEmployee'),
                },
            });


            let employeeLevelItems = [{
                label: this.$t('workBalance.payroll.crew'),
                value: 1,
                selected: true
            }, {label: 'Management', value: 2, selected: false}];
            dataEntries.push({
                label: this.$tc('store.structure.employeeLevel'), key: 'employeeLevels', type: 'dropdownsearch',
                hidden: view.$helpers.CheckDatafillKeysForHidden('selectAll'),
                dropdownSearchState: {
                    selectMultiple: true, styleLight: true,
                    placeholder: '',
                    items: employeeLevelItems,
                    selectedItem: employeeLevelItems.find(i => i.selected),
                    selectedItems: employeeLevelItems.filter(i => i.selected),
                    selectFirst: true,
                }
            });


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: '',
                    selectCallback: function (data) {
                        let balances = [];
                        let containsUnconfirmed = false;
                        if (data.selectAll) {

                            Object.values(view.workBalanceMap).forEach(wb => {
                                let employee = view.employeeMap[wb.employeeId];
                                let mainSpot = employee.spotId != null ? view.spotMap[employee.spotId] : null;
                                let employeeLevel = mainSpot != null ? mainSpot.employeeLevel : 1;

                                if (data.employeeLevels.includes(employeeLevel)) {
                                    balances.push(wb);
                                    if (wb.confirmed == false) {
                                        containsUnconfirmed = true;
                                    }
                                }
                            });
                        } else {
                            balances = data.balances;
                            containsUnconfirmed = balances.find(b => b.confirmed == false) != null;
                        }
                        view.exportSPSReisertCsv(balances);
                    }
                },
                header: this.$t('workBalance.payroll.reisertExportSelection'),
                expanded: true,
                width: "700px",
                centered: true
            });
        },
        exportSPSReisertCsv(balances) {
            let date = new Date();
            let ts = (date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2(date.getDate()) + this.$helpers.pad2(date.getHours()) + this.$helpers.pad2(date.getMinutes()) + this.$helpers.pad2(date.getSeconds()));

            let view = this;
            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";

            let headers = ['PE-Nr', 'PE-Name, Vorname', 'LA 51', 'LA 74', 'LA 120', 'LA 60', 'LA 1144', 'LA 1174', 'LA 1128', 'LA 148']

            let filename = 'Monatsabschluss_SPS_' + this.currentMonthFrom.format('YYYY-MM') + '_' + this.storeSettings.name + '_' + ts + '.csv';

            csv += headers.join(";");
            csv += "\n";


            balances.sort(function (a, b) {
                let ea = view.employeeMap[a.employeeId];
                let eb = view.employeeMap[b.employeeId];
                if (view.sortByName) {
                    let aName = ea.lastName + " " + ea.firstName;
                    let bName = eb.lastName + " " + eb.firstName;
                    return aName.localeCompare(bName);
                } else {
                    if (ea != undefined && eb != undefined) {
                        let eaNum = ea.personnelId;
                        let ebNum = eb.personnelId;
                        if (eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null) {
                            eaNum = parseInt(eaNum);
                            ebNum = parseInt(ebNum);
                            if (eaNum < ebNum) return -1;
                            if (eaNum > ebNum) return 1;
                        } else if (eaNum == null || eaNum == undefined) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                }
                return 0;
            });

            balances.forEach(function (balance) {
                let employee = view.employeeMap[balance.employeeId];
                let employeeId = employee.id;
                let mainContract = null;


                let overlappingContracts = [];

                if (view.employeeContractMap[employeeId]) {
                    let contracts = view.employeeContractMap[employeeId];

                    overlappingContracts = view.$helpers.GetContractsOverlappingMonth(contracts, view.currentMonthFromTZ.clone().startOf('week').subtract(1, 'days'), view.currentMonthToTZ);
                    overlappingContracts.forEach(contract => {

                        let contractFrom = view.$helpers.getMomentFromStringTZ(contract.from);


                        if (!mainContract) {
                            mainContract = contract;
                        } else {
                            let mainContractFrom = view.$helpers.getMomentFromStringTZ(mainContract.from);
                            if (contractFrom > mainContractFrom) {
                                mainContract = contract;
                            }
                        }
                    });

                }
                let employeeNumber = employee.personnelId;
                let employeeName = employee.lastName + " " + employee.firstName;

                let monthlyOverTime = (Math.max(0, ((balance.workTime + balance.unproductiveWorkTime) - balance.workTimeRegular)) / 60.0).toFixed(2);
                let la51 = (balance.workTime / 60.0).toFixed(2);
                let la74 = (balance.nightWorkTime / 60.0).toFixed(2);
                let la120 = (balance.holidayTime / 60.0).toFixed(2);
                let la60 = mainContract ? (mainContract.contractType != 3 ? monthlyOverTime : (0).toFixed(2)) : monthlyOverTime;
                let la1144 = (balance.vacationTime / (24 * 60)).toFixed(2);
                let la1174 = (balance.sickTime / (24 * 60)).toFixed(2);
                let la1128 = (balance.wageContinuationTime / (24 * 60)).toFixed(2);
                let la148 = (Math.max(0, (balance.paidVacationTime)) / (24 * 60.0)).toFixed(2);

                csv += [employeeNumber, employeeName, la51, la74, la120, la60, la1144, la1174, la1128, la148].join(";");
                csv += "\n";
            });

            let s = csv.split(".");
            csv = s.join(",");
            let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();

        },
        exportCsv(balances) {
            var date = new Date();
            let ts = (date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2(date.getDate()) + this.$helpers.pad2(date.getHours()) + this.$helpers.pad2(date.getMinutes()) + this.$helpers.pad2(date.getSeconds()));

            let view = this;
            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";
            let headers = [this.$t('pages.employeeData.name'), 'Soll (h)', 'Vormonat (h)', 'Ist (h)', 'Unproduktiv Ist (h)', 'Krank (h)', 'LFZ (h)', 'Ausbildung (h)', 'Sonstige Abwesenheiten (h)', 'Pflegeurlaub (h)',
                'Urlaub (h)', 'Urlaub ausbezahlt (t)', 'Urlaub Saldo (t)', 'Arbeitszeit ausbezahlt (h)', 'Arbeitszeit Saldo (h)', 'FT Saldo Vormonat (h)', 'FT (h)',
                'FTA (h)', 'FT ausbezahlt (h)', 'FT Saldo (h)', 'Nachtarbeit Vormonat(h)', 'Nachtarbeit (h)', 'Nachtarbeit (Anzahl)', 'Nachtarbeit ausbezahlt (h)',
                'Nachtarbeit Saldo (h)',
                'Überstunden Vormonat (h)', 'Überstunden (h)', 'Überstunden (Anzahl)', 'Überstunden ausbezahlt (h)', 'Überstunden Saldo (h)', 'Tagesüberstunden (h)', 'Wochenüberstunden (h)', 'Überstunden aus zu vielen Arbeitstagen (h)',
                'Mehrstunden Vormonat (h)', 'Mehrstunden (h)', 'Mehrstunden ausbezahlt (h)', 'Mehrstunden Saldo (h)',
                'Bonusstunden Vormonat (h)', 'Bonusstunden (h)', 'Bonusstunden (Anzahl)', 'Bonusstunden ausbezahlt (h)', 'Bonusstunden Saldo (h)',
                this.$t('global.general.comment')];
            if (!view.sortByName) {
                headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$t('pages.employeeData.name'), 'Soll (h)', 'Vormonat (h)', 'Ist (h)', 'Unproduktiv Ist (h)', 'Krank (h)', 'LFZ (h)', 'Ausbildung (h)', 'Sonstige Abwesenheiten (h)', 'Pflegeurlaub (h)',
                    'Urlaub (h)', 'Urlaub ausbezahlt (t)', 'Urlaub Saldo (t)', 'Arbeitszeit ausbezahlt (h)', 'Arbeitszeit Saldo (h)', 'FT Saldo Vormonat (h)', 'FT (h)',
                    'FTA (h)', 'FT ausbezahlt (h)', 'FT Saldo (h)', 'Nachtarbeit Vormonat(h)', 'Nachtarbeit (h)', 'Nachtarbeit (Anzahl)', 'Nachtarbeit ausbezahlt (h)',
                    'Nachtarbeit Saldo (h)', 'Überstunden Vormonat (h)', 'Überstunden (h)', 'Überstunden (Anzahl)', 'Überstunden ausbezahlt (h)', 'Überstunden Saldo (h)', 'Tagesüberstunden (h)', 'Wochenüberstunden (h)', 'Überstunden aus zu vielen Arbeitstagen (h)',
                    'Mehrstunden Vormonat (h)', 'Mehrstunden (h)', 'Mehrstunden ausbezahlt (h)', 'Mehrstunden Saldo (h)',
                    'Bonusstunden Vormonat (h)', 'Bonusstunden (h)', 'Bonusstunden (Anzahl)', 'Bonusstunden ausbezahlt (h)', 'Bonusstunden Saldo (h)',
                    this.$t('global.general.comment')];
            }
            let prefix = this.isBeforeCurrentIRLMonth ? "" : "Entwurf "
            let filename = prefix + 'Monatsabschluss_' + this.currentMonthFrom.format('YYYY-MM') + '_' + this.storeSettings.name + '_' + ts + '.csv';

            csv += headers.join(";");
            csv += "\n";


            balances.sort(function (a, b) {
                let ea = view.employeeMap[a.employeeId];
                let eb = view.employeeMap[b.employeeId];
                if (view.sortByName) {
                    if (ea != undefined && eb != undefined) {
                        if (ea.lastName < eb.lastName) return -1;
                        if (ea.lastName > eb.lastName) return 1;
                        if (ea.lastName == eb.lastName && ea.firstName < eb.firstName) return -1;
                        if (ea.lastName == eb.lastName && ea.firstName > eb.firstName) return 1;
                    }
                } else {
                    if (ea != undefined && eb != undefined) {
                        let eaNum = ea.personnelId;
                        let ebNum = eb.personnelId;
                        if (eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null) {
                            eaNum = parseInt(eaNum);
                            ebNum = parseInt(ebNum);
                            if (eaNum < ebNum) return -1;
                            if (eaNum > ebNum) return 1;
                        } else if (eaNum == null || eaNum == undefined) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                }
                return 0;
            });
            let hmap = this.dataTableState.headerMap;

            for (let i = 0; i < balances.length; i++) {
                let bal = balances[i];
                let preBal = this.previousMonthWorkBalanceMap[bal.employeeId];


                let mainContract = this.getMainContractForEmployee(bal.employeeId);

                let cur = [
                    hmap.name != undefined ? hmap.name.DisplayLabel(bal) : '',
                    (bal.workTimeRegular / 60).toFixed(2),
                    (bal.prevMonthTime / 60).toFixed(2),
                    (bal.workTime / 60).toFixed(2),
                    (bal.unproductiveWorkTime / 60).toFixed(2),
                    (bal.sickWorkTime / 60).toFixed(2),
                    (bal.wageContinuationWorkTime / 60).toFixed(2),
                    (bal.educationWorkTime / 60).toFixed(2),
                    (bal.miscWorkTime / 60).toFixed(2),
                    (bal.nursingVacationWorkTime / 60).toFixed(2),
                    (bal.vacationWorkTime / 60).toFixed(2),
                    (bal.paidVacationTime / 60 / 24).toFixed(2),
                    (bal.vacationTimeBalance / 60 / 24).toFixed(2),

                    (bal.paidWorkTime / 60).toFixed(2),
                    (bal.workTimeBalance / 60).toFixed(2),

                    preBal != undefined ? (preBal.holidayTimeBalance / 60).toFixed(2) : 0,
                    (bal.holidayTime / 60).toFixed(2),
                    (bal.holidayAdjustmentWorkTime / 60).toFixed(2),
                    (bal.paidHolidayTime / 60).toFixed(2),
                    (bal.holidayTimeBalance / 60).toFixed(2),
                    (bal.prevMonthNightWorkTime / 60).toFixed(2),
                    (bal.nightWorkTime / 60).toFixed(2),
                    bal.nightWorkCount,
                    (bal.paidNightWorkTime / 60).toFixed(2),
                    (bal.nightWorkTimeBalance / 60).toFixed(2),
                    (bal.prevMonthOverTime / 60).toFixed(2),
                    (bal.overTime / 60).toFixed(2),
                    bal.overTimeCount,
                    (bal.paidOverTime / 60).toFixed(2),
                    (bal.overTimeBalance / 60).toFixed(2),
                    (bal.dailyOverTime / 60).toFixed(2),
                    (bal.weeklyOverTime / 60).toFixed(2),
                    (bal.workDayOverTime / 60).toFixed(2),
                    (bal.prevMonthMoreTime / 60).toFixed(2),
                    (bal.moreTime / 60).toFixed(2),
                    (bal.paidMoreTime / 60).toFixed(2),
                    (bal.moreTimeBalance / 60).toFixed(2),
                    (bal.prevMonthBonusTime / 60).toFixed(2),
                    (bal.bonusTime / 60).toFixed(2),
                    bal.bonusTimeCount,
                    (bal.paidBonusTime / 60).toFixed(2),
                    (bal.bonusTimeBalance / 60).toFixed(2),
                    bal.comment != undefined && bal.comment != null ? bal.comment : ''
                ];
                if (!view.sortByName) cur.unshift(hmap.personnelId != undefined ? hmap.personnelId.DisplayLabel(bal) : '');
                let line = cur.join(";");
                csv += line;
                csv += "\n";
            }

            let s = csv.split(".");
            csv = s.join(",");
            let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
        },

        hideModal(ref) {
            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        },

        addPdfReportHeader(headers, data, fieldKey, fieldName, sums, sumsPositive, sumsNegative) {
            if (data[fieldKey]) {
                headers.push(fieldName)
                sums[fieldKey] = 0;
                sumsPositive[fieldKey] = 0;
                sumsNegative[fieldKey] = 0;

            }
        },
        addPdfReportColumnValue(row, data, fieldKey, balance, sums, sumsPositive, sumsNegative, divisor, isNumerical, divisor2 = null, multiplier = 1, customFieldKey = null, noComma = false) {

            let checkKey = customFieldKey ? customFieldKey : fieldKey;
            if (data[checkKey]) {
                let val = balance[fieldKey];

                if (isNumerical && val != null) {
                    if (divisor2 != null) {
                        val = val / divisor2;
                    }
                    val = val * multiplier;
                    if (noComma) {
                        let cv = val / divisor;
                        if (cv % 1 != 0) {
                            row.push(cv.toFixed(2));
                        } else {
                            row.push(cv.toFixed(0));
                        }
                    } else {
                        row.push((val / divisor).toFixed(2));
                    }


                    sums[checkKey] += val;
                    val >= 0 ? sumsPositive[checkKey] += val : sumsNegative[checkKey] += val;

                } else {
                    row.push(val != null ? val : '-');
                }

            }
        },

        addPdfReportPercentageValue(row, data, destinationKey, dataKey, divisorKeys, balance, sums, sumsPositive, sumsNegative, divisor) {


            if (data[destinationKey]) {
                let val = balance[dataKey];
                let divVal = 1;
                if (divisorKeys && divisorKeys.length > 0) {
                    divVal = divisorKeys.reduce((acc, key) => acc + balance[key], 0);
                }


                if (val != null && divVal > 0) {
                    let percentageVal = val / divVal;

                    row.push((percentageVal * 100 / divisor).toFixed(2) + '%');

                    sums[destinationKey] += val;
                    val >= 0 ? sumsPositive[destinationKey] += val : sumsNegative[destinationKey] += val;

                } else {
                    row.push('-');
                }

            }
        },

        addPdfReportColumnSetValue(row, data, fieldKey, value, sums, sumsPositive, sumsNegative, divisor, isNumerical) {
            if (data[fieldKey]) {
                let val = value;
                if (isNumerical && val != null) {
                    row.push((val / divisor).toFixed(2));
                    sums[fieldKey] += val;
                    val >= 0 ? sumsPositive[fieldKey] += val : sumsNegative[fieldKey] += val;
                } else {
                    row.push(val != null ? val : '-');
                }
            }
        },
        addPdfReportAdderColumnValue(row, data, fieldKey, addFields, balance, sums, sumsPositive, sumsNegative, divisor) {
            if (data[fieldKey]) {
                let val = 0
                addFields.forEach(key => {
                    val += balance[key];
                })
                row.push((val / divisor).toFixed(2));
                sums[fieldKey] += val;
                val >= 0 ? sumsPositive[fieldKey] += val : sumsNegative[fieldKey] += val;
            }
        },
        addPdfReportAdderAboveThresholdColumnValue(row, data, fieldKey, addFields, balance, sums, sumsPositive, sumsNegative, divisor, threshold) {
            if (data[fieldKey]) {
                let val = 0
                addFields.forEach(key => {
                    val += balance[key];
                })
                let diff = Math.max(0, val - (threshold != null ? threshold : 0));
                row.push((diff / divisor).toFixed(2));
                sums[fieldKey] += diff;
                val >= 0 ? sumsPositive[fieldKey] += diff : sumsNegative[fieldKey] += diff;
            }
        },
        addPdfReportSumValue(sumRow, positiveRow, negativeRow, data, fieldKey, sums, sumsPositive, sumsNegative, divisor, isNumerical, noComma = false) {
            if (data[fieldKey]) {
                let sumVal = sums[fieldKey];
                let posVal = sumsPositive[fieldKey];
                let negVal = sumsNegative[fieldKey];
                if (isNumerical) {
                    if (noComma) {
                        let cv = sumVal / divisor;
                        let cvPos = posVal / divisor;
                        let cvNeg = negVal / divisor;
                        if (cv % 1 != 0) {
                            sumRow.push(cv.toFixed(2));
                        } else {
                            sumRow.push(cv.toFixed(0));
                        }
                        if (cvPos % 1 != 0) {
                            positiveRow.push(cvPos.toFixed(2));
                        } else {
                            positiveRow.push(cvPos.toFixed(0));
                        }
                        if (cvNeg % 1 != 0) {
                            negativeRow.push(cvNeg.toFixed(2));
                        } else {
                            negativeRow.push(cvNeg.toFixed(0));
                        }
                    } else {
                        sumRow.push((sumVal / divisor).toFixed(2));
                        positiveRow.push((posVal / divisor).toFixed(2));
                        negativeRow.push((negVal / divisor).toFixed(2));
                    }

                } else {
                    sumRow.push('-');
                    positiveRow.push('-');
                    negativeRow.push('-');
                }
            }
        },
        addPdfReportSumPercentage(sumRow, positiveRow, negativeRow, data, fieldKey, divisorKeys, sums, divisor, isNumerical) {
            if (data[fieldKey]) {
                let sumVal = sums[fieldKey];
                let divVal = 1;
                if (divisorKeys && divisorKeys.length > 0) {
                    divVal = divisorKeys.reduce((acc, key) => acc + sums[key], 0);
                }

                if (isNumerical) {
                    let percentageVal = sumVal / divVal;

                    sumRow.push((percentageVal * 100 / divisor).toFixed(2) + '%');
                    positiveRow.push('-');
                    negativeRow.push('-');
                } else {
                    sumRow.push('-');
                    positiveRow.push('-');
                    negativeRow.push('-');
                }
            }
        },
        addPdfReportLatestAccPeriodValue(row, data, dataKey, fieldKey, balance, sums, sumsPositive, sumsNegative, divisor, isNumerical) {

            if (data[dataKey]) {
                let val = this.latestEmployeeAccPeriodMap[balance.employeeId] ? this.latestEmployeeAccPeriodMap[balance.employeeId][fieldKey] : null;
                if (isNumerical && val != null) {
                    row.push((val / divisor).toFixed(2));
                    sums[dataKey] += val;
                    val >= 0 ? sumsPositive[dataKey] += val : sumsNegative[dataKey] += val;
                } else {
                    row.push(val != null ? val : '-');
                }
            }
        },
        addPdfReportCalculatedPayouts(row, data, bal, sums, sumsPositive, sumsNegative, divisor) {
            let prevAccPeriodBalance = this.latestEmployeeAccPeriodMap[bal.employeeId] ? this.latestEmployeeAccPeriodMap[bal.employeeId].workTimeBalance : 0;
            if (data.fiftypercentpayout) {
                let unmodifiedWorkTimeBalance = bal.workTimeBalance + bal.paidWorkTime;
                let unmodifiedMoreTimeBalance = bal.moreTimeBalance + bal.paidMoreTime;
                //let unmodifiedOverTimeBalance = bal.overTimeBalance + bal.paidOverTime;

                //let adjustedMoreTimeBalance = Math.max(0, unmodifiedMoreTimeBalance - Math.max(0, unmodifiedOverTimeBalance));
                let val = Math.max(0, unmodifiedWorkTimeBalance - Math.max(0, unmodifiedMoreTimeBalance));

                row.push((val / divisor).toFixed(2));
                sums['fiftypercentpayout'] += val;
                val >= 0 ? sumsPositive['fiftypercentpayout'] += val : sumsNegative['fiftypercentpayout'] += val;


            }
            if (data.paidfiftypercentpayout) {
                let positivePaidWorkTime = Math.max(0, bal.paidWorkTime);
                let positivePaidMoreTime = Math.max(0, bal.paidMoreTime);
                let val = Math.max(0, positivePaidWorkTime - positivePaidMoreTime);

                row.push((val / divisor).toFixed(2));
                sums['paidfiftypercentpayout'] += val;
                val >= 0 ? sumsPositive['paidfiftypercentpayout'] += val : sumsNegative['paidfiftypercentpayout'] += val;


            }
            if (data.fiftypercentpayoutWithoutAccPeriod) {
                let unmodifiedWorkTimeBalance = bal.workTimeBalance + bal.paidWorkTime - prevAccPeriodBalance;
                let unmodifiedMoreTimeBalance = bal.moreTimeBalance + bal.paidMoreTime;
                let val = Math.max(0, unmodifiedWorkTimeBalance - Math.max(0, unmodifiedMoreTimeBalance));

                row.push((val / divisor).toFixed(2));
                sums['fiftypercentpayoutWithoutAccPeriod'] += val;
                val >= 0 ? sumsPositive['fiftypercentpayoutWithoutAccPeriod'] += val : sumsNegative['fiftypercentpayoutWithoutAccPeriod'] += val;
            }

            if (data.twentyfivepercentpayout) {
                let unmodifiedWorkTimeBalance = bal.workTimeBalance + bal.paidWorkTime;
                let unmodifiedMoreTimeBalance = bal.moreTimeBalance + bal.paidMoreTime;
                let val = Math.max(0, Math.min(unmodifiedWorkTimeBalance, Math.max(0, unmodifiedMoreTimeBalance)));

                row.push((val / divisor).toFixed(2));
                sums['twentyfivepercentpayout'] += val;
                val >= 0 ? sumsPositive['twentyfivepercentpayout'] += val : sumsNegative['twentyfivepercentpayout'] += val;


            }
            if (data.paidtwentyfivepercentpayout) {
                let positivePaidWorkTime = Math.max(0, bal.paidWorkTime);
                let positivePaidMoreTime = Math.max(0, bal.paidMoreTime);
                let val = Math.max(0, Math.min(positivePaidWorkTime, positivePaidMoreTime));

                row.push((val / divisor).toFixed(2));
                sums['paidtwentyfivepercentpayout'] += val;
                val >= 0 ? sumsPositive['paidtwentyfivepercentpayout'] += val : sumsNegative['paidtwentyfivepercentpayout'] += val;


            }
            if (data.twentyfivepercentpayoutWithoutAccPeriod) {
                let unmodifiedWorkTimeBalance = bal.workTimeBalance + bal.paidWorkTime - prevAccPeriodBalance;
                let unmodifiedMoreTimeBalance = bal.moreTimeBalance + bal.paidMoreTime;
                let val = Math.max(0, Math.min(unmodifiedWorkTimeBalance, Math.max(0, unmodifiedMoreTimeBalance)));

                row.push((val / divisor).toFixed(2));
                sums['twentyfivepercentpayoutWithoutAccPeriod'] += val;
                val >= 0 ? sumsPositive['twentyfivepercentpayoutWithoutAccPeriod'] += val : sumsNegative['twentyfivepercentpayoutWithoutAccPeriod'] += val;
            }

        },
        addPdfReportWorkDays(row, data, bal, sums, sumsPositive, sumsNegative) {

            if (data.workDaysPlanned) {
                let days = [];

                let planshifts = this.employeePlanShiftMap[bal.employeeId];
                if (planshifts != null) {
                    planshifts.forEach(shift => {
                        if (shift.published) {
                            let date = this.$helpers.getMomentFromStringTZ(shift.from);
                            let key = date.format("DD.MM.YYYY");
                            if (date >= this.currentMonthFromTZ && date < this.currentMonthToTZ && !days.includes(key)) {
                                days.push(key);
                            }
                        }

                    })
                }
                let val = days.length;
                row.push((val / 1.0).toFixed(2));
                sums['workDaysPlanned'] += val;
                val >= 0 ? sumsPositive['workDaysPlanned'] += val : sumsNegative['workDaysPlanned'] += val;


            }
            if (data.workDaysActual) {
                let days = [];

                let actualShiftDays = this.employeeDateActualShiftMap[bal.employeeId];


                if (actualShiftDays != null) {
                    let actualShifts = Object.values(actualShiftDays).flatMap((x) => x);

                    actualShifts.forEach(shift => {
                        let date = this.$helpers.getMomentFromStringTZ(shift.from);
                        let key = date.format("DD.MM.YYYY");
                        if (date >= this.currentMonthFromTZ && date < this.currentMonthToTZ && !days.includes(key)) {
                            days.push(key);
                        }
                    })
                }
                let val = days.length;
                row.push((val / 1.0).toFixed(2));
                sums['workDaysActual'] += val;
                val >= 0 ? sumsPositive['workDaysActual'] += val : sumsNegative['workDaysActual'] += val;


            }


        },

        addPdfReportOffWorkDays(row, data, bal, sums, sumsPositive, sumsNegative, csv = false) {
            let spareSundaysPlanned = 0;
            let spareSundaysActual = 0;
            let contracts = this.employeeContractMap[bal.employeeId] != null ? this.employeeContractMap[bal.employeeId] : [];

            contracts = contracts.map(c => {
                return {
                    from: this.$helpers.getMomentFromStringTZ(c.from),
                    to: c.to != null ? this.$helpers.getMomentFromStringTZ(c.to) : this.currentMonthToTZ
                }
            });


            if (data.offWorkDaysPlanned) {
                let days = new Set();

                let planshifts = this.employeePlanShiftMap[bal.employeeId];
                if (planshifts != null) {
                    planshifts.forEach(shift => {
                        if (shift.published) {
                            let date = this.$helpers.getMomentFromStringTZ(shift.from);
                            let key = date.format("DD.MM.YYYY");
                            if (date >= this.currentMonthFromTZ && date < this.currentMonthToTZ && !days.has(key)) {
                                days.add(key);
                            }
                        }

                    })
                }
                let preferences = this.employeePreferenceMap[bal.employeeId];
                if (preferences != null && preferences.length > 0) {
                    preferences.filter(pref => pref.approved && pref.state == 1 && pref.type != 8 && !(pref.type == 4 && !pref.alwaysWork)).forEach(pref => {
                        console.log(pref)
                        let prefFrom = this.$helpers.getMomentFromStringTZ(pref.from);
                        let prefTo = this.$helpers.getMomentFromStringTZ(pref.to);

                        let prefStart = prefFrom.clone();

                        while (prefStart < prefTo) {
                            let key = prefStart.format("DD.MM.YYYY");

                            if (prefStart >= this.currentMonthFromTZ && prefStart < this.currentMonthToTZ && !days.has(key)) {
                                days.add(key);
                            }
                            prefStart = prefStart.add(1, 'days').startOf('day');
                        }
                    });
                }

                let monthStart = this.currentMonthFromTZ.clone();
                let val = 0;
                while (monthStart < this.currentMonthToTZ) {
                    let key = monthStart.format("DD.MM.YYYY");
                    if (!days.has(key) && contracts.some(c => monthStart >= c.from && monthStart < c.to)) {
                        val += 1;
                    }
                    monthStart = monthStart.add(1, 'days').startOf('day');
                }

                row.push((val / 1.0).toFixed(2));
                sums['offWorkDaysPlanned'] += val;
                val >= 0 ? sumsPositive['offWorkDaysPlanned'] += val : sumsNegative['offWorkDaysPlanned'] += val;


            }

            if (data.offWorkDaysActual) {
                let days = new Set();

                let actualShiftDays = this.employeeDateActualShiftMap[bal.employeeId];


                if (actualShiftDays != null) {
                    let actualShifts = Object.values(actualShiftDays).flatMap((x) => x);

                    actualShifts.forEach(shift => {
                        let date = this.$helpers.getMomentFromStringTZ(shift.from);
                        let key = date.format("DD.MM.YYYY");
                        if (date >= this.currentMonthFromTZ && date < this.currentMonthToTZ && !days.has(key)) {
                            days.add(key);
                        }
                    })
                }

                let preferences = this.employeePreferenceMap[bal.employeeId];
                if (preferences != null && preferences.length > 0) {
                    preferences.filter(pref => pref.approved && pref.state == 1 && pref.type != 8 && !(pref.type == 4 && !pref.alwaysWork)).forEach(pref => {
                        let prefFrom = this.$helpers.getMomentFromStringTZ(pref.from);
                        let prefTo = this.$helpers.getMomentFromStringTZ(pref.to);

                        let prefStart = prefFrom.clone();

                        while (prefStart < prefTo) {
                            let key = prefStart.format("DD.MM.YYYY");

                            if (prefStart >= this.currentMonthFromTZ && prefStart < this.currentMonthToTZ && !days.has(key)) {
                                days.add(key);
                            }
                            prefStart = prefStart.add(1, 'days').startOf('day');
                        }
                    });
                }

                let monthStart = this.currentMonthFromTZ.clone();
                let val = 0;
                while (monthStart < this.currentMonthToTZ) {
                    let key = monthStart.format("DD.MM.YYYY");
                    if (!days.has(key) && contracts.some(c => monthStart >= c.from && monthStart < c.to)) {
                        val += 1;
                    }
                    monthStart = monthStart.add(1, 'days').startOf('day');
                }

                row.push((val / 1.0).toFixed(2));
                sums['offWorkDaysActual'] += val;
                val >= 0 ? sumsPositive['offWorkDaysActual'] += val : sumsNegative['offWorkDaysActual'] += val;


            }

            if (data.offWorkWeekendDaysPlanned) {
                let days = new Set();

                let planshifts = this.employeePlanShiftMap[bal.employeeId];
                if (planshifts != null) {
                    planshifts.forEach(shift => {
                        if (shift.published) {
                            let date = this.$helpers.getMomentFromStringTZ(shift.from);
                            let key = date.format("DD.MM.YYYY");
                            if (date >= this.currentMonthFromTZ && date < this.currentMonthToTZ && !days.has(key)) {
                                days.add(key);

                            }
                        }

                    })
                }
                let preferences = this.employeePreferenceMap[bal.employeeId];
                if (preferences != null && preferences.length > 0) {
                    preferences.filter(pref => pref.approved && pref.state == 1 && pref.type != 8 && !(pref.type == 4 && !pref.alwaysWork)).forEach(pref => {

                        let prefFrom = this.$helpers.getMomentFromStringTZ(pref.from);
                        let prefTo = this.$helpers.getMomentFromStringTZ(pref.to);

                        let prefStart = prefFrom.clone();

                        while (prefStart < prefTo) {
                            let key = prefStart.format("DD.MM.YYYY");

                            if (prefStart >= this.currentMonthFromTZ && prefStart < this.currentMonthToTZ && !days.has(key)) {
                                days.add(key);
                            }
                            prefStart = prefStart.add(1, 'days').startOf('day');
                        }
                    });
                }

                let monthStart = this.currentMonthFromTZ.clone();
                let val = 0;
                let sundayVal = 0;
                while (monthStart < this.currentMonthToTZ) {
                    let key = monthStart.format("DD.MM.YYYY");
                    if (!days.has(key) && contracts.some(c => monthStart >= c.from && monthStart < c.to)) {
                        if (monthStart.isoWeekday() == 6) {
                            val += 1;
                        }

                        if (monthStart.isoWeekday() == 7) {
                            val += 1;
                            sundayVal += 1;
                        }
                    }
                    monthStart = monthStart.add(1, 'days').startOf('day');
                }


                if (data.offWorkWeekendDaysPlanned) {
                    row.push((val / 1.0).toFixed(2) + " " + (csv ? '' : '\n') + "(" + (sundayVal / 1.0).toFixed(2) + " So)");
                    sums['offWorkWeekendDaysPlanned'] += val;
                    val >= 0 ? sumsPositive['offWorkWeekendDaysPlanned'] += val : sumsNegative['offWorkWeekendDaysPlanned'] += val;
                }


            }

            if (data.offWorkWeekendDaysActual) {
                let days = new Set();

                let actualShiftDays = this.employeeDateActualShiftMap[bal.employeeId];


                if (actualShiftDays != null) {
                    let actualShifts = Object.values(actualShiftDays).flatMap((x) => x);

                    actualShifts.forEach(shift => {
                        let date = this.$helpers.getMomentFromStringTZ(shift.from);
                        let key = date.format("DD.MM.YYYY");

                        if (date >= this.currentMonthFromTZ && date < this.currentMonthToTZ && !days.has(key)) {
                            days.add(key);
                        }
                    })
                }

                let preferences = this.employeePreferenceMap[bal.employeeId];
                if (preferences != null && preferences.length > 0) {
                    preferences.filter(pref => pref.approved && pref.state == 1 && pref.type != 8 && !(pref.type == 4 && !pref.alwaysWork)).forEach(pref => {
                        let prefFrom = this.$helpers.getMomentFromStringTZ(pref.from);
                        let prefTo = this.$helpers.getMomentFromStringTZ(pref.to);

                        let prefStart = prefFrom.clone();

                        while (prefStart < prefTo) {
                            let key = prefStart.format("DD.MM.YYYY");

                            if (prefStart >= this.currentMonthFromTZ && prefStart < this.currentMonthToTZ && !days.has(key)) {
                                days.add(key);
                            }
                            prefStart = prefStart.add(1, 'days').startOf('day');
                        }
                    });
                }

                let monthStart = this.currentMonthFromTZ.clone();
                let val = 0;
                let sundayVal = 0;
                while (monthStart < this.currentMonthToTZ) {
                    let key = monthStart.format("DD.MM.YYYY");
                    if (!days.has(key) && contracts.some(c => monthStart >= c.from && monthStart < c.to)) {
                        if (monthStart.isoWeekday() == 6) {
                            val += 1;
                        }

                        if (monthStart.isoWeekday() == 7) {
                            val += 1;
                            sundayVal += 1;
                        }
                    }
                    monthStart = monthStart.add(1, 'days').startOf('day');
                }


                if (data.offWorkWeekendDaysActual) {
                    row.push((val / 1.0).toFixed(2) + " " + (csv ? '' : '\n') + "(" + (sundayVal / 1.0).toFixed(2) + " So)");
                    sums['offWorkWeekendDaysActual'] += val;
                    val >= 0 ? sumsPositive['offWorkWeekendDaysActual'] += val : sumsNegative['offWorkWeekendDaysActual'] += val;
                }


            }

            if (data.offWorkWeekendsPlanned || data.offSunDaysPerYearPlanned) {
                let days = new Set();

                let planshifts = this.employeePlanShiftMap[bal.employeeId];
                if (planshifts != null) {
                    planshifts.forEach(shift => {
                        if (shift.published) {
                            let date = this.$helpers.getMomentFromStringTZ(shift.from);
                            let key = date.format("DD.MM.YYYY");
                            if (date >= this.currentMonthFromTZ && date < this.currentMonthToTZ && !days.has(key)) {
                                if (date.isoWeekday() == 1) {
                                    if (date.hours() < 16) {
                                        days.add(key);
                                    }

                                } else {
                                    days.add(key);
                                }

                            }
                        }

                    })
                }
                let preferences = this.employeePreferenceMap[bal.employeeId];
                if (preferences != null && preferences.length > 0) {
                    preferences.filter(pref => pref.approved && pref.state == 1 && pref.type != 8 && !(pref.type == 4 && !pref.alwaysWork)).forEach(pref => {

                        let prefFrom = this.$helpers.getMomentFromStringTZ(pref.from);
                        let prefTo = this.$helpers.getMomentFromStringTZ(pref.to);

                        let prefStart = prefFrom.clone();

                        while (prefStart < prefTo) {
                            let key = prefStart.format("DD.MM.YYYY");

                            if (prefStart >= this.currentMonthFromTZ && prefStart < this.currentMonthToTZ && !days.has(key)) {
                                days.add(key);
                            }
                            prefStart = prefStart.add(1, 'days').startOf('day');
                        }
                    });
                }

                let monthStart = this.currentMonthFromTZ.clone();

                let val = 0;
                while (monthStart < this.currentMonthToTZ) {
                    let key = monthStart.format("DD.MM.YYYY");
                    if (!days.has(key) && contracts.some(c => monthStart >= c.from && monthStart < c.to) && monthStart.isoWeekday() == 7) {
                        let satKey = monthStart.clone().add(-1, 'days').format("DD.MM.YYYY");
                        let monKey = monthStart.clone().add(1, 'days').format("DD.MM.YYYY");

                        if ((!days.has(satKey) && !days.has(monKey)) || (days.has(satKey) && !days.has(monKey)) || (!days.has(satKey) && days.has(monKey))) {
                            val += 1;
                        }


                    }
                    monthStart = monthStart.add(1, 'days').startOf('day');
                }
                spareSundaysPlanned += val;

                if (data.offWorkWeekendsPlanned) {
                    row.push((val / 1.0).toFixed(2));
                    sums['offWorkWeekendsPlanned'] += val;
                    val >= 0 ? sumsPositive['offWorkWeekendsPlanned'] += val : sumsNegative['offWorkWeekendDsPlanned'] += val;
                }


            }

            if (data.offWorkWeekendsActual || data.offSunDaysPerYearActual) {

                let days = new Set();

                let actualShiftDays = this.employeeDateActualShiftMap[bal.employeeId];


                if (actualShiftDays != null) {
                    let actualShifts = Object.values(actualShiftDays).flatMap((x) => x);

                    actualShifts.forEach(shift => {
                        let date = this.$helpers.getMomentFromStringTZ(shift.from);
                        let key = date.format("DD.MM.YYYY");

                        if (date >= this.currentMonthFromTZ && date < this.currentMonthToTZ && !days.has(key)) {
                            if (date.isoWeekday() == 1) {
                                if (date.hours() < 16) {
                                    days.add(key);
                                }

                            } else {
                                days.add(key);
                            }
                        }
                    })
                }

                let preferences = this.employeePreferenceMap[bal.employeeId];
                if (preferences != null && preferences.length > 0) {
                    preferences.filter(pref => pref.approved && pref.state == 1 && pref.type != 8 && !(pref.type == 4 && !pref.alwaysWork)).forEach(pref => {
                        let prefFrom = this.$helpers.getMomentFromStringTZ(pref.from);
                        let prefTo = this.$helpers.getMomentFromStringTZ(pref.to);

                        let prefStart = prefFrom.clone();

                        while (prefStart < prefTo) {
                            let key = prefStart.format("DD.MM.YYYY");

                            if (prefStart >= this.currentMonthFromTZ && prefStart < this.currentMonthToTZ && !days.has(key)) {
                                days.add(key);
                            }
                            prefStart = prefStart.add(1, 'days').startOf('day');
                        }
                    });
                }

                let monthStart = this.currentMonthFromTZ.clone();
                let val = 0;
                console.log(contracts)
                while (monthStart < this.currentMonthToTZ) {
                    let key = monthStart.format("DD.MM.YYYY");

                    if (!days.has(key) && contracts.some(c => monthStart >= c.from && monthStart < c.to) && monthStart.isoWeekday() == 7) {
                        let satKey = monthStart.clone().add(-1, 'days').format("DD.MM.YYYY");
                        let monKey = monthStart.clone().add(1, 'days').format("DD.MM.YYYY");
                        console.log("A")
                        if ((!days.has(satKey) && !days.has(monKey)) || (days.has(satKey) && !days.has(monKey)) || (!days.has(satKey) && days.has(monKey))) {
                            val += 1;
                            console.log("B")
                        }
                    }
                    monthStart = monthStart.add(1, 'days').startOf('day');
                }
                spareSundaysActual += val;

                if (data.offWorkWeekendsActual) {
                    row.push((val / 1.0).toFixed(2));
                    sums['offWorkWeekendsActual'] += val;
                    val >= 0 ? sumsPositive['offWorkWeekendsActual'] += val : sumsNegative['offWorkWeekendsActual'] += val;
                }


            }
            if (data.offSunDaysPerYearPlanned) {
                let spare = data.spareSunDayData[bal.employeeId] ? data.spareSunDayData[bal.employeeId].plannedSpare : 0;

                let val = spare + spareSundaysPlanned;

                row.push((val / 1.0).toFixed(2))
                sums['offSunDaysPerYearPlanned'] += val;
                val >= 0 ? sumsPositive['offSunDaysPerYearPlanned'] += val : sumsNegative['offSunDaysPerYearPlanned'] += val;
            }
            if (data.offSunDaysPerYearActual) {
                let spare = data.spareSunDayData[bal.employeeId] ? data.spareSunDayData[bal.employeeId].actualSpare : 0;
                let val = spare + spareSundaysActual;

                row.push((val / 1.0).toFixed(2))
                sums['offSunDaysPerYearActual'] += val;
                val >= 0 ? sumsPositive['offSunDaysPerYearActual'] += val : sumsNegative['offSunDaysPerYearActual'] += val;
            }


        },
        addPdfReportEmployeePrefDays(row, data, bal, sums, sumsPositive, sumsNegative, contract = null) {

            if (data.sickDays || data.fullSickDays || data.holidayAdjustmentDays || data.wageContinuationDays || data.educationDays || data.nursingVacationDays || data.miscDays) {
                let sickDays = 0;
                let fullSickDays = 0;
                let holidayAdjustmentDays = 0;
                let wageContinuationDays = 0;
                let educationDays = 0;
                let nursingVacationDays = 0;
                let miscDays = 0;
                let workDays = contract != null ? contract.workDays : this.storeSettings.workDays;
                let preferences = this.employeePreferenceMap[bal.employeeId];
                if (preferences != null && preferences.length > 0) {
                    preferences.filter(pref => pref.approved).forEach(pref => {
                        if (pref.state == 1) {

                            let prefFrom = this.$helpers.getMomentFromStringTZ(pref.from);
                            let prefTo = this.$helpers.getMomentFromStringTZ(pref.to);

                            let prefStart = prefFrom.clone();

                            let alwaysWork = pref.alwaysWork;
                            let prefTimeTotal = 0;
                            let prefTimeTotalIncludingWeekends = 0;
                            while (prefStart < prefTo) {
                                //step through day, and check interval
                                let endOfDay = prefStart.clone().add(1, 'days').startOf('day');
                                let checkEnd = endOfDay < prefTo ? endOfDay : prefTo;

                                if (checkEnd > this.currentMonthFromTZ && prefStart < this.currentMonthToTZ) {
                                    let diff = checkEnd.diff(prefStart, 'minutes');

                                    let ratioFrom = prefStart < this.currentMonthFromTZ ? this.currentMonthFromTZ : (prefStart > this.currentMonthToTZ ? this.currentMonthToTZ : prefStart);
                                    let ratioTo = checkEnd > this.currentMonthToTZ ? this.currentMonthToTZ : (checkEnd < this.currentMonthFromTZ ? this.currentMonthFromTZ : checkEnd);

                                    let ratio = ratioTo.diff(ratioFrom) / checkEnd.diff(prefStart);


                                    let prefTime = Math.round(diff * ratio);
                                    if (prefTime > 0) {
                                        let isWeekend = !workDays.includes(prefStart.isoWeekday());

                                        if (pref.type == 1 || pref.type == 2 || pref.type == 3 || pref.type == 6 || pref.type == 7 || pref.type == 8) {
                                            if (!isWeekend || alwaysWork) {
                                                prefTimeTotal += prefTime;
                                            }
                                            prefTimeTotalIncludingWeekends += prefTime;
                                        } else if (pref.type == 4 && alwaysWork) {
                                            prefTimeTotal += prefTime;
                                            prefTimeTotalIncludingWeekends += prefTime;
                                        }

                                    }
                                }


                                prefStart = prefStart.add(1, 'days').startOf('day');
                            }
                            if (pref.type == 2) {
                                sickDays += Math.ceil(prefTimeTotal / 60.0 / 24.0);
                                fullSickDays += Math.ceil(prefTimeTotalIncludingWeekends / 60.0 / 24.0);
                            }
                            if (pref.type == 3) {
                                holidayAdjustmentDays += Math.ceil(prefTimeTotal / 60.0 / 24.0);
                            }
                            if (pref.type == 6) {
                                nursingVacationDays += Math.ceil(prefTimeTotal / 60.0 / 24.0);
                            }
                            if (pref.type == 7) {
                                educationDays += Math.ceil(prefTimeTotal / 60.0 / 24.0);
                            }
                            if (pref.type == 8) {
                                wageContinuationDays += Math.ceil(prefTimeTotal / 60.0 / 24.0);
                            }
                            if (pref.type == 4 && alwaysWork) {
                                miscDays += Math.ceil(prefTimeTotal / 60.0 / 24.0);
                            }

                        }

                    });
                }


                if (data.sickDays) {
                    let val = sickDays / 1.0;
                    if (val % 1 != 0) {
                        row.push(val.toFixed(2));
                    } else {
                        row.push(val.toFixed(0));
                    }

                    sums['sickDays'] += val;
                    val >= 0 ? sumsPositive['sickDays'] += val : sumsNegative['sickDays'] += val;
                }
                if (data.fullSickDays) {
                    let val = fullSickDays / 1.0;
                    if (val % 1 != 0) {
                        row.push(val.toFixed(2));
                    } else {
                        row.push(val.toFixed(0));
                    }
                    sums['fullSickDays'] += val;
                    val >= 0 ? sumsPositive['fullSickDays'] += val : sumsNegative['fullSickDays'] += val;
                }
                if (data.holidayAdjustmentDays) {
                    let val = holidayAdjustmentDays / 1.0;
                    if (val % 1 != 0) {
                        row.push(val.toFixed(2));
                    } else {
                        row.push(val.toFixed(0));
                    }
                    sums['holidayAdjustmentDays'] += val;
                    val >= 0 ? sumsPositive['holidayAdjustmentDays'] += val : sumsNegative['holidayAdjustmentDays'] += val;
                }
                if (data.wageContinuationDays) {
                    let val = wageContinuationDays / 1.0;
                    if (val % 1 != 0) {
                        row.push(val.toFixed(2));
                    } else {
                        row.push(val.toFixed(0));
                    }
                    sums['wageContinuationDays'] += val;
                    val >= 0 ? sumsPositive['wageContinuationDays'] += val : sumsNegative['wageContinuationDays'] += val;
                }
                if (data.educationDays) {
                    let val = educationDays / 1.0;
                    if (val % 1 != 0) {
                        row.push(val.toFixed(2));
                    } else {
                        row.push(val.toFixed(0));
                    }
                    sums['educationDays'] += val;
                    val >= 0 ? sumsPositive['educationDays'] += val : sumsNegative['educationDays'] += val;
                }
                if (data.nursingVacationDays) {
                    let val = nursingVacationDays / 1.0;
                    if (val % 1 != 0) {
                        row.push(val.toFixed(2));
                    } else {
                        row.push(val.toFixed(0));
                    }
                    sums['nursingVacationDays'] += val;
                    val >= 0 ? sumsPositive['nursingVacationDays'] += val : sumsNegative['nursingVacationDays'] += val;
                }
                if (data.miscDays) {
                    let val = miscDays / 1.0;
                    if (val % 1 != 0) {
                        row.push(val.toFixed(2));
                    } else {
                        row.push(val.toFixed(0));
                    }
                    sums['miscDays'] += val;
                    val >= 0 ? sumsPositive['miscDays'] += val : sumsNegative['miscDays'] += val;
                }


            }


        },
        addPdfReportWeekendWork(row, data, bal, sums, sumsPositive, sumsNegative, csv = false) {

            let plannedWeekendStats;
            let actualWeekendStats;
            if (data.weekendWorkPlanned || data.weekendWorkCountPlanned) {
                plannedWeekendStats = this.calculateRegularEmployeeBonusPayments(bal.employeeId, 3);
            }
            if (data.weekendWorkActual || data.weekendWorkCountActual) {
                actualWeekendStats = this.calculateRegularEmployeeBonusPayments(bal.employeeId, 2);
            }

            if (data.weekendWorkPlanned) {

                let val = plannedWeekendStats.weekendWorkTime;
                let sundayVal = plannedWeekendStats.sundayWorkTime;
                row.push((val / 60.0).toFixed(2) + " " + (csv ? '' : '\n') + "(" + (sundayVal / 60.0).toFixed(2) + " So)");
                sums['weekendWorkPlanned'] += val;
                val >= 0 ? sumsPositive['weekendWorkPlanned'] += val : sumsNegative['weekendWorkPlanned'] += val;


            }
            if (data.weekendWorkActual) {

                let val = actualWeekendStats.weekendWorkTime;
                let sundayVal = actualWeekendStats.sundayWorkTime;
                row.push((val / 60.0).toFixed(2) + " " + (csv ? '' : '\n') + "(" + (sundayVal / 60.0).toFixed(2) + " So)");
                sums['weekendWorkActual'] += val;
                val >= 0 ? sumsPositive['weekendWorkActual'] += val : sumsNegative['weekendWorkActual'] += val;


            }
            if (data.weekendWorkCountPlanned) {

                let val = plannedWeekendStats.weekendWorkCount;
                let sundayVal = plannedWeekendStats.sundayWorkCount;
                row.push((val / 1.0).toFixed(2) + " " + (csv ? '' : '\n') + "(" + (sundayVal / 1.0).toFixed(2) + " So)");
                sums['weekendWorkCountPlanned'] += val;
                val >= 0 ? sumsPositive['weekendWorkCountPlanned'] += val : sumsNegative['weekendWorkCountPlanned'] += val;


            }
            if (data.weekendWorkCountActual) {

                let val = actualWeekendStats.weekendWorkCount;
                let sundayVal = actualWeekendStats.sundayWorkCount;
                row.push((val / 1.0).toFixed(2) + " " + (csv ? '' : '\n') + "(" + (sundayVal / 1.0).toFixed(2) + " So)");
                sums['weekendWorkCountActual'] += val;
                val >= 0 ? sumsPositive['weekendWorkCountActual'] += val : sumsNegative['weekendWorkCountActual'] += val;


            }

        },
        findMainSpot(employeeId, row, data) {
            if (data.mainSpot) {
                let spotId = this.employeeMap[employeeId].spotId;

                let model = '-';

                if (this.spotMap[spotId]) {
                    model = this.spotMap[spotId].name;
                }
                row.push(model);
            }

        },
        findEmploymentModel(employeeId, row, data) {
            if (data.employmentModel) {
                let remoteId = this.employeeMap[employeeId].remoteId;

                let model = '-';

                if (this.employeeEmploymentModelMap[remoteId] && this.employmentModelMap[this.employeeEmploymentModelMap[remoteId].employmentModelId]) {
                    model = this.employmentModelMap[this.employeeEmploymentModelMap[remoteId].employmentModelId].name;
                }
                row.push(model);
            }

        },
        findMainContractType(employeeId, row, data) {
            if (data.contractType) {
                let mainContract = this.getMainContractForEmployeeForCurrentMonth(employeeId);
                let type = '-';

                if (mainContract) {
                    let t = this.uiDataMap.contractTypes.find(ct => ct.id == mainContract.contractType);
                    if (t != null) {
                        type = t.label_de;
                    }
                }
                row.push(type);
            }

        },
        findMainContractWeekTimeModel(employeeId, row, data) {
            if (data.weekTimeModel) {
                let mainContract = this.getMainContractForEmployeeForCurrentMonth(employeeId);
                let model = '-';

                if (mainContract) {
                    model = (mainContract.weekTimeRegular / 60.0).toFixed(2) + 'h ' + (mainContract.additionalMonthWorkTime > 0 ? '+ ' + (mainContract.additionalMonthWorkTime / 60.0) + ' ZS' : '');
                }
                row.push(model);
            }

        },
        generateReportProxy(data, save = true, csv = false) {
            let view = this;
            if (data.employmentModel == true) {
                let remoteIds = Object.values(this.employeeMap).filter(e => e.remoteId != null).map(e => e.remoteId);
                view.$helpers.GetEmployeeEmploymentModelMap(remoteIds, true).then(employeeEmploymentModelMap => {
                    if (data.offSunDaysPerYearPlanned || data.offSunDaysPerYearActual) {
                        let startOfYear = this.currentMonthFromTZ.clone().startOf('year')
                        if (startOfYear.isoWeekday() == 7) {
                            startOfYear = startOfYear.add(-1, 'days').startOf('day');
                        }
                        let qTo = this.currentMonthFromTZ.clone();
                        if (qTo.isoWeekday() == 7) {
                            qTo = qTo.add(1, 'days').startOf('day');
                        }
                        let weekDays = [7];
                        let checkBefore = view.storeSettings.country == 1 ? 0 : null;
                        let checkAfter = view.storeSettings.country == 1 ? 16 * 60 : null;


                        view.$helpers.GetEmployeeSpareWeekDaysStats(startOfYear.format(), qTo.format(), weekDays, checkBefore, checkAfter)
                            .then(sd => {
                                let sdMap = {};
                                sd.forEach(s => {
                                    sdMap[s.employeeId] = s;
                                })
                                data.spareSunDayData = sdMap;
                                view.generateReport(data, save, csv);

                            }).catch(function (error) {
                            console.log(error)
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                        })
                    } else {
                        view.generateReport(data, save, csv);
                    }

                });

            } else if (data.offSunDaysPerYearPlanned || data.offSunDaysPerYearActual) {
                let startOfYear = this.currentMonthFromTZ.clone().startOf('year');
                if (startOfYear.isoWeekday() == 7) {
                    startOfYear = startOfYear.add(-1, 'days').startOf('day');
                }
                let qTo = this.currentMonthFromTZ.clone();
                if (qTo.isoWeekday() == 7) {
                    qTo = qTo.add(1, 'days').startOf('day');
                }
                let weekDays = [7];
                let checkBefore = view.storeSettings.country == 1 ? 0 : null;
                let checkAfter = view.storeSettings.country == 1 ? 16 * 60 : null;


                view.$helpers.GetEmployeeSpareWeekDaysStats(startOfYear.format(), qTo.format(), weekDays, checkBefore, checkAfter)
                    .then(sd => {
                        let sdMap = {};
                        sd.forEach(s => {
                            sdMap[s.employeeId] = s;
                        })
                        data.spareSunDayData = sdMap;
                        view.generateReport(data, save, csv);

                    }).catch(function (error) {
                    console.log(error)
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                })
            } else {
                view.generateReport(data, save, csv);
            }

        },
        generateReport(data, save = true, csv = false) {

            let view = this;
            let headers = [this.$t('pages.employeeData.name')];
            let sums = {};
            let sumsPositive = {};
            let sumsNegative = {};
            if (data.personnelId) {
                headers = ['PN', this.$t('pages.employeeData.name')];

            }
            //IMPORTANT: Order of function calls matters below!!
            this.addPdfReportHeader(headers, data, 'mainSpot', "Stammposition", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'employmentModel', "Beschäftigungsmodell", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'contractType', "Vertragstyp", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'weekTimeModel', "Arbeitszeit" + (csv ? ' ' : '\n') + "Modell", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'workTimeRegular', "Arbeitszeit" + (csv ? ' ' : '\n') + "(Soll)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'prevMonthTime', "Übertrag" + (csv ? ' ' : '\n') + "Vormonat", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'workTime', "Produktive" + (csv ? ' ' : '\n') + "Arbeitszeit", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'unproductiveWorkTime', "Unproduktive" + (csv ? ' ' : '\n') + "Arbeitszeit", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'totalWorkTime', "Gesamte" + (csv ? ' ' : '\n') + "Arbeitszeit", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'unproductiveWorkPercentage', "Unproduktiv" + (csv ? ' ' : '\n') + "Quote", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'sickWorkTime', "Arbeitszeit" + (csv ? ' ' : '\n') + "Krankenstand", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'sickWorkPercentage', "Krankenstand" + (csv ? ' ' : '\n') + "Quote", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'wageContinuationWorkTime', "Arbeitszeit" + (csv ? ' ' : '\n') + "Lohnfortzahlung", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'wageContinuationWorkPercentage', "Lohnfortzahlung" + (csv ? ' ' : '\n') + "Quote", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'educationWorkTime', "Arbeitszeit" + (csv ? ' ' : '\n') + "Ausbildung", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'educationWorkPercentage', "Ausbildung" + (csv ? ' ' : '\n') + "Quote", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'nursingVacationWorkTime', "Arbeitszeit" + (csv ? ' ' : '\n') + "Pflegeurlaub", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'nursingVacationWorkPercentage', "Pflegeurlaub" + (csv ? ' ' : '\n') + "Quote", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'vacationWorkTime', "Arbeitszeit" + (csv ? ' ' : '\n') + "Urlaub", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'vacationWorkPercentage', "Urlaub" + (csv ? ' ' : '\n') + "Quote", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'miscWorkTime', "Arbeitszeit" + (csv ? ' ' : '\n') + "Sonstiges", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'miscWorkPercentage', "Sonstiges" + (csv ? ' ' : '\n') + "Quote", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'paidWorkTime', "Arbeitszeit" + (csv ? ' ' : '\n') + "Modifizierung", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'workTimeBalance', "Arbeitszeit" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'currentMonthWorkTimeBalance', "Arbeitszeit" + (csv ? ' ' : '\n') + "Saldo" + (csv ? ' ' : '\n') + "ohne Vormonat", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'unmodifiedWorkTimeBalance', "Unmodifiziertes" + (csv ? ' ' : '\n') + "Arbeitszeit" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'workTimeBalanceAccPeriod', "Arbeitszeit" + (csv ? ' ' : '\n') + "Saldo" + (csv ? ' ' : '\n') + "(letzte DR)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'vacationTime', "Verbrauchter" + (csv ? ' ' : '\n') + "Urlaub", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'vacationTimeHours', "Verbrauchter" + (csv ? ' ' : '\n') + "Urlaub" + (csv ? ' ' : '\n') + "(in Stunden)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'paidVacationTime', "Urlaub" + (csv ? ' ' : '\n') + "Modifizierung", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'vacationTimeBalance', "Urlaub" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'unmodifiedVacationTimeBalance', "Unmodifiziertes" + (csv ? ' ' : '\n') + "Urlaub" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'vacationTimeBalanceAccPeriod', "Urlaub" + (csv ? ' ' : '\n') + "Saldo" + (csv ? ' ' : '\n') + "(letzte DR)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'holidayTime', "Feiertagszeit", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'paidHolidayTime', "Feiertagszeit" + (csv ? ' ' : '\n') + "Modifizierung", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'holidayAdjustmentWorkTime', "Feiertagausgleich", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'holidayTimeBalance', "Feiertagszeit" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'unmodifiedHolidayTimeBalance', "Unmodifiziertes" + (csv ? ' ' : '\n') + "Feiertagszeit" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'holidayTimeBalanceAccPeriod', "Feiertagszeit" + (csv ? ' ' : '\n') + "Saldo" + (csv ? ' ' : '\n') + "(letzte DR)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'nightWorkTime', "Nachtarbeit", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'nightWorkCount', "Nachtarbeit" + (csv ? ' ' : '\n') + "Anzahl", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'prevMonthNightWorkTime', "Nachtarbeit" + (csv ? ' ' : '\n') + "Vormonat", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'paidNightWorkTime', "Nachtarbeit" + (csv ? ' ' : '\n') + "Modifizierung", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'nightWorkTimeBalance', "Nachtarbeit" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'unmodifiedNightWorkTimeBalance', "Unmodifiziertes" + (csv ? ' ' : '\n') + "Nachtarbeit" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'nightWorkTimeBalanceAccPeriod', "Nachtarbeit" + (csv ? ' ' : '\n') + "Saldo" + (csv ? ' ' : '\n') + "(letzte DR)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'overTime', "Überstunden", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'prevMonthOverTime', "Überstunden" + (csv ? ' ' : '\n') + "Vormonat", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'paidOverTime', "Überstunden" + (csv ? ' ' : '\n') + "Modifizierung", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'overTimeBalance', "Überstunden" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'unmodifiedOverTimeBalance', "Unmodifiziertes" + (csv ? ' ' : '\n') + "Überstunden" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'overTimeBalanceAccPeriod', "Überstunden" + (csv ? ' ' : '\n') + "Saldo" + (csv ? ' ' : '\n') + "(letzte DR)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'moreTime', "Mehrstunden", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'prevMonthMoreTime', "Mehrstunden" + (csv ? ' ' : '\n') + "Vormonat", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'paidMoreTime', "Mehrstunden" + (csv ? ' ' : '\n') + "Modifizierung", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'moreTimeBalance', "Mehrstunden" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'unmodifiedMoreTimeBalance', "Unmodifiziertes" + (csv ? ' ' : '\n') + "Mehrstunden" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'moreTimeBalanceAccPeriod', "Mehrstunden" + (csv ? ' ' : '\n') + "Saldo" + (csv ? ' ' : '\n') + "(letzte DR)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'workTimeAboveThreshold', "Stunden über" + (csv ? ' ' : '\n') + "Grenze (" + (data.workTimeThreshold / 60.0).toFixed(2) + ")", sums, sumsPositive, sumsNegative)


            this.addPdfReportHeader(headers, data, 'bonusTime', "Bonusstunden", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'prevMonthBonusTime', "Bonusstunden" + (csv ? ' ' : '\n') + "Vormonat", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'paidBonusTime', "Bonusstunden" + (csv ? ' ' : '\n') + "Modifizierung", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'bonusTimeBalance', "Bonusstunden" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'unmodifiedBonusTimeBalance', "Unmodifiziertes" + (csv ? ' ' : '\n') + "Bonusstunden" + (csv ? ' ' : '\n') + "Saldo", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'bonusTimeBalanceAccPeriod', "Bonusstunden" + (csv ? ' ' : '\n') + "Saldo" + (csv ? ' ' : '\n') + "(letzte DR)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'comment', "Kommentar", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'fiftypercentpayout', "50% Zuschlag", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'paidfiftypercentpayout', "Ausbez." + (csv ? ' ' : '\n') + "50% Zuschlag", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'fiftypercentpayoutWithoutAccPeriod', "50% Zuschlag" + (csv ? ' ' : '\n') + "ohne DR", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'twentyfivepercentpayout', "25% Zuschlag", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'paidtwentyfivepercentpayout', "Ausbez." + (csv ? ' ' : '\n') + "25% Zuschlag", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'twentyfivepercentpayoutWithoutAccPeriod', "25% Zuschlag" + (csv ? ' ' : '\n') + "ohne DR", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'workDaysPlanned', "Arbeitstage" + (csv ? ' ' : '\n') + "(Soll)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'workDaysActual', "Arbeitstage" + (csv ? ' ' : '\n') + "(Ist)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'sickDays', "Krankenstand" + (csv ? ' ' : '\n') + "Tage", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'fullSickDays', "Krankenstand" + (csv ? ' ' : '\n') + "Tage (Ges.)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'holidayAdjustmentDays', "Feiertagausgleich" + (csv ? ' ' : '\n') + "Tage", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'wageContinuationDays', "Lohnfortzahlung" + (csv ? ' ' : '\n') + "Tage", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'educationDays', "Ausbildung" + (csv ? ' ' : '\n') + "Tage", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'nursingVacationDays', "Pflegeurlaub" + (csv ? ' ' : '\n') + "Tage", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'miscDays', "Sonstige" + (csv ? ' ' : '\n') + "Tage", sums, sumsPositive, sumsNegative)


            this.addPdfReportHeader(headers, data, 'weekendWorkPlanned', "Wochenend" + (csv ? ' ' : '\n') + "Arbeit" + (csv ? ' ' : '\n') + "(Soll)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'weekendWorkActual', "Wochenend" + (csv ? ' ' : '\n') + "Arbeit" + (csv ? ' ' : '\n') + "(Ist)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'weekendWorkCountPlanned', "Wochenend" + (csv ? ' ' : '\n') + "Arbeit" + (csv ? ' ' : '\n') + "Anzahl" + (csv ? ' ' : '\n') + "(Soll)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'weekendWorkCountActual', "Wochenend" + (csv ? ' ' : '\n') + "Arbeit" + (csv ? ' ' : '\n') + "Anzahl" + (csv ? ' ' : '\n') + "(Ist)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'offWorkDaysPlanned', "Freie Tage" + (csv ? ' ' : '\n') + "(Soll)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'offWorkDaysActual', "Freie Tage" + (csv ? ' ' : '\n') + "(Ist)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'offWorkWeekendDaysPlanned', "Freie" + (csv ? ' ' : '\n') + "Wochenendtage" + (csv ? ' ' : '\n') + "(Soll)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'offWorkWeekendDaysActual', "Freie" + (csv ? ' ' : '\n') + "Wochenendtage" + (csv ? ' ' : '\n') + "(Ist)", sums, sumsPositive, sumsNegative)

            this.addPdfReportHeader(headers, data, 'offWorkWeekendsPlanned', "Freie" + (csv ? ' ' : '\n') + "Wochenenden" + (csv ? ' ' : '\n') + "(Soll)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'offWorkWeekendsActual', "Freie" + (csv ? ' ' : '\n') + "Wochenenden" + (csv ? ' ' : '\n') + "(Ist)", sums, sumsPositive, sumsNegative)


            this.addPdfReportHeader(headers, data, 'offSunDaysPerYearPlanned', "Freie" + (csv ? ' ' : '\n') + "Sonntage / Jahr" + (csv ? ' ' : '\n') + "(Soll)", sums, sumsPositive, sumsNegative)
            this.addPdfReportHeader(headers, data, 'offSunDaysPerYearActual', "Freie" + (csv ? ' ' : '\n') + "Sonntage / Jahr" + (csv ? ' ' : '\n') + "(Ist)", sums, sumsPositive, sumsNegative)


            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);
            let partialReport = visibleSpots.length != view.filterDropdownOptions.length;


            let body = [];
            let rows = [];


            let balances = data.balances;
            balances.sort(function (a, b) {
                let ea = view.employeeMap[a.employeeId];
                let eb = view.employeeMap[b.employeeId];

                if (data.sortByPersonnelId) {
                    if (ea != undefined && eb != undefined) {
                        let eaNum = ea.personnelId;
                        let ebNum = eb.personnelId;
                        if (eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null) {
                            eaNum = parseInt(eaNum);
                            ebNum = parseInt(ebNum);
                            if (eaNum < ebNum) return -1;
                            if (eaNum > ebNum) return 1;
                        } else if (eaNum == null || eaNum == undefined) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                } else {
                    if (ea != undefined && eb != undefined) {
                        let aName = ea.lastName + " " + ea.firstName;
                        let bName = eb.lastName + " " + eb.firstName;
                        return aName.toLocaleLowerCase().localeCompare(bName.toLocaleLowerCase());
                    }
                }


                return 0;
            });
            let hmap = this.dataTableState.headerMap;
            let countTotal = 0;
            let countConfirmed = 0;
            for (let i = 0; i < balances.length; i++) {
                countTotal += 1;
                if (balances[i].confirmed) {
                    countConfirmed += 1;
                }

                let bal = balances[i];
                let employee = view.employeeMap[bal.employeeId];
                let pn = employee ? (employee.personnelId ? employee.personnelId : '') : '';
                let cur = [
                    hmap.name != undefined ? hmap.name.DisplayLabel(bal) : '',
                ];
                if (data.personnelId) cur.unshift(pn);
                this.findMainSpot(bal.employeeId, cur, data);
                this.findEmploymentModel(bal.employeeId, cur, data);
                this.findMainContractType(bal.employeeId, cur, data);
                this.findMainContractWeekTimeModel(bal.employeeId, cur, data);
                let mainContract = this.getMainContractForEmployeeForCurrentMonth(bal.employeeId);
                let dayTimeRegular = mainContract ? (mainContract.weekTimeRegular / (mainContract.weekWorkDaysRegular * 60)) : 8;

                this.addPdfReportColumnValue(cur, data, 'workTimeRegular', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'prevMonthTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'workTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'unproductiveWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportAdderColumnValue(cur, data, 'totalWorkTime', ['workTime', 'unproductiveWorkTime'], bal, sums, sumsPositive, sumsNegative, 60)


                this.addPdfReportPercentageValue(cur, data, 'unproductiveWorkPercentage', 'unproductiveWorkTime', ['workTime', 'unproductiveWorkTime'], bal, sums, sumsPositive, sumsNegative, 1)

                this.addPdfReportColumnValue(cur, data, 'sickWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportPercentageValue(cur, data, 'sickWorkPercentage', 'sickWorkTime', ['workTime', 'unproductiveWorkTime'], bal, sums, sumsPositive, sumsNegative, 1)

                this.addPdfReportColumnValue(cur, data, 'wageContinuationWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportPercentageValue(cur, data, 'wageContinuationWorkPercentage', 'wageContinuationWorkTime', ['workTime', 'unproductiveWorkTime'], bal, sums, sumsPositive, sumsNegative, 1)

                this.addPdfReportColumnValue(cur, data, 'educationWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportPercentageValue(cur, data, 'educationWorkPercentage', 'educationWorkTime', ['workTime', 'unproductiveWorkTime'], bal, sums, sumsPositive, sumsNegative, 1)

                this.addPdfReportColumnValue(cur, data, 'nursingVacationWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportPercentageValue(cur, data, 'nursingVacationWorkPercentage', 'nursingVacationWorkTime', ['workTime', 'unproductiveWorkTime'], bal, sums, sumsPositive, sumsNegative, 1)

                this.addPdfReportColumnValue(cur, data, 'vacationWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportPercentageValue(cur, data, 'vacationWorkPercentage', 'vacationWorkTime', ['workTime', 'unproductiveWorkTime'], bal, sums, sumsPositive, sumsNegative, 1)

                this.addPdfReportColumnValue(cur, data, 'miscWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportPercentageValue(cur, data, 'miscWorkPercentage', 'miscWorkTime', ['workTime', 'unproductiveWorkTime'], bal, sums, sumsPositive, sumsNegative, 1)

                this.addPdfReportColumnValue(cur, data, 'paidWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'workTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)
                let prevBalance = this.previousMonthWorkBalanceMap[bal.employeeId] ? this.previousMonthWorkBalanceMap[bal.employeeId].workTimeBalance : 0;

                this.addPdfReportColumnSetValue(cur, data, 'currentMonthWorkTimeBalance', bal.workTimeBalance + bal.paidWorkTime - prevBalance, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportAdderColumnValue(cur, data, 'unmodifiedWorkTimeBalance', ['workTimeBalance', 'paidWorkTime'], bal, sums, sumsPositive, sumsNegative, 60)
                this.addPdfReportLatestAccPeriodValue(cur, data, 'workTimeBalanceAccPeriod', 'workTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)

                this.addPdfReportColumnValue(cur, data, 'vacationTime', bal, sums, sumsPositive, sumsNegative, 60 * 24, true, null, 1, null, true)
                this.addPdfReportColumnValue(cur, data, 'vacationTime', bal, sums, sumsPositive, sumsNegative, 60, true, 24, dayTimeRegular, 'vacationTimeHours')

                this.addPdfReportColumnValue(cur, data, 'paidVacationTime', bal, sums, sumsPositive, sumsNegative, 60 * 24, true)
                this.addPdfReportColumnValue(cur, data, 'vacationTimeBalance', bal, sums, sumsPositive, sumsNegative, 60 * 24, true)
                this.addPdfReportAdderColumnValue(cur, data, 'unmodifiedVacationTimeBalance', ['vacationTimeBalance', 'paidVacationTime'], bal, sums, sumsPositive, sumsNegative, 60 * 24)
                this.addPdfReportLatestAccPeriodValue(cur, data, 'vacationTimeBalanceAccPeriod', 'vacationTimeBalance', bal, sums, sumsPositive, sumsNegative, 60 * 24, true)

                this.addPdfReportColumnValue(cur, data, 'holidayTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'paidHolidayTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'holidayAdjustmentWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)

                this.addPdfReportColumnValue(cur, data, 'holidayTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportAdderColumnValue(cur, data, 'unmodifiedHolidayTimeBalance', ['holidayTimeBalance', 'paidHolidayTime'], bal, sums, sumsPositive, sumsNegative, 60)
                this.addPdfReportLatestAccPeriodValue(cur, data, 'holidayTimeBalanceAccPeriod', 'holidayTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)


                this.addPdfReportColumnValue(cur, data, 'nightWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'nightWorkCount', bal, sums, sumsPositive, sumsNegative, 1, true, null, 1, null, true)
                this.addPdfReportColumnValue(cur, data, 'prevMonthNightWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'paidNightWorkTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'nightWorkTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportAdderColumnValue(cur, data, 'unmodifiedNightWorkTimeBalance', ['nightWorkTimeBalance', 'paidNightWorkTime'], bal, sums, sumsPositive, sumsNegative, 60)
                this.addPdfReportLatestAccPeriodValue(cur, data, 'nightWorkTimeBalanceAccPeriod', 'nightWorkTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)


                this.addPdfReportColumnValue(cur, data, 'overTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'prevMonthOverTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'paidOverTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'overTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportAdderColumnValue(cur, data, 'unmodifiedOverTimeBalance', ['overTimeBalance', 'paidOverTime'], bal, sums, sumsPositive, sumsNegative, 60)
                this.addPdfReportLatestAccPeriodValue(cur, data, 'overTimeBalanceAccPeriod', 'overTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)


                this.addPdfReportColumnValue(cur, data, 'moreTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'prevMonthMoreTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'paidMoreTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'moreTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportAdderColumnValue(cur, data, 'unmodifiedMoreTimeBalance', ['moreTimeBalance', 'paidMoreTime'], bal, sums, sumsPositive, sumsNegative, 60)
                this.addPdfReportLatestAccPeriodValue(cur, data, 'moreTimeBalanceAccPeriod', 'moreTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)

                this.addPdfReportAdderAboveThresholdColumnValue(cur, data, 'workTimeAboveThreshold', ['workTime', 'unproductiveWorkTime'], bal, sums, sumsPositive, sumsNegative, 60, (data.workTimeThreshold != null ? data.workTimeThreshold : 0) * 60)


                this.addPdfReportColumnValue(cur, data, 'bonusTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'prevMonthBonusTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'paidBonusTime', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportColumnValue(cur, data, 'bonusTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)
                this.addPdfReportAdderColumnValue(cur, data, 'unmodifiedBonusTimeBalance', ['bonusTimeBalance', 'paidBonusTime'], bal, sums, sumsPositive, sumsNegative, 60)
                this.addPdfReportLatestAccPeriodValue(cur, data, 'bonusTimeBalanceAccPeriod', 'bonusTimeBalance', bal, sums, sumsPositive, sumsNegative, 60, true)


                this.addPdfReportColumnValue(cur, data, 'comment', bal, sums, sumsPositive, sumsNegative, 60, false)

                this.addPdfReportCalculatedPayouts(cur, data, bal, sums, sumsPositive, sumsNegative, 60)
                this.addPdfReportWorkDays(cur, data, bal, sums, sumsPositive, sumsNegative)
                this.addPdfReportEmployeePrefDays(cur, data, bal, sums, sumsPositive, sumsNegative, mainContract)

                this.addPdfReportWeekendWork(cur, data, bal, sums, sumsPositive, sumsNegative, csv)
                this.addPdfReportOffWorkDays(cur, data, bal, sums, sumsPositive, sumsNegative, csv)


                body.push(cur);
                rows.push(cur);
            }
            let sumRow = ['Summe'];
            let posRow = ['Summe Positiv'];
            let negRow = ['Summe Negativ'];
            if (data.personnelId) {
                sumRow[0] = '';
                posRow[0] = '';
                negRow[0] = '';

                sumRow.unshift('Summe');
                posRow.unshift('Summe Positiv');
                negRow.unshift('Summe Negativ');
            }

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'mainSpot', sums, sumsPositive, sumsNegative, 60, false)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'employmentModel', sums, sumsPositive, sumsNegative, 60, false)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'contractType', sums, sumsPositive, sumsNegative, 60, false)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'weekTimeModel', sums, sumsPositive, sumsNegative, 60, false)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'workTimeRegular', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'prevMonthTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'workTime', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'unproductiveWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'totalWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumPercentage(sumRow, posRow, negRow, data, 'unproductiveWorkPercentage', ['workTime', 'unproductiveWorkTime'], sums, 1, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'sickWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumPercentage(sumRow, posRow, negRow, data, 'sickWorkPercentage', ['workTime', 'unproductiveWorkTime'], sums, 1, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'wageContinuationWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumPercentage(sumRow, posRow, negRow, data, 'wageContinuationWorkPercentage', ['workTime', 'unproductiveWorkTime'], sums, 1, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'educationWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumPercentage(sumRow, posRow, negRow, data, 'educationWorkPercentage', ['workTime', 'unproductiveWorkTime'], sums, 1, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'nursingVacationWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumPercentage(sumRow, posRow, negRow, data, 'nursingVacationWorkPercentage', ['workTime', 'unproductiveWorkTime'], sums, 1, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'vacationWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumPercentage(sumRow, posRow, negRow, data, 'vacationWorkPercentage', ['workTime', 'unproductiveWorkTime'], sums, 1, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'miscWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumPercentage(sumRow, posRow, negRow, data, 'miscWorkPercentage', ['workTime', 'unproductiveWorkTime'], sums, 1, true)


            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'paidWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'workTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'currentMonthWorkTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'unmodifiedWorkTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'workTimeBalanceAccPeriod', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'vacationTime', sums, sumsPositive, sumsNegative, 60 * 24, true, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'vacationTimeHours', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'paidVacationTime', sums, sumsPositive, sumsNegative, 60 * 24, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'vacationTimeBalance', sums, sumsPositive, sumsNegative, 60 * 24, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'unmodifiedVacationTimeBalance', sums, sumsPositive, sumsNegative, 60 * 24, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'vacationTimeBalanceAccPeriod', sums, sumsPositive, sumsNegative, 60 * 24, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'holidayTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'paidHolidayTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'holidayAdjustmentWorkTime', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'holidayTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'unmodifiedHolidayTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'holidayTimeBalanceAccPeriod', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'nightWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'nightWorkCount', sums, sumsPositive, sumsNegative, 1, true, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'prevMonthNightWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'paidNightWorkTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'nightWorkTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'unmodifiedNightWorkTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'nightWorkTimeBalanceAccPeriod', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'overTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'prevMonthOverTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'paidOverTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'overTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'unmodifiedOverTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'overTimeBalanceAccPeriod', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'moreTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'prevMonthMoreTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'paidMoreTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'moreTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'unmodifiedMoreTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'moreTimeBalanceAccPeriod', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'workTimeAboveThreshold', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'bonusTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'prevMonthBonusTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'paidBonusTime', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'bonusTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'unmodifiedBonusTimeBalance', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'bonusTimeBalanceAccPeriod', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'comment', sums, sumsPositive, sumsNegative, 60, false)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'fiftypercentpayout', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'paidfiftypercentpayout', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'fiftypercentpayoutWithoutAccPeriod', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'twentyfivepercentpayout', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'paidtwentyfivepercentpayout', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'twentyfivepercentpayoutWithoutAccPeriod', sums, sumsPositive, sumsNegative, 60, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'workDaysPlanned', sums, sumsPositive, sumsNegative, 1, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'workDaysActual', sums, sumsPositive, sumsNegative, 1, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'sickDays', sums, sumsPositive, sumsNegative, 1, true, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'fullSickDays', sums, sumsPositive, sumsNegative, 1, true, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'holidayAdjustmentDays', sums, sumsPositive, sumsNegative, 1, true, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'wageContinuationDays', sums, sumsPositive, sumsNegative, 1, true, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'educationDays', sums, sumsPositive, sumsNegative, 1, true, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'nursingVacationDays', sums, sumsPositive, sumsNegative, 1, true, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'miscDays', sums, sumsPositive, sumsNegative, 1, true, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'weekendWorkPlanned', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'weekendWorkActual', sums, sumsPositive, sumsNegative, 60, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'weekendWorkCountPlanned', sums, sumsPositive, sumsNegative, 1, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'weekendWorkCountActual', sums, sumsPositive, sumsNegative, 1, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'offWorkDaysPlanned', sums, sumsPositive, sumsNegative, 1, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'offWorkDaysActual', sums, sumsPositive, sumsNegative, 1, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'offWorkWeekendDaysPlanned', sums, sumsPositive, sumsNegative, 1, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'offWorkWeekendDaysActual', sums, sumsPositive, sumsNegative, 1, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'offWorkWeekendsPlanned', sums, sumsPositive, sumsNegative, 1, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'offWorkWeekendsActual', sums, sumsPositive, sumsNegative, 1, true)

            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'offSunDaysPerYearPlanned', sums, sumsPositive, sumsNegative, 1, true)
            this.addPdfReportSumValue(sumRow, posRow, negRow, data, 'offSunDaysPerYearActual', sums, sumsPositive, sumsNegative, 1, true)


            body.push(sumRow);
            body.push(posRow);
            body.push(negRow);

            if (csv) {
                let prefix = this.isBeforeCurrentIRLMonth ? "" : "Entwurf "
                let filename = prefix + 'Monatsabschluss_' + this.currentMonthFrom.format('YYYY-MM') + '.csv';


                let csvPre = "data:text/csv;charset=utf-8,";
                let csv = "";
                console.log(headers)
                console.log(rows);
                csv += headers.join(";");
                csv += "\n";

                for (let i = 0; i < rows.length; i++) {
                    let cur = rows[i];

                    let line = cur.join(";");
                    csv += line;
                    csv += "\n";
                }

                let s = csv.split(".");
                csv = s.join(",");
                let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", filename);
                document.body.appendChild(link); // Required for FF

                link.click();
            } else {
                let prefix = this.isBeforeCurrentIRLMonth ? "" : "Entwurf "
                let filename = prefix + 'Monatsabschluss_' + this.currentMonthFrom.format('YYYY-MM') + '.pdf';
                let repDoc = this.$helpers.tableReportDoc(
                    headers,
                    prefix + 'Monatsabschluss ' + this.currentMonthFrom.format('MMMM YYYY'),
                    this.storeSettings.name + (partialReport ? " Teilbericht" : "") + " - " + data.name + " - " + (countConfirmed < countTotal ? "Nicht vollständig bestätigt" : "Vollständig bestätigt"),
                    this.storeSettings.description,
                    this.userFullname,
                    9);
                let doc = repDoc.doc;
                let contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);

                doc.setProperties({
                    title: "Export Monatsabschluss"
                });

                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                        fillColor: [109, 141, 33],
                        fontSize: 7,
                    },
                    bodyStyles: {
                        fontSize: 7
                    },
                    columnStyles: {},
                    horizontalPageBreak: headers.length > 15,
                    horizontalPageBreakRepeat: 0,
                });

                const pageCount = doc.internal.getNumberOfPages();
                if (pageCount > 0) {
                    let height = doc.internal.pageSize.getHeight();

                    doc.setFontSize(7)
                    let text = 'Monatsabschluss ' + this.currentMonthFrom.format('MMMM YYYY') + ' ' + this.storeSettings.name;

                    for (var i = 1; i <= pageCount; i++) {
                        doc.setPage(i)
                        doc.text(text, 15, height - 10);
                    }
                }


                view.$helpers.previewPdf(doc, filename);
            }

        },
        generateNightWorkTimeReport(balances, save = true, mode = 1) {

            let view = this;
            let headers = [this.$t('pages.employeeData.name'), 'Nachtarbeit (h)', 'Nachtschichten (Anzahl)', 'Nachtzuschlag laut Vertrag (€)', 'Überstunden (h)', 'Überstunden (Anzahl)', 'Überstundenzuschlag laut Vertrag (€)', 'Mehrstunden (h)', 'Wochenend Arbeit (h)', 'Wochenend Arbeit (Anzahl)'];
            if (!view.sortByName) {
                headers = ['PN', this.$t('pages.employeeData.name'), 'Nachtarbeit (h)', 'Nachtschichten (Anzahl)', 'Nachtzuschlag laut Vertrag (€)', 'Überstunden (h)', 'Überstunden (Anzahl)', 'Überstundenzuschlag laut Vertrag (€)', 'Mehrstunden (h)', 'Wochenend Arbeit (h)', 'Wochenend Arbeit (Anzahl)'];
            }
            let sums = ['Gesamt', 0, 0, 0, 0, 0, 0, 0, 0, 0];
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);
            let partialReport = visibleSpots.length != view.filterDropdownOptions.length;
            let modeName = mode == 1 ? this.$t('workBalance.payroll.allShifts') : (mode == 2 ? this.$t('workBalance.payroll.actualShiftsOnly') : this.$t('workBalance.payroll.targetShiftsOnly'))

            let prefix = this.isBeforeCurrentIRLMonth ? "" : "Entwurf "
            let filename = prefix + 'Nacht und Überstunden_' + this.currentMonthFrom.format('YYYY-MM') + '.pdf';
            let body = [];
            let repDoc = this.$helpers.tableReportDoc(
                headers,
                prefix + 'Nacht- und Überstunden ' + this.currentMonthFrom.format('MMMM YYYY'),
                this.storeSettings.name + (partialReport ? " Teilbericht" : "") + " " + modeName,
                this.storeSettings.description,
                this.userFullname,
                9);
            let doc = repDoc.doc;
            let contentOffsetY = repDoc.contentOffsetY;
            doc.setFontSize(12);


            balances.sort(function (a, b) {
                let ea = view.employeeMap[a.employeeId];
                let eb = view.employeeMap[b.employeeId];
                if (view.sortByName) {
                    if (ea != undefined && eb != undefined) {
                        let aName = ea.lastName + " " + ea.firstName;
                        let bName = eb.lastName + " " + eb.firstName;
                        return aName.toLocaleLowerCase().localeCompare(bName.toLocaleLowerCase());
                    }
                } else {
                    if (ea != undefined && eb != undefined) {
                        let eaNum = ea.personnelId;
                        let ebNum = eb.personnelId;
                        if (eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null) {
                            eaNum = parseInt(eaNum);
                            ebNum = parseInt(ebNum);
                            if (eaNum < ebNum) return -1;
                            if (eaNum > ebNum) return 1;
                        } else if (eaNum == null || eaNum == undefined) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                }
                return 0;
            });
            let hmap = this.dataTableState.headerMap;

            for (let i = 0; i < balances.length; i++) {
                let bal = balances[i];
                let bonusStats = this.calculateRegularEmployeeBonusPayments(bal.employeeId, mode);


                let cur = [
                    hmap.name != undefined ? hmap.name.DisplayLabel(bal) : '',
                    (bonusStats.nightWorkTime / 60).toFixed(2),
                    bonusStats.nightWorkCount,
                    ((bonusStats.nightWorkTimePayment + bonusStats.nightWorkCountPayment) / 100).toFixed(2),
                    (bonusStats.overTime / 60).toFixed(2),
                    bonusStats.overTimeCount,
                    ((bonusStats.overTimePayment + bonusStats.overTimeCountPayment) / 100).toFixed(2),

                    (bal.moreTime / 60).toFixed(2),
                    (bonusStats.weekendWorkTime / 60).toFixed(2) + "  \n(" + (bonusStats.sundayWorkTime / 60).toFixed(2) + " So)",
                    bonusStats.weekendWorkCount + "  \n(" + bonusStats.sundayWorkCount + " So)",
                ];
                if (!view.sortByName) cur.unshift(hmap.personnelId != undefined ? hmap.personnelId.DisplayLabel(bal) : '');

                sums[1] += bonusStats.nightWorkTime;
                sums[2] += bonusStats.nightWorkCount;
                sums[3] += ((bonusStats.nightWorkTimePayment + bonusStats.nightWorkCountPayment) / 100);
                sums[4] += bonusStats.overTime;
                sums[5] += bonusStats.overTimeCount;
                sums[6] += ((bonusStats.overTimePayment + bonusStats.overTimeCountPayment) / 100);
                sums[7] += bonusStats.moreTime;
                sums[8] += bonusStats.weekendWorkTime;
                sums[9] += bonusStats.weekendWorkCount;


                body.push(cur);
            }
            if (!view.sortByName) {
                body.push(['', '', '', '', '', '', '', '', '']);
            } else {
                body.push(['', '', '', '', '', '', '', '']);
            }

            sums[1] /= 60;

            sums[4] /= 60;
            sums[7] /= 60;
            sums[8] /= 60;


            for (let i = 1; i < sums.length; i++) sums[i] = sums[i].toFixed(2);

            if (!view.sortByName) {
                sums[0] = '';
                sums.unshift('Gesamt');
            }
            body.push(sums);

            doc.setProperties({
                title: "Export Nacht- und Überstunden"
            });

            doc.autoTable({
                startY: contentOffsetY,
                head: [headers],
                body: body,
                headStyles: {
                    fillColor: [109, 141, 33],
                    fontSize: 7,
                },
                bodyStyles: {
                    fontSize: 7
                },
                columnStyles: {}
            });


            view.$helpers.previewPdf(doc, filename);
        },
        generateBonusPaymentSettingReport(balances, save = true, bonusPaymentSettingsMap, mode = 1) {
            let view = this;
            let headers = ['PN', this.$t('pages.employeeData.name'), 'Stammposition', 'Bonus Name', 'Bonusarbeit (h)', 'Bonusschichten (Anzahl)', 'Bonuszuschlag (€)'];


            let sums = ['Gesamt', '-', '-', '-', 0, 0, 0];
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);
            let partialReport = visibleSpots.length != view.filterDropdownOptions.length;
            let modeName = mode == 1 ? this.$t('workBalance.payroll.allShifts') : (mode == 2 ? this.$t('workBalance.payroll.actualShiftsOnly') : this.$t('workBalance.payroll.targetShiftsOnly'))

            let prefix = this.isBeforeCurrentIRLMonth ? "" : "Entwurf "
            let filename = prefix + 'Bonuszahlungen_' + this.currentMonthFrom.format('YYYY-MM') + '.pdf';
            let body = [];
            let repDoc = this.$helpers.tableReportDoc(
                headers,
                prefix + 'Bonuszahlungen ' + this.currentMonthFrom.format('MMMM YYYY'),
                this.storeSettings.name + (partialReport ? " Teilbericht" : "") + " " + modeName,
                this.storeSettings.description,
                this.userFullname,
                9);
            let doc = repDoc.doc;
            let contentOffsetY = repDoc.contentOffsetY;
            doc.setFontSize(12);


            balances.sort(function (a, b) {
                let ea = view.employeeMap[a.employeeId];
                let eb = view.employeeMap[b.employeeId];
                if (view.sortByName) {
                    if (ea != undefined && eb != undefined) {
                        let aName = ea.lastName + " " + ea.firstName;
                        let bName = eb.lastName + " " + eb.firstName;
                        return aName.toLocaleLowerCase().localeCompare(bName.toLocaleLowerCase());
                    }
                } else {
                    if (ea != undefined && eb != undefined) {
                        let eaNum = ea.personnelId;
                        let ebNum = eb.personnelId;
                        if (eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null) {
                            eaNum = parseInt(eaNum);
                            ebNum = parseInt(ebNum);
                            if (eaNum < ebNum) return -1;
                            if (eaNum > ebNum) return 1;
                        } else if (eaNum == null || eaNum == undefined) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                }
                return 0;
            });
            let hmap = this.dataTableState.headerMap;

            for (let i = 0; i < balances.length; i++) {
                let bal = balances[i];
                let bonusStats = this.calculateCustomEmployeeBonusPayments(bal.employeeId, bonusPaymentSettingsMap, mode);
                let named = false;
                let employee = view.employeeMap[bal.employeeId];
                Object.values(bonusStats).sort((a, b) => a.name.localeCompare(b.name)).forEach(stats => {
                    let name = '';
                    if (!named) {
                        name = hmap.name != undefined ? hmap.name.DisplayLabel(bal) : ''
                        named = true;
                    } else {
                        name = '';
                    }
                    if (stats.count > 0 || stats.time > 0) {
                        let cur = [
                            employee.personnelId ? employee.personnelId : '',
                            name,
                            employee.spotId ? view.spotMap[employee.spotId].name : '',
                            stats.name,
                            (stats.time / 60.0).toFixed(2),
                            stats.count,
                            ((stats.timeBonus + stats.countBonus) / 100).toFixed(2),
                        ];

                        sums[4] += stats.time;
                        sums[5] += stats.count;
                        sums[6] += ((stats.timeBonus + stats.countBonus) / 100);
                        body.push(cur);
                    }

                })

            }
            body.push(['', '', '', '', '', '', '']);


            sums[4] /= 60;

            for (let i = 4; i < sums.length; i++) sums[i] = sums[i].toFixed(2);

            sums[0] = 'Gesamt';


            body.push(sums);

            doc.setProperties({
                title: "Export Bonuszahlungen"
            });

            doc.autoTable({
                startY: contentOffsetY,
                head: [headers],
                body: body,
                headStyles: {
                    fillColor: [109, 141, 33],
                    fontSize: 7,
                },
                bodyStyles: {
                    fontSize: 7
                },
                columnStyles: {}
            });


            view.$helpers.previewPdf(doc, filename);
        },
        generateBonusPaymentSettingReportCSV(balances, includeWorkTime = true, bonusPaymentSettingsMap, mode = 1) {
            let view = this;
            let headers = [this.$t('pages.employeeData.name')];
            
            headers = ['PN', this.$t('pages.employeeData.name'), 'Position'];
            

            Object.values(bonusPaymentSettingsMap).sort((a, b) => a.name.localeCompare(b.name)).forEach(setting => {
                headers.push(setting.name + " Bonus (€)");
                if (includeWorkTime) {
                    headers.push(setting.name + " Stunden (h)")
                }
            })


            let prefix = this.isBeforeCurrentIRLMonth ? "" : "Entwurf "
            let filename = prefix + 'Bonuszahlungen_' + this.currentMonthFrom.format('YYYY-MM') + '.csv';
            let body = [];


            balances.sort(function (a, b) {
                let ea = view.employeeMap[a.employeeId];
                let eb = view.employeeMap[b.employeeId];
                if (view.sortByName) {
                    if (ea != undefined && eb != undefined) {
                        let aName = ea.lastName + " " + ea.firstName;
                        let bName = eb.lastName + " " + eb.firstName;
                        return aName.toLocaleLowerCase().localeCompare(bName.toLocaleLowerCase());
                    }
                } else {
                    if (ea != undefined && eb != undefined) {
                        let eaNum = ea.personnelId;
                        let ebNum = eb.personnelId;
                        if (eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null) {
                            eaNum = parseInt(eaNum);
                            ebNum = parseInt(ebNum);
                            if (eaNum < ebNum) return -1;
                            if (eaNum > ebNum) return 1;
                        } else if (eaNum == null || eaNum == undefined) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                }
                return 0;
            });
            let hmap = this.dataTableState.headerMap;

            for (let i = 0; i < balances.length; i++) {
                let bal = balances[i];
                let employee = view.employeeMap[bal.employeeId];
                let bonusStats = this.calculateCustomEmployeeBonusPayments(bal.employeeId, bonusPaymentSettingsMap, mode);
                let cur = [employee.personnelId ? employee.personnelId : '', hmap.name != undefined ? hmap.name.DisplayLabel(bal) : '', employee.spotId ? view.spotMap[employee.spotId].name : ''];

                Object.values(bonusPaymentSettingsMap).sort((a, b) => a.name.localeCompare(b.name)).forEach(setting => {
                    let stats = bonusStats[setting.id];
                    if (stats != null) {
                        cur.push((stats.timeBonus + stats.countBonus) / 100.0)
                    } else {
                        cur.push(0)
                    }

                    if (includeWorkTime) {
                        if (stats != null) {
                            cur.push((stats.time / 60.0))
                        } else {
                            cur.push(0)
                        }
                    }
                })
                body.push(cur);


            }


            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";
            csv += headers.join(";");
            csv += "\n";

            for (let i = 0; i < body.length; i++) {
                let cur = body[i];

                let line = cur.join(";");
                csv += line;
                csv += "\n";
            }

            let s = csv.split(".");
            csv = s.join(",");
            let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
            let link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
        },
        OpenCSVDataImportPopup() {
            let view = this;
            let description = "";


            let dataEntries = [
                {
                    label: this.$t('global.ui.csvFile'),
                    accept: ".csv",
                    key: 'file',
                    hidden: false,
                    type: 'file',
                    value: null
                },


            ];


            this.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    errorCheck: [
                        (entries) => {
                            if (entries['file'] == null) {
                                return {
                                    key: 'file',
                                    type: 'error',
                                    label: this.$t('global.ui.file'),
                                    text: this.$t('global.ui.pleaseSelectFile')
                                }
                            } else {
                                return null
                            }
                        },
                    ],
                    selectCallback: function (data) {
                        view.parseCSVImport(data.file[0])
                            .then(data => {
                                console.log(data)
                                data.forEach(d => {
                                    if (view.workBalanceMap[d[0]] != null && !view.workBalanceMap[d[0]].confirmed) {
                                        view.dataUpdatedByUser("" + d[1], view.workBalanceMap[d[0]], "workTimeBalance");
                                        view.dataUpdatedByUser("" + d[2], view.workBalanceMap[d[0]], "vacationTimeBalance");
                                        view.dataUpdatedByUser("" + d[3], view.workBalanceMap[d[0]], "holidayTimeBalance");
                                        view.dataUpdatedByUser("" + d[4], view.workBalanceMap[d[0]], "nightWorkTimeBalance");
                                        view.dataUpdatedByUser("" + d[5], view.workBalanceMap[d[0]], "overTimeBalance");
                                        view.dataUpdatedByUser("" + d[6], view.workBalanceMap[d[0]], "moreTimeBalance");
                                        view.dataUpdatedByUser("" + d[7], view.workBalanceMap[d[0]], "bonusTimeBalance");
                                    }

                                })

                            }).catch(function (error) {
                            view.$helpers.error(view.$t('store.settings.importError'), view.$t('workBalance.payroll.importKeyFiguresError'))
                            console.log(error)
                        })
                    }
                },
                header: this.$t('global.ui.csvDataImport'),
                pointerDirection: 1,
                expanded: true,
                centered: true,
            });

        },
        parseCSVImport(file) {
            let view = this;
            return new Promise((resolve, reject) => {
                Papa.parse(file,
                    {
                        delimiter: ";",
                        skipEmptyLines: true,
                        complete: (result, file) => {
                            let convertedResults = [];


                            result.data.forEach(row => {
                                console.log(row)
                                if (row.length >= 2) {

                                    let ewbId = null;
                                    let employee = Object.values(view.employeeMap).find(e => e.personnelId == row[0]);

                                    if (employee != null) {
                                        console.log(view.workBalanceMap)
                                        let ewb = Object.values(view.workBalanceMap).find(e => e.employeeId == employee.id);
                                        if (ewb != null) {
                                            ewbId = ewb.id;
                                        }
                                    }

                                    if (ewbId != null) {
                                        let res = [];
                                        res.push(ewbId);

                                        let val = row[1]; //workTimeBalance
                                        if (val != null) {
                                            val = val.replace(',', '.')
                                        }
                                        val = parseFloat(val);
                                        res.push(isNaN(val) ? 0 : Math.round(val * 60));

                                        if (row.length >= 3) { //vacationTimeBalance
                                            val = row[2];
                                            if (val != null) {
                                                val = val.replace(',', '.')
                                            }
                                            val = parseFloat(val);
                                            res.push(isNaN(val) ? 0 : Math.round(val * 60 * 24));
                                        } else {
                                            res.push(0);
                                        }

                                        if (row.length >= 4) { //holidayWorkTimeBalance
                                            val = row[3];
                                            if (val != null) {
                                                val = val.replace(',', '.')
                                            }
                                            val = parseFloat(val);
                                            res.push(isNaN(val) ? 0 : Math.round(val * 60));
                                        } else {
                                            res.push(0);
                                        }

                                        if (row.length >= 5) { //nightWorkTimeBalance
                                            val = row[4];
                                            if (val != null) {
                                                val = val.replace(',', '.')
                                            }
                                            val = parseFloat(val);
                                            res.push(isNaN(val) ? 0 : Math.round(val * 60));
                                        } else {
                                            res.push(0);
                                        }

                                        if (row.length >= 6) { //overTimeBalance
                                            val = row[5];
                                            if (val != null) {
                                                val = val.replace(',', '.')
                                            }
                                            val = parseFloat(val);
                                            res.push(isNaN(val) ? 0 : Math.round(val * 60));
                                        } else {
                                            res.push(0);
                                        }

                                        if (row.length >= 7) { //moreTimeBalance
                                            val = row[6];
                                            if (val != null) {
                                                val = val.replace(',', '.')
                                            }
                                            val = parseFloat(val);
                                            res.push(isNaN(val) ? 0 : Math.round(val * 60));
                                        } else {
                                            res.push(0);
                                        }

                                        if (row.length >= 8) { //bonusTimeBalance
                                            val = row[7];
                                            if (val != null) {
                                                val = val.replace(',', '.')
                                            }
                                            val = parseFloat(val);
                                            res.push(isNaN(val) ? 0 : Math.round(val * 60));
                                        } else {
                                            res.push(0);
                                        }
                                        console.log(res)
                                        convertedResults.push(res);

                                    }

                                }
                            })


                            resolve(convertedResults);
                        },
                        error: (error, file) => {
                            reject(error);

                        }
                    })
            })

        },
    },

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->

<style scoped>
.tablecontainer {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
}

.has-header > .has-header > .scrollbar-container {
    height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
    top: var(--header-height);
}


.data-table {
    top: 10px;
    position: relative;
}

::-webkit-scrollbar {
    display: none;
}
</style>
